export default {
  th: {
    nodata: "ไม่มีข้อมูล",
    dashboardBonus: {
      bonus_term1:
        "ฝากเงินครั้งแรก $20 รับฟรี $30 \nเทรดและถอนได้โดยไม่มีเงื่อนไข",
      bonus_term2:
        "คุณสามารถเทรดและถอนได้ทันทีโดยไม่มีเงื่อนไข ใดๆทั้งสิ้นโบนัส",
      ckeck_box_bonus: "คุณได้อ่านรายละเอียดและได้ยอมรับเงื่อนไขของบริษัทแล้ว",
      bonus_warning:
        "**โปรดทราบว่าการรับโบนัส $30 สามารถใช้ได้เพียงครั้งเดียวเท่านั้นไม่สามารถเปลี่ยนแปลงได้",
      bonus_warning_2:
        "**หมายเหตุ : การรับโบนัส 30$ จะสามารถใช้ได้สำหรับการฝากเงินในบัญชี STANDARD+ และ Standard เท่านั้น",
    },
    tooltip_currency: "ค่าเงินเป็นเพียงการประมาณจากราคา ณ ปัจจุบัน",
    dashboard: {
      footer:
        "เว็บไซต์นี้ดำเนินงานโดย IUX Markets Global Group ได้รับการกำกับดูแล จากประเทศสิงคโปร์ มีอำนาจในการประกอบธุรกิจจัดการซื้อขายหลักทรัพย์เป็นหลัก พร้อมด้วยใบอนุญาต" +
        "คำเตือนความเสี่ยง: โปรดทราบว่าการซื้อขาย CFDs และการซื้อขายผลิตภัณฑ์สินเชื่ออื่น ๆ มีความเสี่ยงสูง และอาจไม่เหมาะสมสำหรับนักลงทุนทุกราย การซื้อขายตราสารทางการเงินอาจส่งผลให้เกิดการสูญเสียเช่นเดียว กับการได้รับผลกำไร และการสูญเสียนั้นอาจมากกว่าเงินลงทุนเริ่มแรก ก่อนทำธุรกรรมดังกล่าวควรแน่ใจว่าได้เข้าใจถึงความเสี่ยงทั้งหมดแล้ว และควรรับคำแนะนำที่เป็นกลางหากมีความจำเป็น ข้อมูลนี้ไม่ได้ถูกนำมาใช้ หรือมีวัตถุประสงค์เพื่อเผยแพร่หรือใช้โดยผู้ที่อาศัยอยู่ในบางประเทศ/เขตอำนาจศาล โดยรวมถึงแต่ไม่จำกัดเพียง ออสเตรเลีย เบลเยียม ฝรั่งเศส อิหร่าน ญี่ปุ่น เกาหลีเหนือ และสหรัฐอเมริกา บริษัทไม่ได้ให้บริการ แก่ผู้ที่อาศัยอยู่ในบางประเทศ/เขตอำนาจศาล โดยรวมถึงแต่ไม่จำกัดเพียง ออสเตรเลีย เบลเยียม ฝรั่งเศส อิหร่าน ญี่ปุ่น เกาหลีเหนือ และสหรัฐอเมริกา IUX Markets Global Group มีสิทธิ์ในการเปลี่ยนแปลงรายชื่อประเทศด้านบน ตามดุลยพินิจของเราเอง" +
        "©2016 IUX Markets Global Group สงวนสิทธิ์ทุกประการ",
      copyright: "©2016 IUX Markets Global Group สงวนสิทธิ์ทุกประการ",
    },
    dashboardTransactionHistory: {
      filter: {
        month: "เดือน",
        type: "ประเภท",
        status: "สถานะ",
        all: "ทั้งหมด",
      },
      headers: {
        type: "ประเภท",
        time: "เวลา",
        account: "บัญชี",
        method: "วิธีการ",
        localAmount: "จำนวนเงินที่โอน",
        receive: "จำนวนเงินที่ได้รับ",
        status: "สถานะ",
      },
      type: {
        Deposit: "ฝากเงิน",
        Withdraw: "ถอนเงิน",
        Compensation: "ค่าชดเชย",
      },
      status: {
        Accepted: "อนุมัติ",
        Pending: "รอดำเนินการ",
        Rejected: "ปฏิเสธ",
      },
      expand: {
        otherDetails: "รายละเอียดเพิ่มเติม",
        bankAccountDetail: "รายละเอียดบัญชีธนาคาร",
        accountType: "ประเภทบัญชี",
        transactionID: "รหัสธุรกรรม",
        currencyRate: "อัตราแลกเปลี่ยน",
        accountNumber: "เลขบัญชี",
        accountName: "ชื่อบัญชี",
        bankName: "ชื่อธนาคาร",
        proofOfTransfer: "หลักฐานการโอน",
        exportHere: "ส่งออกไฟล์ที่นี่",
      },
    },
    dashboardWallet: {
      no_archive_account: "	คุณไม่มีบัญชีเก็บถาวร	",
      account_detail: "	รายละเอียดบัญชี	",
      recommended: "	แนะนำ	",
      Professional: "	มืออาชีพ	",
      fund: "	ธุรกรรม	",
      reactive: "	ใช้งานอีกครั้ง	",
      only_mt5: `เพิ่มบัญชีเทรด MT5 ได้เท่านั้น`,
      your_account: "เกิดข้อผิดพลาด",
      error_10:
        'ขออภัยท่านไม่สามารถเปิดบัญชีเพิ่มเติมได้ เราจำกัดบัญชีเพิ่มเติมสูงสุดเพียง 6 บัญชี เท่านั้น " โปรดลบบัญชีที่ไม่ใช้งานเพื่อเพิ่มบัญชีใหม่',
      laos_deposit: `กรุณาโอนเงินเป็นสกุลเงินกีบเท่านั้น หากโอนเป็น USD ท่านจะโดนหัก Rate ฝากจากทางธนาคารสูงกว่า Rate ปกติ`,
      your_mt4: "เลขบัญชี MT4 ของคุณ",
      your_mt5: "เลขบัญชี MT5 ของคุณ",
      input_error: "กรุณากรอกข้อมูล",
      rq_account: "กรุณาเลือกบัญชี",
      rq_amount: "กรุณากรอกจำนวนเงิน",
      createAccount: "เพิ่มบัญชีเทรด",
      account: "บัญชี",
      accountType: "ประเภทบัญชี",
      accountBalance: "ยอดเงินคงเหลือ",
      accountCredit: "เครดิต",
      accountBonusRemain: "เครดิตคงเหลือ",
      accountPlatform: "เพลตฟอร์ม",
      accountNumber: "เลขบัญชีเทรด",
      accountLeverage: "เลเวอเรจ",
      accountDemoMoney: "จำนวนเงินทดลอง",
      transferNomore: "ในการโอนเงินคุณต้องเปิดบัญชีการซื้อขายมากกว่า 1 บัญชี",
      myBonus: "โบนัสของฉัน",
      detail: "รายละเอียด",
      deposit: "ฝากเงิน",
      server: "เซิร์ฟเวอร์",
      remainBonus: "โบนัสจำนวนคงเหลือที่สามารถรับได้",
      notAccount:
        "คุณไม่มีบัญชีเทรดที่เปิดใช้งานอยู่ คุณสามารถร้องขอบัญชีโดยคลิกที่ไอคอนด้านขวามือ",
      noVerifyUser: "คุณจะต้องได้รับการยืนยันตัวตนก่อนเพิ่มบัญชี",
      noVerifyBookBank: "คุณจะต้องได้รับการยืนยันตัวตนก่อนจะถอนเงิน",
      bonus: "โบนัส",
      menu: {
        confirm_dialog: {
          title: "คุณต้องการลบบัญชี",
          content: "คุณยืนยันที่จะลบบัญชีนี้ใช่หรือไม่",
        },
        account_edit: "เปลี่ยนรหัสผ่านเทรด",
        investor_edit: "เพิ่มรหัสอินเวสเตอร์",
        account_close: "ปิดบัญชี",
        account_archive: "จัดเก็บบัญชี",
        leverage_edit: "เปลี่ยนเลเวอเรจ",
      },
      tooltip: {
        password:
          "รหัสผ่านต้องประกอบด้วยอักษรภาษาอังกฤษอย่างน้อย 1 ตัวอักษร (A-Z a-z)",
        title: "โบนัสเงินฝาก",
        description:
          "เงื่อนไขโบนัส: คุณจะได้รับโบนัสจำนวนเงินที่เป็นสัดส่วนกับผลรวมที่ฝากโดยมีขีด จำกัด สูงสุดตามที่ระบุ",
      },
      modal: {
        title: "เปิดบัญชีใหม่",
        subTitle:
          "กรุณาเลือกลักษณะเฉพาะของบัญชีที่ใช้งานจริงของคุณ เพื่อความสะดวกในการใช้งาน",
        metatrader: "Metatrader 4",
        accountType: "เปิดบัญชีใหม่",
        accountMoney: "สกุลเงิน",
        accountPassword: "รหัสผ่านการซื้อขาย",
        accountPassword_validate:
          "ความยาวรหัสผ่าน — อย่างน้อย 8 ตัวอักษร และไม่เกิน 15 ตัวอักษร รหัสผ่านจะต้องมีอักขระอย่างน้อย 1 ตัวทั้งตัวพิมพ์ใหญ่และตัวพิมพ์เล็ก อย่างน้อย 1 หลัก และอักขระพิเศษอย่างน้อย 1 ตัว",
        accountConfirmPassword: "ยืนยัน รหัสผ่านการซื้อขาย",
        accountPasswordInvestor: "ตั้งรหัสอินเวสเตอร์",
        accountConfirmPasswordInvestor: "ยืนยันรหัสอินเวสเตอร์",
        code: "กรอกโค้ดที่ได้รับทาง",
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",
        validate: {
          inputFirstName: "",
          inputLastName: "",
          inputPopId: "",
          inputBankAccount: "",
          inputBankAccountName: "",
          inputTel: "",
          inputDate: "",
          inpu: "",
          inputPost: "",
          inputUpload: "",
        },
      },
      error: {
        title: "ยอดเงินที่ต้องการถอนไม่เพียงพอ",
      },
    },
    dashboardInnerTransfer: {
      title: "โอนเงินภายใน",
      tab1: "การโอนเงิน",
      tab2: "ประวัติการโอนเงิน",
      warningTitle: "ประกาศสำคัญ",
      warningSubTitle1:
        "เมื่อวางคำสั่งซื้อขายให้ทราบว่าการโอนภายในสามารถโอนได้สูงถึง 90% ของส่วนของคุณไม่รวมเครดิต",
      warningSubTitle2:
        "สำหรับการโอนภายในระหว่างบัญชีโบนัสไปยังบัญชีโบนัสที่เข้าร่วมโบนัสเครดิตจะโอนตามสัดส่วนตามเปอร์เซ็นต์ยอดคงเหลือที่โอน",
      warningSubTitle3:
        "สำหรับการโอนภายในระหว่างบัญชีโบนัสไปยังบัญชีที่ไม่เข้าร่วมโบนัสโบนัสจะถูกหักออกจากบัญชีที่โอน",
      input1: "จากบัญชี",
      input2: "ไปยังบัญชี",
      input3: "จำนวนเงินที่ต้องการโอน",
      input1Placeholder: "เลือกบัญชีที่ต้องการโอน",
      input2Placeholder: "เลือกบัญชีที่ต้องการรับเงิน",
      input3Placeholder: "จำนวนเงินที่ต้องการโอน",
      confirm: "ยืนยัน",
      confirm_dialog: {
        title: "ยืนยันการโอนเงินของคุณ",
      },
      historyTitle: "ประวัติการโอนเงิน",
      accountNumberTransfer: "เลขบัญชีที่โอน",
      accountNumberIncome: "เลขบัญชีที่รับ",
      amount: "จำนวนเงินที่โอน",
      date: "วันที่",
      error: {
        title_PRO: "การโอนภายในไปยังบัญชี PRO ขั้นต่ำ ",
        title_Raw: "การโอนภายในไปยังบัญชี Raw ขั้นต่ำ ",
        title_min: "การโอนภายในขั้นต่ำ",
      },
    },
    dashboardProgram: {
      title: "แพลตฟอร์ม",
      boxMetatrader4Title: "MetaTrader 4",
      boxMetatrader5Title: "MetaTrader 5",
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle:
        "MetaTrader 4 ได้รับการยกย่องอย่างแพร่หลายว่าเป็นแพลต ฟอร์มการซื้อขาย CFDs ที่นิยมของโลก เพราะมีส่วนติดต่อผู้ใช้ที่ใช้งานง่าย กราฟ และตัวชี้วัดต่างๆ รวมทั้งที่สำคัญที่สุด คือ ภาษา MQL ซึ่งจะช่วยให้ผู้ใช้สามารถตั้งโปรแกรมตัวชี้วัดได้อย่างง่ายดาย และยังมี Expert Advisors (EA หรือ Automated Trading Strategies) อีกด้วย",
      boxMetatrader5SubTitle:
        "MetaTrader 5 ได้รับการยกย่องอย่างแพร่หลายว่าเป็นแพลต ฟอร์มการซื้อขาย CFDs ที่นิยมของโลก เพราะมีส่วนติดต่อผู้ใช้ที่ใช้งานง่าย กราฟ และตัวชี้วัดต่างๆ รวมทั้งที่สำคัญที่สุด คือ ภาษา MQL ซึ่งจะช่วยให้ผู้ใช้สามารถตั้งโปรแกรมตัวชี้วัดได้อย่างง่ายดาย และยังมี Expert Advisors (EA หรือ Automated Trading Strategies) อีกด้วย",
      boxWebtrader4SubTitle:
        "ท่านสามารถใช้งาน IUX Markets  MT4 WebTrader เพื่อทำการเทรดออนไลน์ได้บนบัญชีเดโมและบัญชีเทรดได้ทันที โดยไม่ต้องมีการดาวน์โหลดใด ๆ ฟังก์ชั่นการทำงานเกี่ยวกับการเทรดของ IUX Markets  WebTrader จะสามารถทำงานได้อย่างสมบูรณ์ร่วมกับ MetaTrader 4 ให้ท่านสามารถเปิดและปิดการเทรด, ตั้งจุด stop และจุดเข้าแบบ limit, วางคำสั่งต่าง ๆ, ตั้งค่าและปรับจุด limit และ stop loss, และการปรับกราฟ ได้ด้วยการคลิกเพียงแค่ครั้งเดียว",
      boxWebtrader5SubTitle:
        "ท่านสามารถใช้งาน IUX Markets  MT5 WebTrader เพื่อทำการเทรดออนไลน์ได้บนบัญชีเดโมและบัญชีเทรดได้ทันที โดยไม่ต้องมีการดาวน์โหลดใด ๆ ฟังก์ชั่นการทำงานเกี่ยวกับการเทรดของ IUX Markets  WebTrader จะสามารถทำงานได้อย่างสมบูรณ์ร่วมกับ MetaTrader 4 ให้ท่านสามารถเปิดและปิดการเทรด, ตั้งจุด stop และจุดเข้าแบบ limit, วางคำสั่งต่าง ๆ, ตั้งค่าและปรับจุด limit และ stop loss, และการปรับกราฟ ได้ด้วยการคลิกเพียงแค่ครั้งเดียว",
      boxMobileTitle: "MT4 Mobile App",
      boxMobile5Title: "MT5 Mobile App",
      boxMobileSubTitle:
        "แอพ MT4 ของ IUX สำหรับ iPhone® พร้อมใช้งานสำหรับบัญชีซื้อขายที่ใช้งานจริง โดยดาวน์โหลดได้ฟรีจาก Apple App Store",
      readMore: "เพิ่มเติม",
    },
    dashboardVerify: {
      title: "ยืนยันตัวตน",
    },
    dashboardSwapReturn: {
      title: "เครดิต swap เงินคืน",
      deposit: "ฝากเงิน",
      withdraw: "ถอนเงิน",
      myCredit: "เครดิตวันนี้",
      condition: "เงื่อนไข",
      conditionSeq1:
        "- เครดิต Swap เงินคืนนั้น ได้จากผู้ให้บริการต้องสอดคล่องกับตลาด หรือ Broker โดยตรงเสมอ ",
      conditionSeq2: "- ท่านต้องมีการเทรดต่อเนื่อง อย่างสม่ำเสมอ ",
      conditionSeq3:
        "- ต้องมียอดฝากขั้นต่ำ 50,000 บาทขึ้นไป ท่านถึงจะได้รับเครดิต Swap เงินคืน ",
      conditionSeq4: "- โปรดอ่านและทำความเข้าใจเงื่อนไขให้ถูกต้อง",
    },
    dashboardFund: {
      deposit: "ฝากเงิน",
      withdraw: "ถอนเงิน",
      warning: {
        title:
          "หมายเหตุ: โปรดทราบขณะที่ท่านติดออร์เดอร์การซื้อขาย การถอนเงินจะถอนได้ 90% ของ equity โดยมิได้นำเครดิตมาร่วมด้วย",
        description:
          "แนะนำ: หากต้องการถอนเงินควรจะปิดออเดอร์ที่ค้างอยู่ทั้งหมดก่อน",
      },
      history: "ประวัติ",
      modalVerify: {
        bankAccountTypeLabel: "ประเภทบัญชีธนาคาร",
        bankAccountTypePlaceHolder: "เลือกประเภทบัญชีธนาคาร",
        typeOfBank: {
          currentaccount: "บัญชีกระแสรายวัน",
          savingsaccount: "บัญชีออมทรัพย์",
          ordinaryaccount: "บัญชีปกติ",
        },

        bankBranch: "สาขาธนาคาร ",
        bankBranchPlaceHolder: "สาขาธนาคาร",
        bankBranchRequired: "โปรดใส่สาขาธนาคารให้ถูกต้อง",

        alertVerifyBookBank:
          "ท่านต้องทำการยืนยันบัญชีธนาคารให้เรียบร้อย จึงจะสามารถดำเนินธุรกรรมการถอนเงินได้ โดยท่านสามารถยืนยันบัญชีธนาคารได้โดยกรอกข้อมูลข้างล่างนี้ให้ครบถ้วน",
        alertVerifyUser:
          "ท่านต้องทำการยืนยันตัวตนให้เรียบร้อย จึงจะสามารถเปิดบัญชีเทรดได้ โดยท่านสามารถยืนยันตัวตนได้โดยกรอกข้อมูลข้างล่างนี้ให้ครบถ้วน",
        titleVerifyUser: "ยืนยันตัวตน",
        titleVerifyBookBank: "ยืนยันเลขบัญชี",
        fnameLabel: "ชื่อ",
        fnamePlaceHolder: "ชื่อ (ไทย หรือ อังกฤษ)",
        fnameLabelPlaceHolderJP: "กรุณากรอกชื่อของคุณโดยใช้ตัวอักษรภาษาอังกฤษ",
        lnameLabel: "นามสกุล",
        lnamePlaceHolder: "นามสกุล (ไทย หรือ อังกฤษ)",
        lnameLabelPlaceHolderJP:
          "กรุณากรอกนามสกุลของคุณโดยใช้ตัวอักษรภาษาอังกฤษ",
        popIdLabel: "เลขบัตรประชาชน",
        popIdPlaceHolder: "เลขบัตรประชน",
        warning:
          "* โปรดกรอกข้อมูล ธนาคาร ที่ใช้ในการฝาก-ถอน สำหรับใช้ในบัญชีของคุณ",
        bankLabel: "ธนาคาร",
        bankPlaceHolder: "โปรดเลือกธนาคาร",
        accountNumberLabel: "เลขบัญชีธนาคาร",
        accountNumberPlaceHolder: "เลขบัญชีธนาคาร",

        accountNameLabel: "ผู้ถือบัญชีธนาคาร",
        accountNamePlaceholderJP:
          "กรุณากรอกชื่อเจ้าของบัญชีธนาคารโดยใช้อักขระคาตาคานะ",
        email: "อีเมล",
        tel: "เบอร์โทร",
        birthdayLabel: "วัน เดือน ปี เกิด",
        birthdayPlaceHolder: "กรอก วันเดือนปีเกิด",
        addressLabel: "ที่อยู่",
        addressPlaceHolder: "ที่อยู่",
        provinceLabel: "จังหวัด",
        provincePlaceHolder: "เลือกจังหวัด",
        stateUnionLabel: "	เขตรัฐ/สหภาพ	",
        stateUnionPlaceHolder: "	เลือกอาณาเขตของรัฐ/สหภาพ	",
        stateLabel: "	เขต	",
        statePlaceHolder: "	เลือกรัฐ	",
        municipalityLabel: "	จังหวัด/เทศบาล	",
        municipalityPlaceHolder: "	เลือกจังหวัด/เทศบาล	",
        regionStateLabel: "	ภูมิภาค/รัฐ	",
        regionStatePlaceHolder: "	เลือกภูมิภาค/รัฐ	",
        regionLabel: "	ภูมิภาค	",
        regionPlaceHolder: "	เลือกภูมิภาค	",
        postLabel: "เลขที่ไปรษณีย์",
        postPlaceHolder: "เลขที่ไปรษณีย์",
        jobLabel: "อาชีพ",
        otherLabel: "อื่นๆ (ระบุ)",
        jobPlaceHolder: "เลือกอาชีพ",
        footerText1:
          "กรุณาอัพโหลดรูปบัตรประจำตัวประชาชน โดยแนบไฟล์เพียงส่วนของหน้าบัตรเท่านั้น",
        footerText2: "กรุณาอัพโหลดรูปหน้าบัญชีธนาคาร",
        footerText3:
          "ก่อนดำเนินการต่อด้วยการยืนยันหลักฐานของธนาคาร (POB) เราขอให้คุณตรวจสอบคำแนะนำอย่างละเอียดเพื่อให้มั่นใจว่าการอัปเดตจะเป็นไปอย่างราบรื่นและประสบความสำเร็จ",
        validateFirstName: "กรุณากรอก ชื่อ ของคุณ ให้ถูกต้อง",
        validateLastName: "กรุณากรอก นามสกุล ของคุณ ให้ถูกต้อง",
        validateIdCard: "กรุณากรอก ",
        validateBank: "กรุณากรอก ธนาคารบัญชีธนาคาร ของคุณ ให้ถูกต้อง",
        validateBankAccount: "กรุณากรอก เลขบัญชีธนาคาร ของคุณ ให้ถูกต้อง",
        validateBankName: "กรุณากรอก ชื่อบัญชีธนาคาร ของคุณ ให้ถูกต้อง",
        validatePhone: "กรุณากรอก หมายเลขโทรศัพท์ ของคุณ ให้ถูกต้อง",
        validateBirth: "กรุณากรอก วันเกิด ของคุณ ให้ถูกต้อง",
        validateAddress: "กรุณากรอก ที่อยู่ ของคุณ ให้ถูกต้อง",
        validateProvince: "กรุณากรอก จังหวัด ของคุณ ให้ถูกต้อง",
        validat: "กรุณากรอก จังหวัด ของคุณ ให้ถูกต้อง",
        validatePost: "กรุณากรอก รหัสไปรษณีย์ ของคุณ ให้ถูกต้อง",
        validateCareer: "กรุณากรอก อาชีพ ของคุณ ให้ถูกต้อง",
        validateInput: "กรุณากรอก",
        validatePassword: "กรุณากรอก ข้อมูล ให้ถูกต้อง",
      },

      tabHistory: {
        title: "ธุรกรรมรอดำเนินการ",
        title2: "ธุรกรรมสมบูรณ์",
        tableLabel: {
          transaction: "ธุรกรรม",
          account: "บัญชี",
          amount: "จำนวนเงิน",
          bank: "ธนาคาร",
          status: "สถานะ",
          date: "วันที่",
        },
      },
    },
    dashboardSpread: {
      thematic: "ดัชนี Thematic",
    },
  },
  lo: {
    nodata: "ບໍ່​ມີ​ຂໍ້​ມູນ",
    dashboardBonus: {
      bonus_term1: "ຝາກເງິນຄັ້ງທຳ ອິດ ຮັບຟຣີ 30$ ເທຮດແລະຖອນເງິນ ບໍ່ມີເງື່ອນໄຂ",
      bonus_term2: "ເຈົ້າ​ສາ​ມາດເທຮດແລະຖອນເງິນໄດ້ແບບບໍ່ມີເງື່ອນໄຂ",
      ckeck_box_bonus: "ເຈົ້າໄດ້ອ່ານຂໍ້ ກຳ ນົດແລະລາຍລະອຽດບໍລິສັດແລ້ວ",
      bonus_warning:
        "** ຫມາຍເຫດກະລຸນາ ການຮັບໂບນັດສາມາດໃຊ້ໄດ້ຄັ້ງດຽວເທົ່ານັ້ນບໍ່ສາມາດປ່ຽນແປງໄດ້",
      bonus_warning_2:
        "** ຫມາຍ​ເຫດ​ : ການຮັບໂບນັດ 30$  ສາມາດໃຊ້ກັບບັນຊີ STANDARD+ and Standard ເທົ່ານັ້ນ",
    },
    tooltip_currency: "ມູນຄ່າຂອງສະກຸນເງິນແມ່ນພຽງແຕ່ປະມານຂອງລາຄາໃນປະຈຸບັນ",
    dashboard: {
      footer:
        "ເວບໄຊທ໌ນີ້ແມ່ນ ດຳ ເນີນງານໂດຍ IUX Markets Global Group. ຈາກປະເທດສິງກະໂປມີ ອຳ ນາດໃນການຄຸ້ມຄອງທຸລະກິດດ້ານການຄ້າຫຼັກຊັບຢ່າງຫຼວງຫຼາຍໂດຍມີໃບອະນຸຍາດ" +
        "ຄຳ ເຕືອນກ່ຽວກັບຄວາມສ່ຽງ: ກະລຸນາຮັບຊາບວ່າການຊື້ຂາຍ CFDs ແລະຜະລິດຕະພັນສິນເຊື່ອອື່ນໆກ່ຽວຂ້ອງກັບຄວາມສ່ຽງສູງ. ແລະບໍ່ ເໝາະ ສົມ ສຳ ລັບນັກລົງທືນທຸກການຊື້ຂາຍເຄື່ອງມືການເງິນອາດຈະເຮັດໃຫ້ເກີດການສູນເສຍເຊັ່ນກັນ. ດ້ວຍການໄດ້ຮັບຜົນ ກຳ ໄລແລະການສູນເສຍອາດຈະໃຫຍ່ກວ່າການລົງທືນໃນເບື້ອງຕົ້ນກ່ອນທີ່ຈະ ດຳ ເນີນທຸລະ ກຳ ແບບນີ້, ໃຫ້ແນ່ໃຈວ່າທ່ານເຂົ້າໃຈຄວາມສ່ຽງທັງ ໝົດ. ແລະຄວນໄດ້ຮັບ ຄຳ ແນະ ນຳ ທີ່ບໍ່ມີອະຄະຕິຖ້າ ຈຳ ເປັນຂໍ້ມູນນີ້ບໍ່ຖືກ ນຳ ໃຊ້. ຫລືມີຈຸດປະສົງທີ່ຈະແຈກຢາຍຫລື ນຳ ໃຊ້ໂດຍປະຊາຊົນທີ່ອາໄສຢູ່ໃນບາງປະເທດ / ເຂດ ອຳ ນາດການປົກຄອງລວມທັງແຕ່ບໍ່ ຈຳ ກັດຢູ່ອົດສະຕາລີ, ແບນຊິກ, ຝຣັ່ງ, ອີຣ່ານ, ຍີ່ປຸ່ນ, ເກົາຫຼີ ເໜືອ ແລະສະຫະລັດບໍລິສັດບໍ່ໃຫ້ບໍລິການ. ສຳ ລັບຄົນທີ່ອາໄສຢູ່ໃນບາງປະເທດ / ເຂດ ອຳ ນາດຕັດສິນລວມທັງແຕ່ບໍ່ ຈຳ ກັດອົດສະຕາລີ, ແບນຊິກ, ຝລັ່ງ, ອີຣານ, ຍີ່ປຸ່ນ, ເກົາຫຼີ ເໜືອ ແລະສະຫະລັດອາເມລິກາ, ກຸ່ມ IUX Markets Global ມີສິດທີ່ຈະປ່ຽນບັນຊີລາຍຊື່ຂອງບັນດາປະເທດທີ່ຢູ່ຂ້າງເທິງໂດຍການຕັດສິນໃຈຂອງພວກເຮົາເອງ.",
      copyright: `© 2017 IUX Markets Global Group. All rights reserved.`,
    },
    dashboardTransactionHistory: {
      filter: {
        month: "ເດືອນ",
        type: "ປະເພດ",
        status: "ສະຖານະພາບ",
        all: "ທັງຫມົດ",
      },
      headers: {
        type: "ປະເພດ",
        time: "ເວລາ",
        account: "ບັນຊີ",
        method: "ທາງ",
        localAmount: "ຈໍານວນເງິນທີ່ໂອນເງິນ",
        receive: "ຈໍານວນທີ່ໄດ້ຮັບ",
        status: "ສະຖານະພາບ",
      },
      type: {
        Deposit: "ຝາກເງິນ",
        Withdraw: "ຖົກຖອນ",
        Compensation: "ເງິນຊົດເຊີຍ",
      },
      status: {
        Accepted: "ອະນຸມັດ",
        Pending: "ລໍຖ້າການກະທໍາ",
        Rejected: "ປະຕິເສດ",
      },
      expand: {
        otherDetails: "ລາຍ​ລະ​ອຽດ​ເພີ່ມ​ເຕີມ",
        bankAccountDetail: "ລາຍລະອຽດບັນຊີຂອງທະນາຄານ",
        accountType: "ປະເພດບັນຊີ",
        transactionID: "ການເຮັດທຸລະກໍາ",
        currencyRate: "ອັດ​ຕາ​ແລກ​ປ່ຽນ",
        accountNumber: "ເລກບັນຊີ",
        accountName: "ຊື່​ບັນ​ຊີ",
        bankName: "ຊື່ທະນາຄານ",
        proofOfTransfer: "ການໂອນ",
        exportHere: "ເອກະສານສົ່ງອອກທີ່ນີ້",
      },
    },
    dashboardWallet: {
      no_archive_account: "	ທ່ານບໍ່ມີບັນຊີເກັບຂໍ້ມູນ.	",
      account_detail: "	ລາຍລະອຽດຂອງບັນຊີ	",
      recommended: "	ແນະນໍາ	",
      Professional: "	ມື​ອາ​ຊີບ	",
      fund: "	ໃຊ້ມັນອີກເທື່ອຫນຶ່ງ	",
      reactive: "	Re ເຄື່ອນໄຫວ	",
      only_mt5: `ສາມາດເພີ່ມບັນຊີເທຣດ MT5 ໄດ້ເທົ່ານັ້ນ.`,
      your_account: `Something went wrong`,
      error_10:
        'Sorry for the inconvenience, You cannot open additional accounts. Because the maximum account is limited to 6 accounts only." Please delete some accounts to add new accounts',
      laos_deposit: `ກະລຸນາໂອນເງິນເປັນສະກຸນເງິນກີບເທົ່ານັ້ນ ຖ້າໂອນເປັນໂດລາ ທ່ານຈະຖືກຫັກເງິນຈາກອັດຕາເງິນຝາກທະນາຄານທີ່ສູງກວ່າອັດຕາປົກກະຕິ`,
      your_mt4: "ບັນຊີ MT4 ຂອງທ່ານ",
      your_mt5: "ບັນຊີ MT5 ຂອງທ່ານ",
      input_error: "ກະລຸນາປ້ອນຂໍ້ມູນຢູ່ບ່ອນນີ້",
      rq_account: "ກະລຸນາເລືອກບັນຊີ",
      rq_amount: "ກະລຸນາໃສ່ຈໍານວນ",
      createAccount: "ສ້າງບັນຊີ MT5",
      server: "ເຄື່ອງມື",
      account: "ບັນຊີ",
      accountType: "ປະເພດ",
      accountBalance: "Balance",
      accountCredit: "Credit",
      accountBonusRemain: "Bonus Remain",
      accountPlatform: "Platform",
      accountNumber: "ເລກບັນຊີ",
      accountLeverage: "Leverage",
      accountDemoMoney: "ຈໍາ​ນວນ",
      transferNomore:
        "ເພື່ອໂອນເງິນ, ທ່ານຕ້ອງເປີດບັນຊີການຄ້າທີ່ມີຊີວິດຫຼາຍກ່ວາ 1",
      myBonus: "ໂບນັດຂອງທ່ານ",
      detail: "ລາຍລະອຽດ",
      deposit: "ການຝາກເງິນ",
      remainBonus: "ໂບນັດທີ່ຍັງເຫຼືອ",
      notAccount:
        "ທ່ານຍັງບໍ່ໄດ້ເປີດບັນຊີຊື້ຂາຍເທື່ອ. ທ່ານສາມາດສ້າງບັນຊີໄດ້ໂດຍການກົດປຸ່ມສ້າງບັນຊີ",
      noVerifyUser: "ທ່ານຕ້ອງໄດ້ຮັບການຢັ້ງຢືນຕົວຕົນກ່ອນທີ່ຈະເພີ່ມບັນຊີ.",
      noVerifyBookBank: "ທ່ານຕ້ອງມີການກວດສອບຕົວຕົນກ່ອນທີ່ຈະຖອນເງິນ.",
      bonus: "ໂບນັດ",
      menu: {
        confirm_dialog: {
          title: "ເລກບັນຊີ",
          content: "ທ່ານຢືນຢັນທີ່ຈະລຶບບັນຊີນີ້ບໍ?",
        },
        account_edit: "ປ່ຽນລະຫັດຜ່ານ",
        investor_edit: "ປ່ຽນລະຫັດຜ່ານນັກລົງທືນ",
        account_close: "ລຶບບັນຊີ",
        account_archive: "Archive account",
        leverage_edit: "ປ່ຽນ Leverage",
      },
      tooltip: {
        password: "ລະຫັດຜ່ານຕ້ອງມີ (A-Z a-z) ຢ່າງ ໜ້ອຍ 1 ໂຕອັກສອນ",
        title: "ໂບນັດ IUX Markets ເງິນຝາກ ",
        description:
          "ເງື່ອນໄຂໂບນັດ: ທ່ານຈະໄດ້ຮັບຈໍານວນເງິນໂບນັດທີ່ມີອັດຕາສ່ວນກັບຜົນລວມທີ່ຝາກໄວ້, ມີຂີດຈໍາກັດສູງສຸດຕາມທີ່ລະບຸ",
      },
      modal: {
        title: "ເປີດບັນຊີ ໃໝ່",
        subTitle:
          "ກະລຸນາເລືອກຄຸນລັກສະນະຂອງບັນຊີຕົວຈິງຂອງທ່ານ. ເພື່ອຄວາມສະດວກໃນການ ນຳ ໃຊ້",
        metatrader: "Metatrader 4",
        accountType: "Type",
        accountMoney: "Currency",
        accountPassword: "ລະຫັດຜ່ານ",
        accountPassword_validate:
          "ລະຫັດຜ່ານຕ້ອງມີຄວາມຍາວ — ຢ່າງຫນ້ອຍ 8 ຕົວອັກສອນ, ສູງສຸດ 15 ຕົວອັກສອນ. ລະຫັດຜ່ານຕ້ອງປະກອບດ້ວຍຕົວອັກສອນໃຫຍ່ແລະຕົວອັກສອນຍ່ອຍຢ່າງຫນ້ອຍ 1 ຕົວ, ຢ່າງຫນ້ອຍ 1 ຕົວເລກ, ແລະຢ່າງຫນ້ອຍ 1 ຕົວອັກສອນພິເສດ.",

        accountConfirmPassword: "ຢືນ​ຢັນ​ລະ​ຫັດຜ່ານ",
        accountPasswordInvestor: "ລະຫັດຜ່ານຜູ້ຊົມ",
        accountConfirmPasswordInvestor: "ຢືນ​ຢັນ​ລະ​ຫັດຜ່ານຜູ້ຊົມ",
        code: "ລະຫັດຈາກ",
        confirm: "ຢືນຢັນ",
        cancel: "ຍົກເລີກ",
        validate: {
          inputFirstName: "",
          inputLastName: "",
          inputPopId: "",
          inputBankAccount: "",
          inputBankAccountName: "",
          inputTel: "",
          inputDate: "",
          inpu: "",
          inputPost: "",
          inputUpload: "",
        },
      },
      error: {
        title: "ຈຳນວນເງິນທີ່ທ່ານຕ້ອງການຖອນແມ່ນບໍ່ພຽງພໍ.",
      },
    },
    dashboardInnerTransfer: {
      title: "ການໂອນພາຍໃນ",
      tab1: "ປະຫວັດ",
      tab2: "ປະຫວັດ",
      warningTitle: "ແຈ້ງການສໍາຄັນ",
      warningSubTitle1:
        "ໃນເວລາທີ່ວາງຄໍາສັ່ງຊື້ຂາຍ, ໃຫ້ລະວັງວ່າການໂອນຍ້າຍພາຍໃນສາມາດໂອນໄດ້ເຖິງ 90% ຂອງຮຸ້ນຂອງທ່ານ, ຍົກເວັ້ນການປ່ອຍສິນເຊື່ອ.",
      warningSubTitle2:
        "ສໍາລັບການໂອນເງິນພາຍໃນລະຫວ່າງບັນຊີເງິນໂບນັດໃນບັນຊີໂບນັດທີ່ເຂົ້າຮ່ວມໂບນັດ, ເງິນທີ່ມີຊື່ສຽງຈະໂອນໃຫ້ເປັນເປີເຊັນທີ່ຖືກໂອນ.",
      warningSubTitle3:
        "ສໍາລັບການໂອນເຂົ້າພາຍໃນລະຫວ່າງບັນຊີ Bonus ເພື່ອບັນຊີທີ່ບໍ່ເຂົ້າຮ່ວມໂບນັດ, ເງິນໂບນັດຈະຖືກຫັກອອກຈາກບັນຊີ.",
      input1: "ຈາກ",
      input2: "ເຖິງ",
      input3: "ຈໍາ​ນວນ",
      input1Placeholder: "ເລືອກບັນຊີ",
      input2Placeholder: "ເລືອກບັນຊີຈາກ",
      input3Placeholder: "ຈໍາ​ນວນ",
      confirm: "ຢືນຢັນ",
      confirm_dialog: {
        title: "ການຢັ້ງຢືນ",
      },
      historyTitle: "ເຮັດທຸລະກໍາ",
      accountNumberTransfer: "ຈາກບັນຊີ",
      accountNumberIncome: "ຖືງບັນຊີ",
      amount: "ຈໍາ​ນວນ",
      date: "ວັນທີ",
      error: {
        title_PRO: "ເຂົ້າໃນບັນຊີ PRO.ການໂອນເງິນຂັ້ນຕ່ ຳ ",
        title_Raw: "ເຂົ້າໃນບັນຊີ Raw.ການໂອນເງິນຂັ້ນຕ່  ",
        title_min: "ການໂອນເງິນຂັ້ນຕ່",
      },
    },
    dashboardProgram: {
      title: "ເຄື່ອງມືເທຮດ",
      boxMetatrader4Title: "MetaTrader 4",
      boxMetatrader5Title: "MetaTrader 5",
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle:
        "MetaTrader 4 ແມ່ນຖືວ່າເປັນແພລະຕະຟອມ. ຮູບແບບການຊື້ຂາຍ CFDs ທີ່ນິຍົມທີ່ສຸດໃນໂລກເພາະວ່າມັນມີອິນເຕີເຟດຜູ້ໃຊ້ງ່າຍ, ກຣາຟແລະຕົວຊີ້ວັດລວມທັງສິ່ງທີ່ ສຳ ຄັນທີ່ສຸດແມ່ນພາສາ MQL, ເຊິ່ງຊ່ວຍໃຫ້ຜູ້ໃຊ້ສາມາດດັດສະນີໂປແກຼມໄດ້ງ່າຍແລະຍັງປະກອບມີທີ່ປຶກສາຊ່ຽວຊານ (EA ຫຼືອັດຕະໂນມັດ)",
      boxMetatrader5SubTitle:
        "MetaTrader 5 ແມ່ນຖືວ່າເປັນແພລະຕະຟອມ. ຮູບແບບການຊື້ຂາຍ CFDs ທີ່ນິຍົມທີ່ສຸດໃນໂລກເພາະວ່າມັນມີອິນເຕີເຟດຜູ້ໃຊ້ງ່າຍ, ກຣາຟແລະຕົວຊີ້ວັດລວມທັງສິ່ງທີ່ ສຳ ຄັນທີ່ສຸດແມ່ນພາສາ MQL, ເຊິ່ງຊ່ວຍໃຫ້ຜູ້ໃຊ້ສາມາດດັດສະນີໂປແກຼມໄດ້ງ່າຍແລະຍັງປະກອບມີທີ່ປຶກສາຊ່ຽວຊານ (EA ຫຼືອັດຕະໂນມັດ)",
      boxWebtrader4SubTitle:
        "ท่านสามารถใช้งาน IUX Markets  MT4 WebTrader เพื่อทำการเทรดออนไลน์ได้บนบัญชีเดโมและบัญชีเทรดได้ทันที โดยไม่ต้องมีการดาวน์โหลดใด ๆ ฟังก์ชั่นการทำงานเกี่ยวกับการเทรดของ IUX Markets  WebTrader จะสามารถทำงานได้อย่างสมบูรณ์ร่วมกับ MetaTrader 4 ให้ท่านสามารถเปิดและปิดการเทรด, ตั้งจุด stop และจุดเข้าแบบ limit, วางคำสั่งต่าง ๆ, ตั้งค่าและปรับจุด limit และ stop loss, และการปรับกราฟ ได้ด้วยการคลิกเพียงแค่ครั้งเดียว",
      boxWebtrader5SubTitle:
        "ท่านสามารถใช้งาน IUX Markets  MT5 WebTrader เพื่อทำการเทรดออนไลน์ได้บนบัญชีเดโมและบัญชีเทรดได้ทันที โดยไม่ต้องมีการดาวน์โหลดใด ๆ ฟังก์ชั่นการทำงานเกี่ยวกับการเทรดของ IUX Markets  WebTrader จะสามารถทำงานได้อย่างสมบูรณ์ร่วมกับ MetaTrader 4 ให้ท่านสามารถเปิดและปิดการเทรด, ตั้งจุด stop และจุดเข้าแบบ limit, วางคำสั่งต่าง ๆ, ตั้งค่าและปรับจุด limit และ stop loss, และการปรับกราฟ ได้ด้วยการคลิกเพียงแค่ครั้งเดียว",
      boxMobileTitle: "MT4 Mobile App",
      boxMobile5Title: "MT5 Mobile App",
      boxMobileSubTitle:
        "The IUX MT4 app for iPhone® is ready for a live trading account. By downloading it free from the Apple App Store",
      readMore: "More",
    },
    dashboardVerify: {
      title: "ຢັ້ງຢືນ",
    },
    dashboardSwapReturn: {
      title: "ແລກປ່ຽນສິນເຊື່ອຄືນ",
      deposit: "ຝາກເງິນ",
      withdraw: "ຖອນເງິນ",
      myCredit: "Creditຂອງຂ້ອຍ",
      condition: "เงื่อนไข",
      conditionSeq1:
        "- ເຄດິດແລກປ່ຽນເງິນຕາທີ່ສາມາດຈ່າຍຄືນໄດ້ໂດຍຜູ້ໃຫ້ບໍລິການຕ້ອງຕິດຕໍ່ໂດຍກົງກັບຕະຫຼາດຫຼືນາຍ ໜ້າ.",
      conditionSeq2: "- ທ່ານຕ້ອງມີການຊື້ຂາຍຢ່າງຕໍ່ເນື່ອງ. ປົກກະຕິແລ້ວ",
      conditionSeq3:
        "- ຕ້ອງມີເງິນຝາກຂັ້ນຕ່ ຳ 50.000 ບາດຫຼືຫຼາຍກວ່ານັ້ນເພື່ອຈະໄດ້ຮັບສິນເຊື່ອ Swap Swap",
      conditionSeq4: "- ກະລຸນາອ່ານແລະເຂົ້າໃຈເງື່ອນໄຂຢ່າງຖືກຕ້ອງ",
    },
    dashboardFund: {
      deposit: "ຝາກເງິນ",
      withdraw: "ຖອນເງິນ",
      warning: {
        title:
          "ໝາຍ ເຫດ: ຖ້າຈະຖອນເງິນໃນກໍລະນີເປີດ ຄຳ ສັ່ງທີ່ຍັງຄ້າງຢູ່ທ່ານຈະສາມາດຖອນໄດ້ພຽງ 90% ຂອງຍອດເງິນທີ່ມີຢູ່ຂອງທ່ານ.(Orders that are not included, include, stop, sell, stop, limit, sell)",
        description: "ແນະ ນຳ: ຖ້າຈະຖອນເງິນ, ທຸກ ຄຳ ສັ່ງທີ່ຍັງຄ້າງຄວນຈະປິດກ່ອນ",
      },
      history: "ເຮັດທຸລະກໍາ",
      modalVerify: {
        bankAccountTypeLabel: "ປະເພດບັນຊີທະນາຄານ",
        bankAccountTypePlaceHolder: "ເລືອກປະເພດບັນຊີທະນາຄານ",
        typeOfBank: {
          currentaccount: "ບັນຊີກະແສລາຍວັນ",
          savingsaccount: "ບັນ​ຊີ​ເງິນ​ຝາກ​ປະ​ຢັດ",
          ordinaryaccount: "ບັນຊີປົກກະຕິ",
        },
        bankBranch: "ສາຂາວິຊານທາງລະບົບ",
        bankBranchPlaceHolder: "ສາຂາວິຊານ",
        bankBranchRequired: "ກະລຸນາໃສ່ສາຂາວິຊານການເລີຍ",

        alertVerifyBookBank:
          "ທ່ານຕ້ອງຢືນຢັນບັນຊີທະນາຄານຂອງທ່ານ. ເພື່ອໃຫ້ສາມາດ ດຳ ເນີນການຖອນເງິນທ່ານສາມາດຢືນຢັນບັນຊີທະນາຄານຂອງທ່ານໂດຍການຕື່ມຂໍ້ມູນທີ່ຄົບຖ້ວນຢູ່ດ້ານລຸ່ມ",
        alertVerifyUser:
          "ທ່ານຕ້ອງຢືນຢັນຕົວຕົນຂອງທ່ານເພື່ອຈະສາມາດຍອມຮັບການເທຮດ ທ່ານສາມາດກວດສອບຕົວຕົນຂອງທ່ານໂດຍການຕື່ມຂໍ້ມູນຂ້າງລຸ່ມນີ້",
        titleVerifyUser: "ຢືນຢັນຜູ້ໃຊ້",
        titleVerifyBookBank: "ດຽວນີ້ ເຈົ້າ ໜ້າ ທີ່ ກຳ ລັງກວດສອບຢູ່",
        fnameLabel: "ຊື່​ແທ້",
        fnamePlaceHolder: "ຊື່​ແທ້",
        fnameLabelPlaceHolderJP:
          "ກະລຸນາໃສ່ຊື່ຂອງທ່ານໂດຍໃຊ້ຕົວອັກສອນພາສາອັງກິດ.",
        lnameLabel: "ນາມ​ສະ​ກຸນ",
        lnamePlaceHolder: "ນາມ​ສະ​ກຸນ",
        lnameLabelPlaceHolderJP:
          "ກະລຸນາໃສ່ນາມສະກຸນຂອງທ່ານໂດຍໃຊ້ຕົວອັກສອນພາສາອັງກິດ.",
        popIdLabel: "ເລກບັດປະ ຈຳ ຕົວ",
        popIdPlaceHolder: "ເລກບັດປະ ຈຳ ຕົວ",
        warning:
          "* ກະລຸນາໃສ່ຂໍ້ມູນຂອງທະນາຄານທີ່ໃຊ້ໃນການຝາກ - ຖອນ. ສຳ ລັບໃຊ້ໃນບັນຊີຂອງທ່ານ",
        bankLabel: "ທະນາຄານ",
        bankPlaceHolder: "ທະນາຄານ",
        accountNumberLabel: "ເລກບັນຊີທະນາຄານ",
        accountNumberPlaceHolder: "ເລກບັນຊີທະນາຄານ",

        accountNameLabel: "ຊື່ຜູ້ຖືບັນຊີທະນາຄານ",
        accountNamePlaceholderJP:
          "ກະລຸນາໃສ່ຊື່ເຈົ້າຂອງບັນຊີທະນາຄານໂດຍໃຊ້ຕົວອັກສອນ Katakana.",
        email: "Email",
        tel: "ໂທ",
        birthdayLabel: "ວັນ​ເດືອນ​ປີ​ເກີດ",
        birthdayPlaceHolder: "ວັນ​ເດືອນ​ປີ​ເກີດ",
        addressLabel: "ທີ່ຢູ່",
        addressPlaceHolder: "ທີ່ຢູ່",
        provinceLabel: "ແຂວງ",
        provincePlaceHolder: "ແຂວງ",
        stateUnionLabel: "	ອານາເຂດຂອງລັດ / Union	",
        stateUnionPlaceHolder: "	ເລືອກເຂດແດນຂອງລັດ / Union	",
        stateLabel: "	ລັດ	",
        statePlaceHolder: "	ເລືອກລັດ	",
        municipalityLabel: "	ແຂວງ / ເທດສະບານ	",
        municipalityPlaceHolder: "	ເລືອກແຂວງ / ເທດສະບານ	",
        regionStateLabel: "	ພາກພື້ນ / ລັດ	",
        regionStatePlaceHolder: "	ເລືອກພາກພື້ນ / ລັດ	",
        regionLabel: "	ພາກພື້ນ	",
        regionPlaceHolder: "	ເລືອກພາກພື້ນ	",
        postLabel: "ລະ​ຫັດ​ໄປ​ສະ​ນີ",
        postPlaceHolder: "ລະ​ຫັດ​ໄປ​ສະ​ນີ",
        jobLabel: "ອາຊີບ",
        otherLabel: "ອື່ນໆ (ລະບຸ)",
        jobPlaceHolder: "ເລືອກອາຊີບ",
        footerText1:
          "ກະ​ລຸ​ນາ​ອັບ​ໂຫຼດ​ຮູບ​ແທນ​ຕົວ​ຂອງ​ທ່ານ​ໂດຍ​ການ​ຕິດ​ຮູບ​ພາບ​ຂອງ​ຫນ້າ​ຂອງ​ບັດ​ເທົ່າ​ນັ້ນ​",
        footerText2: "ກະລຸນາອັບໂຫລດຮູບພາບບັນຊີທະນາຄານ",
        footerText3:
          "ກ່ອນທີ່ຈະໄດ້ຈັດລອງການຢືນຢັນຂໍ້ມູນທະນາຄານ (POB) ພວກເຮົາເອົາຢ່າງດີໂດຍກົງໄປວ່າເພີ່ມຂໍ້ມູນເຂົ້າພັກໄດ້ແລະເລີຍເຊີນສະຫຼຸບການປັບປຸງຮຽບຮ້ອຍທາງດີໂດຍແນະນຳບຸກຄົນທີ່ຄອບຄຸມດ້ວຍມານີ້.",
        validateFirstName: "ກະລຸນາໃສ່ຊື່ ທຳ ອິດ. ທີ່ຖືກຕ້ອງ.",
        validateLastName: "ກະລຸນາປ້ອນນາມສະກຸນ , ທີ່ຖືກຕ້ອງ.",
        validateIdCard: "ກະລຸນາປ້ອນລະຫັດ",
        validateBank: "ກະລຸນາໃສ່ຊື່ຂອງທະນາຄານ.  ທີ່ຖືກຕ້ອງ.",
        validateBankAccount: "ກະລຸນາໃສ່ບັນຊີທະນາຄານ  ທີ່ຖືກຕ້ອງ.",
        validateBankName: "ກະລຸນາໃສ່ຊື່ຂອງທະນາຄານ. ທີ່ຖືກຕ້ອງ.",
        validatePhone: "ກະລຸນາໃສ່ເບີໂທລະສັບເຂົ້າ. ທີ່ຖືກຕ້ອງ.",
        validateBirth: "ກະລຸນາໃສ່ວັນເດືອນປີເກີດ. ທີ່ຖືກຕ້ອງ.",
        validateAddress: "ກະລຸນາໃສ່ທີ່ຢູ່ ທີ່ຖືກຕ້ອງ",
        validateProvince: `ກະລຸນາໃສ່ແຂວງ ທີ່ຖືກຕ້ອງ`,
        validat: "ກະລຸນາໃສ່ແຂວງ ທີ່ຖືກຕ້ອງ",
        validatePost: "ກະລຸນາໃສ່ລະ​ຫັດ​ໄປ​ສະ​ນີ",
        validateCareer: "ກະລຸນາໃສ່ອາຊີບ ທີ່ຖືກຕ້ອງ",
        validateInput: "ກະລຸນາປ້ອນ",
        validatePassword: "ຂໍ້ມູນບໍ່ຖືກຕ້ອງ.",
      },

      tabHistory: {
        title: "ການເຮັດທຸລະກຳທີ່ຍັງຄ້າງຢູ່",
        title2: "ການເຮັດທຸລະກຳສຳເລັດ",
        tableLabel: {
          transaction: "ການເຮັດທຸລະ ກຳ",
          account: "ບັນຊີ",
          amount: "ຈໍາ​ນວນ",
          bank: "ທະນາຄານ",
          status: "ສະຖານະ",
          date: "ວັນທີ",
        },
      },
    },
    dashboardSpread: {
      thematic: "Thematic Indices",
    },
  },
  en: {
    nodata: "No Data",
    dashboardBonus: {
      bonus_term1:
        "Make your first deposit 20 $, get free $30, trade and withdraw unconditionally.",
      bonus_term2:
        "You can trade and withdraw immediately without any conditions.",
      ckeck_box_bonus:
        "You have read the details and agree to the terms of the company.",
      bonus_warning:
        "** Please note that the 30 $ bonus can be used only once and cannot be changed.",
      bonus_warning_2:
        "** Note : $30 Bonus for deposit to STANDARD+ and Standard account only",
    },
    tooltip_currency:
      "The value of the currency is only an approximation of the current price.",
    dashboard: {
      footer:
        "This website is operated by IUX Markets Global Group. From Singapore Has the power to mainly manage the securities trading business With a license" +
        "                Risk Warning: Please note that trading CFDs and other credit products involves high risks. And not suitable for all investors Trading financial instruments may result in loss as well. With receiving profits And the loss may be greater than the initial investment Before making such a transaction, be sure to understand all risks. And should receive unbiased advice if needed This information is not used. Or intended to be distributed or used by people residing in certain countries / jurisdictions Including but not limited to Australia, Belgium, France, Iran, Japan, North Korea and the United States The company does not provide services. To people residing in certain countries / jurisdictions Including but not limited to Australia, Belgium, France, Iran, Japan, North Korea and the United States, IUX Markets Global Group has the right to change the list of countries above At our own discretion. ",
      copyright: "© 2016 IUX Markets Global Group. All rights reserved.",
    },
    dashboardTransactionHistory: {
      filter: {
        month: "Month",
        type: "Type",
        status: "Status",
        all: "All",
      },
      headers: {
        type: "Type",
        time: "Time",
        account: "Account",
        method: "Method",
        localAmount: "Local Amount",
        receive: "Recieve",
        status: "Status",
      },
      type: {
        Deposit: "Deposit",
        Withdraw: "Withdraw",
        Compensation: "Compensation",
      },
      status: {
        Accepted: "Accepted",
        Pending: "Pending",
        Rejected: "Rejected",
      },
      expand: {
        otherDetails: "Other Detail",
        bankAccountDetail: "Bank Account Detail",
        accountType: "Account Type",
        transactionID: "Transaction ID",
        currencyRate: "Currency Rate",
        accountNumber: "Account Number",
        accountName: "Account Name",
        bankName: "Bank Name",
        proofOfTransfer: "Proof of transfer",
        exportHere: "Export Here",
      },
    },
    dashboardWallet: {
      no_archive_account: "	You do not have an archive account.	",
      account_detail: "	Account Detail	",
      recommended: "	Recommended	",
      Professional: "	Professional	",
      fund: "	Fund	",
      reactive: "	ReActive	",
      only_mt5: `Only MT5 trading accounts can be added.`,
      your_account: `Something went wrong`,
      error_10:
        'Sorry for the inconvenience, You cannot open additional accounts. Because the maximum account is limited to 6 accounts only." Please delete some accounts to add new accounts',
      laos_deposit: `Please transfer money in kip currency only, if transfer in USD, you will be deducted from the bank deposit rate higher than normal rate`,
      your_mt4: "Your MT4 Account",
      your_mt5: "Your MT5 Account",
      input_error: "Please enter value",
      rq_account: "Please choose account",
      rq_amount: "Please enter amount",
      createAccount: "Create trading account",
      server: "Platform",
      account: "My Account",
      accountType: "Account Type",
      accountBalance: "Balance",
      accountCredit: "Credit",
      accountBonusRemain: "Bonus Remain",
      accountPlatform: "Platform",
      accountNumber: "Account No.",
      accountLeverage: "Leverage",
      accountDemoMoney: "Amount",
      transferNomore:
        "In order to transfer funds, you have to open more than 1 live trading account",
      myBonus: "My Bonus",
      detail: "Detail",
      deposit: "Deposit",
      remainBonus: "Remaining bonus",
      notAccount: "You don’t have any accounts",
      noVerifyUser:
        "You must receive identity verification before adding an account.",
      noVerifyBookBank:
        "You must have identity verification before withdrawing money.",
      bonus: "Bonus",
      menu: {
        confirm_dialog: {
          title: "Account number",
          content: "Do you confirm to delete this account?",
        },
        account_edit: "Change Password",
        investor_edit: "Create Password Investor",
        account_close: "Delete Account",
        account_archive: "Archive Account",
        leverage_edit: "Change Leverage",
      },
      tooltip: {
        password: "password must contain (A-Z a-z) at least 1 charactor",
        title: "Bonus Deposit",
        description:
          "Bonus condition: You will receive a bonus amount that is proportional to the deposited sum, with a maximum limit as specified",
      },
      modal: {
        title: "Open a New Account",
        subTitle:
          "Please choose the characteristics of your actual account. For ease of use",
        metatrader: "Metatrader 4",
        accountType: "Type",
        accountMoney: "Currency",
        accountPassword: "Trading Password",
        accountPassword_validate:
          "Password length — Minimum 8 characters, maximum 15 characters. Password must contain at least 1 uppercase and lowercase character, at least 1 digit, and at least 1 special character.",
        accountPasswordInvestor: "Investor Password",
        accountConfirmPassword: "Confirm Trading Password",
        accountConfirmPasswordInvestor: "Confirm Investor Password",
        code: " Enter the code from your",
        confirm: "Confirm",
        cancel: "Cancel",
      },
      error: {
        title: "The amount you wish to withdraw is insufficient.",
      },
    },
    dashboardInnerTransfer: {
      title: "Internal transfer",
      tab1: "Transfer",
      tab2: "History",
      warningTitle: "Important Notice",
      warningSubTitle1:
        "When placing a trading order, be aware that internal transfers can transfer up to 90% of your equity, excluding credit.",
      warningSubTitle2:
        "For internal transfers between bonus accounts to accounts participating bonuses, the credited bonus will transfer proportionally based on the transferred balance percentage.",
      warningSubTitle3:
        "For internal transfers between bonus accounts to accounts that do not participate bonuses, the bonus will be deducted from transferred account.",
      input1: "From",
      input2: "To",
      input3: "Amount",
      input1Placeholder: "Select account",
      input2Placeholder: "Select account",
      input3Placeholder: "Amount",
      confirm: "Confirm",
      confirm_dialog: {
        title: "Confirmation transfer!",
      },
      historyTitle: "History",
      accountNumberTransfer: "From account ",
      accountNumberIncome: "To account",
      amount: "Amount",
      date: "Date",
      error: {
        title_PRO: "Internal transfers to PRO accounts for a minimum of ",
        title_Raw: "Internal transfers to Raw accounts for a minimum of ",
        title_min: "Internal transfer minimum",
      },
    },
    dashboardProgram: {
      title: "Platform",
      boxMetatrader4Title: "MetaTrader 4",
      boxMetatrader5Title: "MetaTrader 5",
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle:
        "MetaTrader 4 is widely regarded as a platform. The world's most popular CFDs Trading form Because it has an easy-to-use user interface, graphs and indicators Including the most important is the MQL language, which allows users to easily program indicators and also includes Expert Advisors (EA or Automated Trading Strategies).",
      boxMetatrader5SubTitle:
        "MetaTrader 5 is widely regarded as a platform. The world's most popular CFDs Trading form Because it has an easy-to-use user interface, graphs and indicators Including the most important is the MQL language, which allows users to easily program indicators and also includes Expert Advisors (EA or Automated Trading Strategies).",
      boxWebtrader4SubTitle:
        "Without having to download anything at all, you can use the full practicality of IUX Markets  MT4 WebTrader for instant online trading on both demo and trading accounts. The complete trading functionality of IUX Markets  WebTrader is based on its compatibility with MetaTrader4. This allows one-click operations for opening and closing trades, setting stops and entry limits, placing direct orders, setting and editing limit and stop loss, and charting.",
      boxWebtrader5SubTitle:
        "Without having to download anything at all, you can use the full practicality of IUX Markets  MT5 WebTrader for instant online trading on both demo and trading accounts. The complete trading functionality of IUX Markets  WebTrader is based on its compatibility with MetaTrader4. This allows one-click operations for opening and closing trades, setting stops and entry limits, placing direct orders, setting and editing limit and stop loss, and charting.",
      boxMobileTitle: "MT4 Mobile App",
      boxMobile5Title: "MT5 Mobile App",
      boxMobileSubTitle:
        "The IUX MT4 app for iPhone® is ready for a live trading account. By downloading it free from the Apple App Store",
      readMore: "More",
    },
    dashboardVerify: {
      title: "Verify",
    },
    dashboardSwapReturn: {
      title: "Swap Credit Return",
      deposit: "Deposit",
      withdraw: "Withdraw",
      myCredit: "My Credit",
      condition: "Condition",
      conditionSeq1:
        "- Swap credits that can be refunded by service providers must always be in direct contact with the market or broker. ",
      conditionSeq2: "- You must have continuous trading. usually ",
      conditionSeq3:
        "- Must have a minimum deposit of 50,000 baht or more to receive a Swap Swap credit",
      conditionSeq4: "- Please read and understand the conditions correctly",
    },
    dashboardFund: {
      deposit: "Deposit",
      withdraw: "Withdraw",
      history: "History",
      warning: {
        title:
          " Please be aware while placing a trading order. Withdrawals can be withdrawn 90% of the margin without bringing credit.",
        description:
          "Recommend: If withdrawing funds, all pending orders should be closed first.",
      },
      modalVerify: {
        bankAccountTypeLabel: "Bank Account Type",
        bankAccountTypePlaceHolder: "Choose Bank Account Type",
        typeOfBank: {
          currentaccount: "Current account",
          savingsaccount: "Savings account",
          ordinaryaccount: "Ordinary account",
        },
        bankBranch: "Bank Branch ",
        bankBranchPlaceHolder: "Bank Branch",
        bankBranchRequired: "Please Input Bank Branch Correctly",
        alertVerifyBookBank:
          "You have to confirm your bank account. In order to be able to process withdrawals You can confirm your bank account by filling in the complete information below.",
        alertVerifyUser:
          "You must confirm your identity in order to be able to accept trades. You can verify your identity by filling in the information below.",
        titleVerifyUser: "Verify User",
        titleVerifyBookBank: "Verify Book Bank",
        fnameLabel: "First Name",
        fnamePlaceHolder: "First Name ",
        fnameLabelPlaceHolderJP:
          "Please enter your first name using English characters.",
        lnameLabel: "Last Name",
        lnamePlaceHolder: "Last Name",
        lnameLabelPlaceHolderJP:
          "Please enter your last name using English characters.",
        popIdLabel: "ID card number",
        popIdPlaceHolder: "ID card number",
        warning:
          "* Please enter the bank information used for depositing - withdrawing. For use in your account",
        bankLabel: "Bank",
        bankPlaceHolder: "Choose Bank",
        accountNumberLabel: "Bank Account Number",
        accountNumberPlaceHolder: "Bank Account Number",

        accountNameLabel: "Bank Account Holder",
        accountNamePlaceholderJP:
          "Please enter the bank account holder's name using Katakana characters.",
        email: "Email",
        tel: "Phone Number",
        birthdayLabel: "Date of birth",
        birthdayPlaceHolder: "Date of birth",
        addressLabel: "Address",
        addressPlaceHolder: "Address",
        provinceLabel: `Province`,
        provincePlaceHolder: `Select Province`,
        stateUnionLabel: "	State/Union Territory	",
        stateUnionPlaceHolder: "	Select State/Union Territory	",
        stateLabel: "	State	",
        statePlaceHolder: "	Select State	",
        municipalityLabel: "	Province/Municipality	",
        municipalityPlaceHolder: "	Select Province/Municipality	",
        regionStateLabel: "	Region/State	",
        regionStatePlaceHolder: "	Select Region/State	",
        regionLabel: "	Region	",
        regionPlaceHolder: "	Select Region	",
        postLabel: "ZIP / Post Code",
        postPlaceHolder: "ZIP / Post Code",
        jobLabel: "Career",
        otherLabel: "Other (specify)",
        jobPlaceHolder: "Select career",
        footerText1:
          "Please upload a photo of your ID Card by attaching only the front of the card.",
        condition: "* (xxx.png, xxx.jpg, xxx.jpeg)",
        footerText2: "Please upload bank account images",
        footerText3:
          " Before proceeding with the Proof of Bank (POB) verification, we kindly request you to thoroughly review the instructions to ensure a seamless and successful update.",
        validateFirstName: "Please Input First name.Correctly",
        validateLastName: "Please Input Last name.Correctly",
        validateIdCard: "Please Input",
        validateBank: "Please Input Bank name.Correctly",
        validateBankAccount: "Please Input Bank Account.Correctly",
        validateBankName: "Please Input Bank Name.Correctly",
        validatePhone: "Please Input Phone Number.Correctly",
        validateBirth: "Please Input Birth Date.Correctly",
        validateAddress: "Please Input Address.Correctly",
        validateProvince: `Please Input Province.Correctly`,
        validat: "Please Input.Correctly",
        validatePost: "Please Input ZIP / Post Code Number.Correctly",
        validateCareer: "Please Input Career.Correctly",
        validateInput: "Please Input",
        validatePassword: "Please Input Field, Correctly",
      },
      tabHistory: {
        title: "Transaction pending",
        title2: "Complete transaction",
        tableLabel: {
          transaction: "Transaction",
          account: "Account",
          amount: "Amount",
          bank: "Bank",
          status: "Status",
          date: "Date",
        },
      },
    },
    dashboardSpread: {
      thematic: "Thematic Indices",
    },
  },
  pt: {
    nodata: "Sem dados",

    /* ---------- Dashboard Bonus ---------- */
    dashboardBonus: {
      bonus_term1:
        "Faça o seu primeiro depósito de 20 USD, receba 30 USD grátis, negocie e levante sem condições.",
      bonus_term2:
        "Pode negociar e levantar imediatamente, sem quaisquer requisitos.",
      ckeck_box_bonus: "Li os detalhes e aceito os termos da empresa.",
      bonus_warning:
        "** Atenção: o bónus de 30 USD só pode ser usado uma vez e não pode ser alterado.",
      bonus_warning_2:
        "** Nota: bónus de 30 USD disponível apenas para depósitos em contas STANDARD+ e Standard.",
    },

    tooltip_currency:
      "O valor da moeda é apenas uma aproximação do preço atual.",

    /* ---------- Dashboard (rodapé) ---------- */
    dashboard: {
      footer:
        "Este website é operado pelo IUX Markets Global Group, a partir de Singapura, com autoridade para gerir principalmente o negócio de negociação de valores mobiliários sob licença. \
  Aviso de Risco: Negociar CFDs e outros produtos alavancados envolve riscos elevados e pode não ser adequado para todos os investidores. As operações podem resultar em perdas superiores ao investimento inicial. Antes de negociar, certifique-se de compreender todos os riscos e, se necessário, procure aconselhamento imparcial. \
  Esta informação não se destina a ser distribuída nem utilizada por pessoas residentes em determinados países/jurisdições, incluindo, mas não limitado a, Austrália, Bélgica, França, Irão, Japão, Coreia do Norte e Estados Unidos. A empresa não presta serviços a residentes desses países. O IUX Markets Global Group reserva-se o direito de alterar a lista de países acima ao seu critério.",
      copyright:
        "© 2016 IUX Markets Global Group. Todos os direitos reservados.",
    },

    /* ---------- Histórico de Transações ---------- */
    dashboardTransactionHistory: {
      filter: {
        month: "Mês",
        type: "Tipo",
        status: "Estado",
        all: "Todos",
      },
      headers: {
        type: "Tipo",
        time: "Hora",
        account: "Conta",
        method: "Método",
        localAmount: "Montante local",
        receive: "Recebido",
        status: "Estado",
      },
      type: {
        Deposit: "Depósito",
        Withdraw: "Levantamento",
        Compensation: "Compensação",
      },
      status: {
        Accepted: "Aceite",
        Pending: "Pendente",
        Rejected: "Rejeitado",
      },
      expand: {
        otherDetails: "Outros detalhes",
        bankAccountDetail: "Detalhes da conta bancária",
        accountType: "Tipo de conta",
        transactionID: "ID da transação",
        currencyRate: "Taxa de câmbio",
        accountNumber: "N.º da conta",
        accountName: "Titular da conta",
        bankName: "Banco",
        proofOfTransfer: "Comprovativo de transferência",
        exportHere: "Exportar aqui",
      },
    },

    /* ---------- Carteira ---------- */
    dashboardWallet: {
      no_archive_account: "Não tem contas arquivadas.",
      account_detail: "Detalhes da conta",
      recommended: "Recomendado",
      Professional: "Profissional",
      fund: "Fundos",
      reactive: "Reativar",
      only_mt5: "Apenas contas de negociação MT5 podem ser adicionadas.",
      your_account: "Algo correu mal",
      error_10:
        "Lamentamos o incómodo. Não pode abrir contas adicionais porque o limite máximo é 6. Elimine algumas contas para criar novas.",
      laos_deposit:
        "Transfira apenas em kip; depósitos em USD serão sujeitos à taxa de câmbio bancária superior à normal.",
      your_mt4: "A sua conta MT4",
      your_mt5: "A sua conta MT5",
      input_error: "Introduza um valor",
      rq_account: "Escolha a conta",
      rq_amount: "Introduza o montante",
      createAccount: "Criar conta de trading",
      server: "Servidor",
      account: "Minha Conta",
      accountType: "Tipo",
      accountBalance: "Saldo",
      accountCredit: "Crédito",
      accountBonusRemain: "Bónus restante",
      accountPlatform: "Plataforma",
      accountNumber: "N.º da conta",
      accountLeverage: "Alavancagem",
      accountDemoMoney: "Montante",
      transferNomore:
        "Para transferir fundos tem de ter mais de 1 conta real de trading.",
      myBonus: "O meu bónus",
      detail: "Detalhe",
      deposit: "Depósito",
      remainBonus: "Bónus remanescente",
      notAccount: "Não tem nenhuma conta",
      noVerifyUser:
        "Tem de concluir a verificação de identidade antes de adicionar uma conta.",
      noVerifyBookBank:
        "É necessária verificação de identidade antes de efetuar levantamentos.",
      bonus: "Bónus",
      menu: {
        confirm_dialog: {
          title: "Número da conta",
          content: "Confirma que pretende eliminar esta conta?",
        },
        account_edit: "Alterar palavra-passe",
        investor_edit: "Criar palavra-passe de investidor",
        account_close: "Eliminar conta",
        account_archive: "Arquivar conta",
        leverage_edit: "Alterar alavancagem",
      },
      tooltip: {
        password:
          "A palavra-passe deve conter pelo menos 1 carácter (A-Z, a-z)",
        title: "Bónus de Depósito",
        description:
          "Condição do bónus: receberá um montante proporcional ao depósito, até ao limite máximo especificado.",
      },
      modal: {
        title: "Abrir nova conta",
        subTitle:
          "Escolha as características da sua conta real para maior comodidade",
        metatrader: "MetaTrader 4",
        accountType: "Tipo",
        accountMoney: "Moeda",
        accountPassword: "Palavra-passe de trading",
        accountPassword_validate:
          "A palavra-passe deve ter 8 a 15 caracteres, incluir maiúsculas, minúsculas, dígito e carácter especial.",
        accountPasswordInvestor: "Palavra-passe de investidor",
        accountConfirmPassword: "Confirmar palavra-passe de trading",
        accountConfirmPasswordInvestor: "Confirmar palavra-passe de investidor",
        code: "Introduza o código da sua",
        confirm: "Confirmar",
        cancel: "Cancelar",
      },
      error: {
        title: "O montante que pretende levantar é insuficiente.",
      },
    },

    /* ---------- Transferência Interna ---------- */
    dashboardInnerTransfer: {
      title: "Transferência interna",
      tab1: "Transferir",
      tab2: "Histórico",
      warningTitle: "Aviso importante",
      warningSubTitle1:
        "Ao colocar ordens, lembre-se de que pode transferir até 90 % do seu capital (excluindo crédito).",
      warningSubTitle2:
        "Transferências entre contas com bónus para contas que também participam em bónus transferem o bónus proporcionalmente de acordo com o saldo transferido.",
      warningSubTitle3:
        "Transferências de contas com bónus para contas sem bónus deduzem o bónus da conta de origem.",
      input1: "De",
      input2: "Para",
      input3: "Montante",
      input1Placeholder: "Selecionar conta",
      input2Placeholder: "Selecionar conta",
      input3Placeholder: "Montante",
      confirm: "Confirmar",
      confirm_dialog: {
        title: "Confirmar transferência!",
      },
      historyTitle: "Histórico",
      accountNumberTransfer: "Da conta",
      accountNumberIncome: "Para a conta",
      amount: "Montante",
      date: "Data",
      error: {
        title_PRO: "Transferências internas para contas PRO a partir de ",
        title_Raw: "Transferências internas para contas Raw a partir de ",
        title_min: "Transferência interna mínima",
      },
    },

    /* ---------- Programas / Plataformas ---------- */
    dashboardProgram: {
      title: "Plataforma",
      boxMetatrader4Title: "MetaTrader 4",
      boxMetatrader5Title: "MetaTrader 5",
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle:
        "O MetaTrader 4 é amplamente reconhecido como a plataforma de CFDs mais popular do mundo, pela interface intuitiva, gráficos, indicadores e linguagem MQL para programar indicadores e Expert Advisors (EAs).",
      boxMetatrader5SubTitle:
        "O MetaTrader 5 partilha a popularidade do MT4, oferecendo interface simples, gráficos avançados, indicadores e MQL para EAs e indicadores personalizados.",
      boxWebtrader4SubTitle:
        "Sem downloads, use todas as funcionalidades do IUX MT4 WebTrader para negociar online em contas demo e reais. Compatível com MT4, permite abrir/fechar posições com um clique, definir stops, ordens pendentes e analisar gráficos.",
      boxWebtrader5SubTitle:
        "Com o IUX MT5 WebTrader pode negociar instantaneamente em contas demo e reais sem instalações. Compatível com MT4, inclui operações com um clique, gestão de ordens e ferramentas de gráfico.",
      boxMobileTitle: "App MT4 Mobile",
      boxMobile5Title: "App MT5 Mobile",
      boxMobileSubTitle:
        "A app IUX MT4 para iPhone® está pronta para contas reais; faça download gratuito na App Store.",
      readMore: "Mais",
    },

    /* ---------- Verificação ---------- */
    dashboardVerify: {
      title: "Verificar",
    },

    /* ---------- Swap Credit Return ---------- */
    dashboardSwapReturn: {
      title: "Devolução de crédito Swap",
      deposit: "Depósito",
      withdraw: "Levantamento",
      myCredit: "Meu crédito",
      condition: "Condições",
      conditionSeq1:
        "- Créditos de swap reembolsáveis devem estar sempre em contato direto com o mercado ou broker.",
      conditionSeq2: "- É necessário manter negociação contínua.",
      conditionSeq3:
        "- Depósito mínimo de 50 000 THB (ou equivalente) para receber crédito de swap.",
      conditionSeq4: "- Leia e compreenda corretamente as condições.",
    },

    /* ---------- Fundos (Depósito/Levantamento) ---------- */
    dashboardFund: {
      deposit: "Depósito",
      withdraw: "Levantamento",
      history: "Histórico",
      warning: {
        title:
          "Ao colocar ordens, lembre-se de que os levantamentos podem retirar 90 % da margem, excluindo crédito.",
        description:
          "Recomendação: feche todas as ordens pendentes antes de levantar fundos.",
      },
      modalVerify: {
        bankAccountTypeLabel: "Tipo de conta bancária",
        bankAccountTypePlaceHolder: "Selecionar tipo de conta",
        typeOfBank: {
          currentaccount: "Conta à ordem",
          savingsaccount: "Conta poupança",
          ordinaryaccount: "Conta corrente",
        },
        bankBranch: "Agência bancária",
        bankBranchPlaceHolder: "Agência",
        bankBranchRequired: "Introduza corretamente a agência",
        alertVerifyBookBank:
          "Confirme a sua conta bancária para poder efetuar levantamentos, preenchendo as informações abaixo.",
        alertVerifyUser:
          "É necessária verificação de identidade para negociar; preencha os dados abaixo.",
        titleVerifyUser: "Verificar utilizador",
        titleVerifyBookBank: "Verificar conta bancária",
        fnameLabel: "Nome próprio",
        fnamePlaceHolder: "Nome",
        fnameLabelPlaceHolderJP: "Introduza o nome usando caracteres latinos.",
        lnameLabel: "Apelido",
        lnamePlaceHolder: "Apelido",
        lnameLabelPlaceHolderJP:
          "Introduza o apelido usando caracteres latinos.",
        popIdLabel: "N.º de identificação",
        popIdPlaceHolder: "N.º de identificação",
        warning:
          "* Introduza os dados bancários usados para depósitos/levantamentos na sua conta.",
        bankLabel: "Banco",
        bankPlaceHolder: "Selecionar banco",
        accountNumberLabel: "N.º da conta bancária",
        accountNumberPlaceHolder: "N.º da conta",
        accountNameLabel: "Titular da conta",
        accountNamePlaceholderJP: "Introduza o nome do titular em Katakana.",
        email: "Email",
        tel: "Telefone",
        birthdayLabel: "Data de nascimento",
        birthdayPlaceHolder: "Data de nascimento",
        addressLabel: "Endereço",
        addressPlaceHolder: "Endereço",
        provinceLabel: "Província",
        provincePlaceHolder: "Selecione a província",
        stateUnionLabel: "Estado/Território",
        stateUnionPlaceHolder: "Selecione o estado/território",
        stateLabel: "Estado",
        statePlaceHolder: "Selecione o estado",
        municipalityLabel: "Município/Província",
        municipalityPlaceHolder: "Selecione o município/província",
        regionStateLabel: "Região/Estado",
        regionStatePlaceHolder: "Selecione a região/estado",
        regionLabel: "Região",
        regionPlaceHolder: "Selecione a região",
        postLabel: "Código postal",
        postPlaceHolder: "Código postal",
        jobLabel: "Profissão",
        otherLabel: "Outro (especificar)",
        jobPlaceHolder: "Selecione a profissão",
        footerText1: "Carregue a foto do seu documento de identidade (frente).",
        condition: "* (xxx.png, xxx.jpg, xxx.jpeg)",
        footerText2: "Carregue imagens da conta bancária",
        footerText3:
          "Antes de prosseguir com a verificação de prova de banco, leia atentamente as instruções para garantir atualização bem-sucedida.",
        validateFirstName: "Introduza o nome corretamente",
        validateLastName: "Introduza o apelido corretamente",
        validateIdCard: "Introduza o número de ID",
        validateBank: "Introduza o banco corretamente",
        validateBankAccount: "Introduza o n.º de conta corretamente",
        validateBankName: "Introduza o nome do banco corretamente",
        validatePhone: "Introduza o telefone corretamente",
        validateBirth: "Introduza a data de nascimento corretamente",
        validateAddress: "Introduza o endereço corretamente",
        validateProvince: "Selecione a província corretamente",
        validat: "Introduza corretamente",
        validatePost: "Introduza o código postal corretamente",
        validateCareer: "Introduza a profissão corretamente",
        validateInput: "Preenchimento obrigatório",
        validatePassword: "Preencha o campo corretamente",
      },
      tabHistory: {
        title: "Transações pendentes",
        title2: "Transações concluídas",
        tableLabel: {
          transaction: "Transação",
          account: "Conta",
          amount: "Montante",
          bank: "Banco",
          status: "Estado",
          date: "Data",
        },
      },
    },

    /* ---------- Spreads ---------- */
    dashboardSpread: {
      thematic: "Índices Temáticos",
    },
  },
  hi: {
    nodata: "कोई डेटा नहीं",
    dashboardBonus: {
      bonus_term1: `अपनी पहली जमा राशि 20$ करें, निःशुल्क $30 प्राप्त करें, व्यापार करें और बिना शर्त निकासी करें।`,
      bonus_term2: `आप बिना किसी शर्त के तुरंत व्यापार कर सकते हैं और निकासी कर सकते हैं।`,
      ckeck_box_bonus: `आपने विवरण पढ़ लिया है और कंपनी की शर्तों से सहमत हैं।`,
      bonus_warning: `** कृपया ध्यान दें कि 30$ बोनस का उपयोग केवल एक बार किया जा सकता है और इसे बदला नहीं जा सकता।`,
      bonus_warning_2: `** नोट: केवल मानक+ और मानक खाते में जमा के लिए $30 बोनस`,
    },
    tooltip_currency: `मुद्रा का मूल्य वर्तमान कीमत का केवल एक अनुमान है।`,
    dashboard: {
      footer:
        `यह वेबसाइट IUX मार्केट्स ग्लोबल ग्रुप द्वारा संचालित है। सिंगापुर से लाइसेंस के साथ मुख्य रूप से प्रतिभूति व्यापार व्यवसाय का प्रबंधन करने की शक्ति है` +
        `जोखिम चेतावनी: कृपया ध्यान दें कि सीएफडी और अन्य क्रेडिट उत्पादों के व्यापार में उच्च जोखिम शामिल है। और सभी निवेशकों के लिए उपयुक्त नहीं है, वित्तीय साधनों का व्यापार करने से नुकसान भी हो सकता है। लाभ प्राप्त करने के साथ और हानि प्रारंभिक निवेश से अधिक हो सकती है। ऐसा लेनदेन करने से पहले, सभी जोखिमों को समझना सुनिश्चित करें। और आवश्यकता पड़ने पर निष्पक्ष सलाह प्राप्त करनी चाहिए। इस जानकारी का उपयोग नहीं किया जाता है। या कुछ देशों/न्यायक्षेत्रों में रहने वाले लोगों द्वारा वितरित या उपयोग करने का इरादा है, जिसमें ऑस्ट्रेलिया, बेल्जियम, फ्रांस, ईरान, जापान, उत्तर कोरिया और संयुक्त राज्य अमेरिका शामिल हैं, लेकिन इन्हीं तक सीमित नहीं हैं। कंपनी सेवाएं प्रदान नहीं करती है। कुछ देशों/क्षेत्राधिकारों में रहने वाले लोगों के लिए, जिनमें ऑस्ट्रेलिया, बेल्जियम, फ्रांस, ईरान, जापान, उत्तर कोरिया और संयुक्त राज्य अमेरिका शामिल हैं, लेकिन इन्हीं तक सीमित नहीं हैं, IUX मार्केट्स ग्लोबल ग्रुप को उपरोक्त देशों की सूची को अपने विवेक से बदलने का अधिकार है।`,
      copyright: `© 2016 आईयूएक्स मार्केट्स ग्लोबल ग्रुप। सर्वाधिकार सुरक्षित।`,
    },
    dashboardTransactionHistory: {
      filter: {
        month: "महीना",
        type: "प्रकार",
        status: "स्थिति",
        all: "सभी",
      },
      headers: {
        type: "प्रकार",
        time: "समय",
        account: "खाता",
        method: "रास्ता",
        localAmount: "धन की राशि हस्तांतरित की गई",
        receive: "प्राप्त राशि",
        status: "स्थिति",
      },
      type: {
        Deposit: "जमा",
        Withdraw: "निकालना",
        Compensation: "क्षतिपूर्ति",
      },
      status: {
        Accepted: "मंज़ूरी देना",
        Pending: "कार्रवाई का इंतजार",
        Rejected: "अस्वीकार करना",
      },
      expand: {
        otherDetails: "अधिक जानकारी",
        bankAccountDetail: "बैंक के खाते का विवरण",
        accountType: "लेखांकन प्रकार",
        transactionID: "लेन-देन",
        currencyRate: "विनिमय दर",
        accountNumber: "खाता संख्या",
        accountName: "खाता नाम",
        bankName: "बैंक का नाम",
        proofOfTransfer: "अंतरण साक्ष्य",
        exportHere: "यहां फ़ाइलें निर्यात करें",
      },
    },
    dashboardWallet: {
      no_archive_account: "	आपके पास संग्रह खाता नहीं है।	",
      account_detail: "	लेखा विवरण	",
      recommended: "	अनुशंसित	",
      Professional: "	पेशेवर	",
      fund: "	निधि	",
      reactive: "	फिर से सक्रिय	",
      only_mt5: `केवल MT5 ट्रेडिंग खाते ही जोड़े जा सकते हैं।`,
      your_account: `कुछ गलत हो गया`,
      error_10: `असुविधा के लिए खेद है, आप अतिरिक्त खाते नहीं खोल सकते। क्योंकि अधिकतम खाता केवल 6 खातों तक ही सीमित है। नए खाते जोड़ने के लिए कृपया कुछ खाते हटा दें`,
      laos_deposit: `कृपया पैसा केवल किप मुद्रा में ही ट्रांसफर करें, यदि यूएसडी में ट्रांसफर करते हैं, तो आपको सामान्य दर से अधिक बैंक जमा दर से कटौती की जाएगी`,
      your_mt4: `आपका MT4 खाता`,
      your_mt5: `आपका MT5 खाता`,
      input_error: `कृपया मान दर्ज करें`,
      rq_account: `कृपया खाता चुनें`,
      rq_amount: `कृपया राशि दर्ज करें`,
      createAccount: `ट्रेडिंग अकाउंट बनाएं`,
      server: `सर्वर`,
      account: `मेरा खाता`,
      accountType: `प्रकार`,
      accountBalance: `संतुलन`,
      accountCredit: `श्रेय`,
      accountBonusRemain: `बोनस शेष`,
      accountPlatform: `प्लैटफ़ॉर्म`,
      accountNumber: `खाता नंबर।`,
      accountLeverage: `फ़ायदा उठाना`,
      accountDemoMoney: `मात्रा`,
      transferNomore:
        "फंड ट्रांसफर करने के लिए, आपको 1 से अधिक लाइव ट्रेडिंग खाता खोलना होगा",
      myBonus: `मेरा बोनस`,
      detail: `विवरण`,
      deposit: `जमा`,
      remainBonus: `शेष बोनस`,
      notAccount: `आपके पास कोई खाता नहीं है`,
      noVerifyUser: `खाता जोड़ने से पहले आपको पहचान सत्यापन प्राप्त करना होगा।`,
      noVerifyBookBank: `पैसे निकालने से पहले आपको पहचान सत्यापन कराना होगा।`,
      bonus: `बक्शीश`,
      menu: {
        confirm_dialog: {
          title: `खाता संख्या`,
          content: `क्या आप इस खाते को हटाने की पुष्टि करते हैं?`,
        },
        account_edit: `पासवर्ड बदलें`,
        investor_edit: `पासवर्ड इन्वेस्टर बनाएं`,
        account_close: `खाता हटा दो`,
        account_archive: `पुरालेख खाता`,
        leverage_edit: `उत्तोलन बदलें`,
      },
      tooltip: {
        password: `पासवर्ड में (A-Z a-z) कम से कम 1 अक्षर होना चाहिए`,
        title: `बोनस जमा`,
        description: `बोनस शर्त: आपको एक बोनस राशि प्राप्त होगी जो जमा राशि के समानुपाती होगी, जिसकी अधिकतम सीमा निर्दिष्ट होगी`,
      },
      modal: {
        title: `एक नया खाता खोलें`,
        subTitle: `कृपया अपने वास्तविक खाते की विशेषताएँ चुनें। उपयोग में आसानी के लिए`,
        metatrader: `मेटाट्रेडर 4`,
        accountType: `प्रकार`,
        accountMoney: `मुद्रा`,
        accountPassword: `ट्रेडिंग पासवर्ड`,
        accountPassword_validate:
          "पासवर्ड की लंबाई — न्यूनतम 8 अक्षर, अधिकतम 15 अक्षर। पासवर्ड में कम से कम 1 अपरकेस और लोअरकेस अक्षर, कम से कम 1 अंक, और कम से कम 1 विशेष चरित्र होना चाहिए।",
        accountPasswordInvestor: `निवेशक पासवर्ड`,
        accountConfirmPassword: `ट्रेडिंग पासवर्ड की पुष्टि करें`,
        accountConfirmPasswordInvestor: `निवेशक पासवर्ड की पुष्टि करें`,
        code: `अपना कोड दर्ज करें`,
        confirm: `पुष्टि करना`,
        cancel: `रद्द करना`,
      },
      error: {
        title: `आप जो राशि निकालना चाहते हैं वह अपर्याप्त है।`,
      },
    },
    dashboardInnerTransfer: {
      title: `आंतरिक स्थानांतरण`,
      tab1: `स्थानांतरण`,
      tab2: `इतिहास`,
      warningTitle: "महत्वपूर्ण सूचना",
      warningSubTitle1:
        "ट्रेडिंग ऑर्डर करते समय, ध्यान रखें कि आंतरिक स्थानान्तरण क्रेडिट को छोड़कर, आपकी इक्विटी के 90% तक स्थानांतरित कर सकते हैं।",
      warningSubTitle2:
        "बोनस में भाग लेने वाले खातों के लिए बोनस खातों के बीच आंतरिक स्थानान्तरण के लिए, क्रेडिट बोनस हस्तांतरित शेष प्रतिशत के आधार पर आनुपातिक रूप से स्थानांतरित करेगा।",
      warningSubTitle3:
        "बोनस खातों के बीच आंतरिक स्थानान्तरण के लिए जो बोनस में भाग नहीं लेते हैं, बोनस को स्थानांतरित खाते से काट दिया जाएगा।",
      input1: `से`,
      input2: `को`,
      input3: `मात्रा`,
      input1Placeholder: `खाता चुनें`,
      input2Placeholder: `खाता चुनें`,
      input3Placeholder: `मात्रा`,
      confirm: `पुष्टि करना`,
      confirm_dialog: {
        title: `पुष्टिकरण स्थानांतरण!`,
      },
      historyTitle: `इतिहास`,
      accountNumberTransfer: `अकाउंट से`,
      accountNumberIncome: `खाते में`,
      amount: `मात्रा`,
      date: `तारीख`,
      error: {
        title_PRO: `PRO खातों में आंतरिक स्थानांतरण न्यूनतम का होता है `,
        title_Raw: `रॉ खातों में न्यूनतम का आंतरिक स्थानांतरण। `,
        title_min: `आंतरिक स्थानांतरण न्यूनतम`,
      },
    },
    dashboardProgram: {
      title: `ट्रेडिंग उपकरण`,
      boxMetatrader4Title: `मेटाट्रेडर 4`,
      boxMetatrader5Title: `मेटाट्रेडर 5`,
      boxwebtrader4Title: `वेबट्रेडर 4`,
      boxwebtrader5Title: `वेबट्रेडर 5`,
      boxMetatrader4SubTitle: `मेटाट्रेडर 4 को व्यापक रूप से एक प्लेटफ़ॉर्म माना जाता है। दुनिया का सबसे लोकप्रिय सीएफडी ट्रेडिंग फॉर्म क्योंकि इसमें उपयोग में आसान यूजर इंटरफेस, ग्राफ़ और संकेतक शामिल हैं जिनमें सबसे महत्वपूर्ण एमक्यूएल भाषा है, जो उपयोगकर्ताओं को आसानी से संकेतक प्रोग्राम करने की अनुमति देता है और इसमें विशेषज्ञ सलाहकार (ईए या स्वचालित ट्रेडिंग रणनीतियाँ) भी शामिल हैं। .`,
      boxMetatrader5SubTitle: `मेटाट्रेडर 5 को व्यापक रूप से एक प्लेटफ़ॉर्म माना जाता है। दुनिया का सबसे लोकप्रिय सीएफडी ट्रेडिंग फॉर्म क्योंकि इसमें उपयोग में आसान यूजर इंटरफेस, ग्राफ़ और संकेतक शामिल हैं जिनमें सबसे महत्वपूर्ण एमक्यूएल भाषा है, जो उपयोगकर्ताओं को आसानी से संकेतक प्रोग्राम करने की अनुमति देता है और इसमें विशेषज्ञ सलाहकार (ईए या स्वचालित ट्रेडिंग रणनीतियाँ) भी शामिल हैं। .`,
      boxWebtrader4SubTitle: `कुछ भी डाउनलोड किए बिना, आप डेमो और ट्रेडिंग अकाउंट दोनों पर तत्काल ऑनलाइन ट्रेडिंग के लिए IUX मार्केट्स MT4 वेबट्रेडर की पूरी व्यावहारिकता का उपयोग कर सकते हैं। IUX मार्केट्स वेबट्रेडर की संपूर्ण ट्रेडिंग कार्यक्षमता मेटाट्रेडर4 के साथ इसकी अनुकूलता पर आधारित है। यह ट्रेडों को खोलने और बंद करने, स्टॉप और प्रवेश सीमा निर्धारित करने, सीधे ऑर्डर देने, सीमा निर्धारित करने और संपादित करने और स्टॉप लॉस और चार्टिंग के लिए एक-क्लिक संचालन की अनुमति देता है।`,
      boxWebtrader5SubTitle: `कुछ भी डाउनलोड किए बिना, आप डेमो और ट्रेडिंग अकाउंट दोनों पर तत्काल ऑनलाइन ट्रेडिंग के लिए IUX मार्केट्स MT5 वेबट्रेडर की पूरी व्यावहारिकता का उपयोग कर सकते हैं। IUX मार्केट्स वेबट्रेडर की संपूर्ण ट्रेडिंग कार्यक्षमता मेटाट्रेडर4 के साथ इसकी अनुकूलता पर आधारित है। यह ट्रेडों को खोलने और बंद करने, स्टॉप और प्रवेश सीमा निर्धारित करने, सीधे ऑर्डर देने, सीमा निर्धारित करने और संपादित करने और स्टॉप लॉस और चार्टिंग के लिए एक-क्लिक संचालन की अनुमति देता है।`,
      boxMobileTitle: `MT4 मोबाइल ऐप`,
      boxMobile5Title: `MT5 मोबाइल ऐप`,
      boxMobileSubTitle: `iPhone® के लिए IUX MT4 ऐप लाइव ट्रेडिंग खाते के लिए तैयार है। इसे ऐप्पल ऐप स्टोर से मुफ्त डाउनलोड करके`,
      readMore: `अधिक`,
    },
    dashboardVerify: {
      title: `सत्यापित करें`,
    },
    dashboardSwapReturn: {
      title: `स्वैप क्रेडिट रिटर्न`,
      deposit: `जमा`,
      withdraw: `निकालना`,
      myCredit: `मेरा श्रेय`,
      condition: `स्थिति`,
      conditionSeq1: `- सेवा प्रदाताओं द्वारा वापस किए जा सकने वाले स्वैप क्रेडिट हमेशा बाज़ार या ब्रोकर के सीधे संपर्क में होने चाहिए।`,
      conditionSeq2: `- आपको लगातार ट्रेडिंग करनी होगी। आम तौर पर`,
      conditionSeq3: `- स्वैप स्वैप क्रेडिट प्राप्त करने के लिए न्यूनतम 50,000 baht या अधिक की जमा राशि होनी चाहिए`,
      conditionSeq4: `- कृपया शर्तों को सही से पढ़ें और समझें`,
    },
    dashboardFund: {
      deposit: `जमा`,
      withdraw: `निकालना`,
      history: `इतिहास`,
      warning: {
        title: `कृपया ट्रेडिंग ऑर्डर देते समय सावधान रहें। बिना क्रेडिट लाए मार्जिन का 90% निकाला जा सकता है।`,
        description: `अनुशंसा: यदि धनराशि निकाल रहे हैं, तो पहले सभी लंबित ऑर्डर बंद कर देने चाहिए।`,
      },
      modalVerify: {
        bankAccountTypeLabel: "बैंक खाता प्रकार",
        bankAccountTypePlaceHolder: "बैंक खाता प्रकार चुनें",
        typeOfBank: {
          currentaccount: "चालू खाता",
          savingsaccount: "बचत खाता",
          ordinaryaccount: "सामान्य खाता",
        },
        bankBranch: "बैंक शाखा ",
        bankBranchPlaceHolder: "बैंक शाखा",
        bankBranchRequired: "कृपया बैंक शाखा को सही से भरें",
        alertVerifyBookBank: `आपको अपने बैंक खाते की पुष्टि करनी होगी. निकासी की प्रक्रिया में सक्षम होने के लिए आप नीचे पूरी जानकारी भरकर अपने बैंक खाते की पुष्टि कर सकते हैं।`,
        alertVerifyUser: `ट्रेड स्वीकार करने में सक्षम होने के लिए आपको अपनी पहचान की पुष्टि करनी होगी। आप नीचे दी गई जानकारी भरकर अपनी पहचान सत्यापित कर सकते हैं।`,
        titleVerifyUser: `उपयोगकर्ता सत्यापित करें`,
        titleVerifyBookBank: `बुक बैंक सत्यापित करें`,
        fnameLabel: `पहला नाम`,
        fnamePlaceHolder: `पहला नाम`,
        fnameLabelPlaceHolderJP:
          "कृपया अंग्रेजी अक्षरों का उपयोग करके अपना पहला नाम दर्ज करें।",
        lnameLabel: `उपनाम`,
        lnamePlaceHolder: `उपनाम`,
        lnameLabelPlaceHolderJP:
          "कृपया अंग्रेजी अक्षरों का उपयोग करके अपना अंतिम नाम दर्ज करें।",
        popIdLabel: `परिचय - पत्र संख्या`,
        popIdPlaceHolder: `परिचय - पत्र संख्या`,
        warning: `* कृपया जमा-निकासी के लिए उपयोग की जाने वाली बैंक जानकारी दर्ज करें। आपके खाते में उपयोग के लिए`,
        bankLabel: `किनारा`,
        bankPlaceHolder: `बैंक चुनें`,
        accountNumberLabel: `बैंक खाता संख्या`,
        accountNumberPlaceHolder: `बैंक खाता संख्या`,

        accountNameLabel: `बैंक खाता के धारक का नाम`,
        accountNamePlaceholderJP: `कृपया कटकाना वर्णों का उपयोग करके बैंक खाताधारक का नाम दर्ज करें।`,
        email: `ईमेल`,
        tel: `फ़ोन नंबर`,
        birthdayLabel: `जन्म की तारीख`,
        birthdayPlaceHolder: `जन्म की तारीख`,
        addressLabel: `पता`,
        addressPlaceHolder: `पता`,
        provinceLabel: `राज्य`,
        provincePlaceHolder: `राज्य`,
        stateUnionLabel: "	राज्य/केंद्र क्षेत्र	",
        stateUnionPlaceHolder: "	राज्य/केंद्र क्षेत्र का चयन करें	",
        stateLabel: "	राज्य	",
        statePlaceHolder: "	राज्य चुनें	",
        municipalityLabel: "	प्रांत/नगरपालिका	",
        municipalityPlaceHolder: "	प्रांत/नगर पालिका का चयन करें	",
        regionStateLabel: "	क्षेत्र/राज्य	",
        regionStatePlaceHolder: "	क्षेत्र/राज्य का चयन करें	",
        regionLabel: "	क्षेत्र	",
        regionPlaceHolder: "	क्षेत्र का चयन करें	",
        postLabel: `ज़िप पोस्ट कोड`,
        postPlaceHolder: `ज़िप पोस्ट कोड`,
        jobLabel: `आजीविका`,
        otherLabel: `अन्य (निर्दिष्ट करे)`,
        jobPlaceHolder: `करियर चुनें`,
        footerText1: `कृपया अपने आईडी कार्ड का फोटो केवल कार्ड के सामने संलग्न करके अपलोड करें।`,
        condition: `* (xxx.png, xxx.jpg, xxx.jpeg)`,
        footerText2: `कृपया बैंक खाते के चित्र अपलोड करें`,
        footerText3: `पूर्व में बैंक के प्रमाण (POB) सत्यापन के साथ आगे बढ़ने से पहले, हम आपसे निवेदन करते हैं कि आप निर्देशों का सख्ती से समीक्षा करें ताकि एक सरल और सफल अपडेट हो सके।`,
        validateFirstName: `कृपया पहला नाम सही दर्ज करें`,
        validateLastName: `कृपया अंतिम नाम सही दर्ज करें`,
        validateIdCard: `इनपुट करें`,
        validateBank: `कृपया बैंक का नाम सही दर्ज करें`,
        validateBankAccount: `कृपया बैंक खाता सही दर्ज करें`,
        validateBankName: `कृपया बैंक का नाम सही दर्ज करें`,
        validatePhone: `कृपया फ़ोन नंबर सही दर्ज करें`,
        validateBirth: `कृपया जन्म तिथि सही दर्ज करें`,
        validateAddress: `कृपया पता सही दर्ज करें`,
        validateProvince: `कृपया प्रांत इनपुट करें।सही ढंग से`,
        validat: `कृपया इनपुट करें।सही ढंग से`,
        validatePost: `कृपया ज़िप/पोस्ट कोड नंबर सही ढंग से दर्ज करें`,
        validateCareer: `कृपया करियर इनपुट करें। सही ढंग से`,
        validateInput: "इनपुट करें",
        validatePassword: `कृपया फ़ील्ड सही ढंग से इनपुट करें`,
      },
      tabHistory: {
        title: `लेन-देन लंबित है`,
        title2: `पूर्ण लेन-देन`,
        tableLabel: {
          transaction: `लेन-देन`,
          account: `खाता`,
          amount: `मात्रा`,
          bank: `किनारा`,
          status: `स्थिति`,
          date: `तारीख`,
        },
      },
    },
    dashboardSpread: {
      thematic: "Thematic Indices",
    },
  },
  ms: {
    nodata: "tiada data",
    dashboardBonus: {
      bonus_term1:
        "Buat deposit pertama 20 $ dan dapatkan $30 percuma, berlabur dan keluarkan dana tanpa syarat.",
      bonus_term2:
        "Anda boleh berlabur dan mengeluarkan dana serta-merta tanpa sebarang syarat.",
      ckeck_box_bonus:
        "Anda telah membaca butiran dan bersetuju dengan syarat syarikat.",
      bonus_warning:
        "** Sila ambil perhatian bahawa bonus 30 $ boleh digunakan sekali sahaja tidak boleh diubah.",
      bonus_warning_2:
        "** Nota : Bonus $30 hanya untuk deposit ke akaun Standard+dan Standard sahaja",
    },
    tooltip_currency: "Nilai mata wang hanyalah anggaran harga semasa.",
    dashboard: {
      footer:
        `Laman web ini dikendalikan oleh IUX Markets Global Group dan dikawal selia dari Singapura, mempunyai kuasa untuk mengendalikan perniagaan perdagangan kewangan berlesen` +
        `Amaran Risiko: Sila ambil perhatian bahawa pelaburan CFDs  dan produk kredit lain melibatkan risiko yang tinggi dan tidak sesuai untuk semua pelabur. Pelaburan instrumen kewangan boleh mengakibatkan kerugian juga. Dengan menerima keuntungan dan kerugian yang mungkin lebih besar daripada pelaburan awal sebelum membuat apa-apa urus niaga, pastikan anda memahami semua risiko dan tidak  menerima nasihat yang berat sebelah jika diperlukan. Maklumat ini tidak digunakan atau dimaksudkan untuk diedarkan atau digunakan oleh orang-orang yang tinggal di negara-negara / wilayah tertentu termasuk tetapi tidak terhad kepada Australia, Belgium, Perancis, Iran, Jepun, Korea Utara dan Amerika Syarikat Syarikat tidak menyediakan perkhidmatan. Kepada orang-orang yang tinggal di negara-negara / wilayah tertentu termasuk tetapi tidak terhad kepada Australia, Belgium, Perancis, Iran, Jepun, Korea Utara dan Amerika Syarikat, IUX Markets Global Group mempunyai hak untuk mengubah senarai negara-negara di atas pertimbangan kami sendiri.`,
      copyright: `hak cipta: '© 2016 IUX Markets Global Group. Hak cipta terpelihara.`,
    },
    dashboardTransactionHistory: {
      filter: {
        month: "bulan",
        type: "Jenis",
        status: "status",
        all: "semua",
      },
      headers: {
        type: "Jenis",
        time: "masa",
        account: "akaun",
        method: "cara",
        localAmount: "Jumlah wang yang dipindahkan",
        receive: "Jumlah yang diterima",
        status: "status",
      },
      type: {
        Deposit: "Deposit",
        Withdraw: "Menarik diri",
        Compensation: "pampasan",
      },
      status: {
        Accepted: "terima",
        Pending: "Menunggu tindakan",
        Rejected: "menolak",
      },
      expand: {
        otherDetails: "Maklumat lanjut",
        bankAccountDetail: "maklumat akaun bank",
        accountType: "Jenis Perakaunan",
        transactionID: "Transaksi",
        currencyRate: "Kadar pertukaran",
        accountNumber: "Nombor akaun",
        accountName: "Nama akaun",
        bankName: "nama bank",
        proofOfTransfer: "Bukti pemindahan",
        exportHere: "Fail eksport di sini",
      },
    },
    dashboardWallet: {
      no_archive_account: "	Anda tidak mempunyai akaun arkib.	",
      account_detail: "	Perincian akaun	",
      recommended: "	Disyorkan	",
      Professional: "	Profesional	",
      fund: "	Dana	",
      reactive: "	Semula aktif	",
      only_mt5: `Hanya akaun dagangan MT5 yang boleh ditambah.`,
      your_account: `Ralat berlaku`,
      error_10:
        'Maaf atas kesulitan, Anda tidak boleh membuka akaun tambahan kerana akaun maksimum terhad kepada 6 akaun sahaja." Sila padamkan beberapa akaun untuk menambah akaun baharu',
      laos_deposit: `Sila pindahkan wang dalam mata wang kip sahaja. Jika pindahan dalam USD, anda akan ditolak daripada kadar deposit bank yang lebih tinggi daripada kadar biasa.`,
      your_mt4: `No.akaun MT4 anda`,
      your_mt5: `No. akaun MT5 anda`,
      input_error: `Sila isi disini`,
      rq_account: "Sila pilih akaun",
      rq_amount: "Sila masukkan jumlah",
      createAccount: `Tambah akaun dagangan`,
      server: "Pelayan",
      account: `Akaun`,
      accountType: `Jenis`,
      accountBalance: `Baki`,
      accountCredit: `Kredit`,
      accountCreditRemain: `Baki kredit`,
      accountPlatform: `platform`,
      accountNumber: `No. akaun.`,
      accountLeverage: `leverage`,
      accountDemoMoney: `jumlah`,
      transferNomore:
        "Untuk memindahkan dana, anda perlu membuka lebih daripada 1 akaun perdagangan langsung",
      myBonus: `Bonus saya`,
      detail: `detail`,
      deposit: `deposit`,
      remainBonus: `Sisa bonus `,
      notAccount: `Anda tidak mempunyai akaun dagangan yang aktif. Anda boleh meminta akaun dengan mengklik ikon di sebelah kanan.`,
      noVerifyUser: `Anda mesti mengesahkan identiti sebelum menambah akaun.`,
      noVerifyBookBank: `Anda perlu mengesahkan identiti sebelum keluarkan dana.`,
      bonus: "bonus",
      menu: {
        confirm_dialog: {
          title: `No. akaun`,
          content: `Adakah anda ingin memadam akaun ini?`,
        },
        account_edit: `Tukar kata laluan`,
        investor_edit: `Tukar Kata Laluan Pelabur`,
        account_close: `Padam akaun`,
        account_archive: `Arkib akaun`,
        leverage_edit: `Tukar Leverage`,
      },
      tooltip: {
        password: `kata laluan mesti mengandungi (A-Z a-z) sekurang-kurangnya 1 charactor`,
        title: `Bonus Deposit`,
        description: `Keadaan bonus: anda akan menerima jumlah bonus yang berkadar dengan jumlah yang disimpan, dengan had maksimum seperti yang ditentukan`,
      },
      modal: {
        title: `Membuka akaun baru`,
        subTitle: `Pilih ciri-ciri akaun sebenar anda. Untuk kemudahan penggunaan`,
        metatrader: `Metatrader 4`,
        accountType: `Jenis`,
        accountMoney: `mata wang`,
        accountPassword: "Kata laluan Trading",
        accountPassword_validate:
          "Panjang kata laluan — Minimum 8 aksara, maksimum 15 aksara. Kata laluan mesti mengandungi sekurang-kurangnya 1 aksara besar dan kecil, sekurang-kurangnya 1 digit, dan sekurang-kurangnya 1 aksara khas.",
        accountPasswordInvestor: "Kata Laluan Pelabur",
        accountConfirmPassword: "Sahkan Kata laluan Trading",
        accountConfirmPasswordInvestor: `Sahkan Kata Laluan Pelabur`,
        code: "Masukkan kod daripada e-mel anda.",
        confirm: `Confirm`,
        cancel: `Batal`,
      },
      error: {
        title: "Jumlah yang ingin anda keluarkan tidak mencukupi.",
      },
    },
    dashboardInnerTransfer: {
      title: `pemindahan dalaman`,
      tab1: `pemindahan`,
      tab2: `Sejarah`,
      warningTitle: "Notis penting",
      warningSubTitle1:
        "Apabila meletakkan pesanan dagangan, sedar bahawa pemindahan dalaman boleh memindahkan sehingga 90% ekuiti anda, tidak termasuk kredit.",
      warningSubTitle2:
        "Untuk pemindahan dalaman antara akaun bonus ke akaun bonus yang mengambil bahagian, bonus yang dikreditkan akan dipindahkan secara proporsional berdasarkan peratusan baki yang dipindahkan.",
      warningSubTitle3:
        "Untuk pemindahan dalaman antara akaun bonus ke akaun yang tidak menyertai bonus, bonus akan ditolak dari akaun yang dipindahkan.",
      input1: `Daripada Akaun`,
      input2: `Kepada Akaun`,
      input3: `jumlah wang yang ingin dipindahkan`,
      input1Placeholder: `Pilih akaun yang ingin dipindahkan`,
      input2Placeholder: `Pilih akaun tujuan`,
      input3Placeholder: `jumlah`,
      confirm: `Mengesahkan`,
      confirm_dialog: {
        title: `pengesahan`,
      },
      historyTitle: `Pemindahan yang telah berlaku `,
      accountNumberTransfer: `daripada akaun`,
      accountNumberIncome: `Kepada akaun`,
      amount: `jumlah`,
      date: `Tarikh`,
      error: {
        title_PRO: "Pemindahan dalaman ke akaun PRO sekurang-kurangnya ",
        title_Raw: "Pemindahan dalaman ke akaun Raw sekurang-kurangnya ",
        title_min: "Internal transfer minimum",
      },
    },
    dashboardProgram: {
      title: `Platform`,
      boxMetatrader4Title: `MetaTrader 4`,
      boxMetatrader5Title: `MetaTrader 5`,
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle: `MetaTrader 4 secara meluas dianggap sebagai platform perdagangan CFDs yang paling popular di dunia \n 's Kerana ia mempunyai bagian penggunaan yang mudah, graf dan berbagai petunjuk untuk digunakan, yang paling penting adalah bahasa MQL, yang membolehkan pengguna dengan mudah diprogramkan juga termasuk Expert Advisors (EA atau Automated Strategi Trading)`,
      boxMetatrader5SubTitle: `MetaTrader 4 secara meluas dianggap sebagai platform perdagangan CFDs yang paling popular di dunia \n 's Kerana ia mempunyai bagian penggunaan yang mudah, graf dan berbagai petunjuk untuk digunakan, yang paling penting adalah bahasa MQL, yang membolehkan pengguna dengan mudah diprogramkan juga termasuk Expert Advisors (EA atau Automated Strategi Trading)`,
      boxWebtrader4SubTitle:
        "Tanpa perlu memuat turun apa-apa pun, anda boleh menggunakan kepraktisan penuh IUX Markets MT4 WebTrader untuk dagangan dalam talian segera pada kedua-dua akaun demo dan dagangan. Fungsi dagangan lengkap IUX Markets WebTrader adalah berdasarkan keserasiannya dengan MetaTrader4. Ini membolehkan operasi satu klik untuk membuka dan menutup dagangan, menetapkan hentian dan had kemasukan, meletakkan pesanan terus, menetapkan dan menyunting had dan henti rugi, dan carta.",
      boxWebtrader5SubTitle:
        "Tanpa perlu memuat turun apa-apa pun, anda boleh menggunakan kepraktisan penuh IUX Markets MT5 WebTrader untuk dagangan dalam talian segera pada kedua-dua akaun demo dan dagangan. Fungsi dagangan lengkap IUX Markets WebTrader adalah berdasarkan keserasiannya dengan MetaTrader4. Ini membolehkan operasi satu klik untuk membuka dan menutup dagangan, menetapkan hentian dan had kemasukan, meletakkan pesanan terus, menetapkan dan menyunting had dan henti rugi, dan carta.",
      boxMobileTitle: `MT4 Mobile App`,
      boxMobile5Title: `MT5 Mobile App`,
      boxMobileSubTitle: `Aplikasi MT4 IUX untuk iPhone® tersedia untuk akaun dagangan sebenar. Ia boleh dimuat turun secara percuma dari Apple App Store.`,
      readMore: `Tambahan`,
    },
    dashboardVerify: {
      title: `mengesahkan identiti`,
    },
    dashboardSwapReturn: {
      title: `Pulangan tunai tukaran kredit`,
      deposit: `deposit`,
      withdraw: `Mengeluarkan`,
      myCredit: `Kredit terkini`,
      condition: `Syarat`,
      conditionSeq1: `- Kredit Pertukaran yang boleh dibayar balik oleh pembekal perkhidmatan perlu sentiasa berada dalam hubungan secara langsung dengan pasaran atau broker.`,
      conditionSeq2: `- Anda mesti mempunyai perdagangan yang berterusan `,
      conditionSeq3: `- Mesti mempunyai deposit minimum sebanyak 50,000 baht atau lebih untuk menerima kredit Pertukaran`,
      conditionSeq4: `- Sila baca dan memahami Syarat dengan betul`,
    },
    dashboardFund: {
      deposit: `Deposit`,
      withdraw: `Mengeluarkan`,
      history: `Sejarah`,
      warning: {
        title: `Nota: Sila ambil perhatian apabila anda membuat pesanan dagangan, pengeluaran boleh dikeluarkan 90% daripada equity tanpa kredit`,
        description: `Mengesyorkan: Jika mengeluarkan wang, semua pesanan yang belum selesai perlu ditutup dahulu`,
      },
      modalVerify: {
        bankAccountTypeLabel: "Jenis akaun bank",
        bankAccountTypePlaceHolder: "Pilih jenis akaun bank",
        typeOfBank: {
          currentaccount: "Akaun terkini",
          savingsaccount: "Akaun simpanan",
          ordinaryaccount: "Akaun biasa",
        },
        bankBranch: "Cawangan Bank ",
        bankBranchPlaceHolder: "Cawangan Bank",
        bankBranchRequired: "Sila Masukkan Cawangan Bank Dengan Betul",
        alertVerifyBookBank: `Anda perlu mengesahkan akaun bank anda supaya transaksi pengeluaran dapat dijalankan. Anda boleh mengesahkan akaun bank anda dengan mengisi maklumat di bawah dengan lengkap`,
        alertVerifyUser: `Anda perlu mengesahkan identiti anda untuk dapat menerima dagangan. Anda boleh mengesahkan identiti anda dengan mengisi maklumat di bawah`,
        titleVerifyUser: `Mengesahkan pengguna`,
        titleVerifyBookBank: `Mengesahkan no.Buku Bank`,
        fnameLabel: `Nama pertama`,
        fnamePlaceHolder: `Nama pertama (bahasa Thai atau Inggeris)`,
        fnameLabelPlaceHolderJP:
          "Sila masukkan nama pertama anda menggunakan aksara Inggeris.",
        lnameLabel: `Nama terakhir`,
        lnamePlaceHolder: `Nama terakhir (bahasa Thai atau Inggeris)`,
        lnameLabelPlaceHolderJP:
          "Sila masukkan nama keluarga anda menggunakan aksara Inggeris.",
        popIdLabel: `nombor kad ID`,
        popIdPlaceHolder: `nombor kad ID`,
        warning: `* Sila masukkan maklumat bank yang digunakan untuk mendepositkan - menarik balik untuk digunakan dalam akaun anda`,
        bankLabel: `Bank`,
        bankPlaceHolder: `pilih Bank`,
        accountNumberLabel: `Nombor akaun bank`,
        accountNumberPlaceHolder: `Nombor akaun bank`,

        accountNameLabel: `Pemegang Akaun Bank`,
        accountNamePlaceholderJP: `Sila masukkan nama pemegang akaun bank menggunakan aksara Katakana.`,
        email: `e-mel`,
        tel: `Phone Number`,
        birthdayLabel: `Tarikh lahir`,
        birthdayPlaceHolder: `Tarikh lahir`,
        addressLabel: `Alamat`,
        addressPlaceHolder: `Alamat`,
        provinceLabel: `Wilayah`,
        provincePlaceHolder: `Pilih Wilayah`,
        stateUnionLabel: "	Wilayah negeri/kesatuan	",
        stateUnionPlaceHolder: "	Pilih Wilayah Negeri/Kesatuan	",
        stateLabel: "	Negeri	",
        statePlaceHolder: "	Pilih Negeri	",
        municipalityLabel: "	Wilayah/perbandaran	",
        municipalityPlaceHolder: "	Pilih Wilayah/Perbandaran	",
        regionStateLabel: "	Wilayah/Negeri	",
        regionStatePlaceHolder: "	Pilih Wilayah/Negeri	",
        regionLabel: "	Wilayah	",
        regionPlaceHolder: "	Pilih Wilayah	",
        postLabel: `Pos/Poskod`,
        postPlaceHolder: `Pos/Poskod`,
        jobLabel: `Pekerjaan`,
        otherLabel: `Lain-lain (nyatakan)`,
        jobPlaceHolder: `Pilih kerjaya`,
        footerText1: `Sila muat naik gambar Kad Pengenalan anda dengan melampirkan bahagian hadapan kad sahaja.`,
        condition: `* (Xxx.png, xxx.jpg, xxx.jpeg)`,
        footerText2: `Sila muat naik gambar akaun bank`,
        footerText3: `Sebelum meneruskan dengan pengesahan Bukti Bank (POB), kami dengan hormat meminta anda untuk menyemak arahan dengan teliti untuk memastikan kemaskini yang lancar dan berjaya.`,
        validateFirstName: `Sila isi nama pertama dengan betul`,
        validateLastName: `Sila isi nama terakhir dengan betul`,
        validateIdCard: `Sila isi no. `,
        validateBank: `Sila isi nama bank anda dengan betul`,
        validateBankAccount: `Sila isi no. akaun bank anda dengan betul`,
        validateBankName: `Sila isi nama akaun bank anda dengan betul`,
        validatePhone: `Sila isi no. Telefon anda dengan betul`,
        validateBirth: `Sila isi tarikh lahir dengan betul`,
        validateAddress: `Sila Isi alamat dengan betul`,
        validateProvince: `Sila Isi Provinsi dengan betul`,
        validat: `Sila Isi Provinsi dengan betul`,
        validatePost: `Sila isi no. post dengan betul`,
        validateCareer: `Sila Isi pekerjaan dengan betul`,
        validateInput: "Sila masukkan",
        validatePassword: `Sila Isi maklumat dengan betul`,
      },
      tabHistory: {
        title: `Transaksi sedang diproses`,
        title2: `Transaksi sempurna`,
        tableLabel: {
          transaction: `Transaksi`,
          account: `akaun`,
          amount: `jumlah`,
          bank: `Bank`,
          status: `status`,
          date: `Tarikh`,
        },
      },
    },
    dashboardSpread: {
      thematic: "Indeks Thematic",
    },
  },
  id: {
    nodata: "tidak ada data",
    dashboardBonus: {
      bonus_term1:
        "Make your first deposit 20 $, get free $30, trade and withdraw unconditionally.",
      bonus_term2:
        "You can trade and withdraw immediately without any conditions.",
      ckeck_box_bonus:
        "You have read the details and agree to the terms of the company.",
      bonus_warning:
        "** Please note that the 30 $ bonus can be used only once and cannot be changed.",
      bonus_warning_2:
        "** Note : $30 Bonus for deposit to STANDARD+ and Standard account only",
    },
    tooltip_currency: "Nilai mata uang hanyalah perkiraan harga saat ini.",
    dashboard: {
      footer:
        `Website ini dioperasikan oleh IUX Markets Group Global. Dari Singapura Memiliki kekuatan untuk terutama mengelola sekuritas perdagangan bisnis Dengan lisensi` +
        `Peringatan Resiko: catatan Harap bahwa perdagangan CFDs dan produk kredit lainnya melibatkan risiko tinggi. Dan tidak cocok untuk semua investor Perdagangan instrumen keuangan dapat mengakibatkan kerugian juga. Dengan menerima keuntungan dan kerugian mungkin lebih besar dari investasi awal Sebelum membuat transaksi tersebut, pastikan untuk memahami semua risiko. Dan harus menerima berisi nasihat jika diperlukan Informasi ini tidak digunakan. Atau dimaksudkan untuk didistribusikan atau digunakan oleh orang-orang yang berada di negara-negara tertentu / yurisdiksi Termasuk namun tidak terbatas ke Australia, Belgia, Perancis, Iran, Jepang, Korea Utara dan Amerika Serikat perusahaan tidak menyediakan layanan. Untuk orang yang tinggal di negara-negara tertentu / yurisdiksi Termasuk namun tidak terbatas ke Australia, Belgia, Perancis, Iran, Jepang, Korea Utara dan Amerika Serikat, IUX Markets Global Group memiliki hak untuk mengubah daftar negara di atas Kebijaksanaan kami sendiri`,
      copyright: `hak cipta: '© 2016 IUX Markets Group Global. Seluruh hak cipta.`,
    },
    dashboardTransactionHistory: {
      filter: {
        month: "bulan",
        type: "jenis",
        status: "status",
        all: "semua",
      },
      headers: {
        type: "jenis",
        time: "waktu",
        account: "akun",
        method: "jalan",
        localAmount: "Jumlah uang yang ditransfer",
        receive: "Jumlah yang diterima",
        status: "status",
      },
      type: {
        Deposit: "Menyetorkan",
        Withdraw: "Menarik",
        Compensation: "kompensasi",
      },
      status: {
        Accepted: "menyetujui",
        Pending: "Menunggu tindakan",
        Rejected: "menolak",
      },
      expand: {
        otherDetails: "Keterangan lebih lanjut",
        bankAccountDetail: "Detail rekening bank",
        accountType: "Jenis akuntansi",
        transactionID: "Transaksi",
        currencyRate: "Kurs",
        accountNumber: "Nomor akun",
        accountName: "Nama akun",
        bankName: "nama Bank",
        proofOfTransfer: "Bukti transfer",
        exportHere: "Ekspor file di sini",
      },
    },
    dashboardWallet: {
      no_archive_account: "	Anda tidak memiliki akun arsip.	",
      account_detail: "	Detail Akun	",
      recommended: "	Direkomendasikan	",
      Professional: "	Profesional	",
      fund: "	Dana	",
      reactive: "	Aktif	",
      no_archive_account: "	Anda tidak mempunyai akaun arkib.	",
      account_detail: "	Perincian akaun	",
      recommended: "	Disyorkan	",
      Professional: "	Profesional	",
      fund: "	Dana	",
      reactive: "	Semula aktif	",
      only_mt5: `Only MT5 trading accounts can be added.`,
      your_account: `Something went wrong`,
      error_10:
        'Sorry for the inconvenience, You cannot open additional accounts. Because the maximum account is limited to 6 accounts only." Please delete some accounts to add new accounts',
      laos_deposit: `Please transfer money in kip currency only, if transfer in USD, you will be deducted from the bank deposit rate higher than normal rate`,
      your_mt4: `Akun MT4 Anda`,
      your_mt5: `Akun MT5 Anda`,
      input_error: `Silakan masukan disini`,
      rq_account: "Please choose account",
      rq_amount: "Please enter amount",
      createAccount: `Buat Akun`,
      server: "Server",
      account: `Akun`,
      accountType: `Tipe`,
      accountBalance: `Keseimbangan`,
      accountCredit: `Kredit`,
      accountBonusRemain: `bonus Tetap`,
      accountPlatform: `Peron`,
      accountNumber: `No rekening.`,
      accountLeverage: `Pengaruh`,
      accountDemoMoney: `Jumlah`,
      transferNomore:
        "Untuk mentransfer dana, Anda harus membuka lebih dari 1 akun perdagangan langsung",
      myBonus: `Bonus saya`,
      detail: `Detil`,
      deposit: `Menyetorkan`,
      remainBonus: `sisa bonus`,
      notAccount: `Anda tidak memiliki akun perdagangan terbuka. Anda dapat meminta akun dengan mengklik ikon di sisi kanan.`,
      noVerifyUser: `Anda harus menerima verifikasi identitas sebelum menambahkan akun.`,
      noVerifyBookBank: `Anda harus memiliki verifikasi identitas sebelum menarik uang.`,
      bonus: "Bonus",
      menu: {
        confirm_dialog: {
          title: `Nomor akun`,
          content: `Apakah Anda mengkonfirmasi menghapus akun ini?`,
        },
        account_edit: `Ubah Password`,
        investor_edit: `Ubah Password Investor`,
        account_close: `Hapus akun`,
        account_archive: `Archive account akun`,
        leverage_edit: `perubahan leverage`,
      },
      tooltip: {
        password: `sandi harus mengandung (A-Z a-z) minimal 1 charactor`,
        title: `Bonus Deposit`,
        description: `Kondisi bonus: Anda akan menerima jumlah bonus yang sebanding dengan jumlah yang disimpan, dengan batas maksimum seperti yang ditentukan`,
      },
      modal: {
        title: `Membuka account baru`,
        subTitle: `Silahkan pilih karakteristik akun Anda yang sebenarnya. Untuk kemudahan penggunaan`,
        metatrader: `Metatrader 4`,
        accountType: `Tipe`,
        accountMoney: `Mata uang`,
        accountPassword: `Kata sandi`,
        accountPassword_validate:
          "Panjang kata sandi — Minimal 8 karakter, maksimal 15 karakter. Kata sandi harus mengandung setidaknya 1 karakter huruf besar dan kecil, setidaknya 1 digit, dan setidaknya 1 karakter khusus.",
        accountPasswordInvestor: `investor password`,
        accountConfirmPassword: `konfirmasi sandi`,
        accountConfirmPasswordInvestor: `Konfirmasi Investor Sandi`,
        code: " Enter the code from your",
        confirm: `Konfirmasi`,
        cancel: `Membatalkan`,
      },
      error: {
        title: "The amount you wish to withdraw is insufficient.",
      },
    },
    dashboardInnerTransfer: {
      title: `internal transfer`,
      tab1: `Transfer`,
      tab2: `Sejarah`,
      warningTitle: "Pemberitahuan Penting",
      warningSubTitle1:
        "Saat menempatkan pesanan perdagangan, ketahuilah bahwa transfer internal dapat mentransfer hingga 90% dari ekuitas Anda, tidak termasuk kredit.",
      warningSubTitle2:
        "Untuk transfer internal antara akun bonus ke akun yang berpartisipasi, bonus yang dikreditkan akan ditransfer secara proporsional berdasarkan persentase saldo yang ditransfer.",
      warningSubTitle3:
        "Untuk transfer internal antara akun bonus ke akun yang tidak berpartisipasi bonus, bonus akan dikurangkan dari akun yang ditransfer.",
      input1: `Dari`,
      input2: `Untuk`,
      input3: `Jumlah`,
      input1Placeholder: `Pilih akun untuk`,
      input2Placeholder: `Pilih akun dari`,
      input3Placeholder: `jumlah`,
      confirm: `Konfirmasi`,
      confirm_dialog: {
        title: `Konfirmasi`,
      },
      historyTitle: `Sejarah`,
      accountNumberTransfer: `Dari akun`,
      accountNumberIncome: `Ke rekening`,
      amount: `Jumlah`,
      date: `Tanggal`,
      error: {
        title_PRO: "Internal transfers to PRO accounts for a minimum of ",
        title_Raw: "Internal transfers to Raw accounts for a minimum of ",
        title_min: "Internal transfer minimum",
      },
    },
    dashboardProgram: {
      title: `Platform`,
      boxMetatrader4Title: `MetaTrader 4`,
      boxMetatrader5Title: `MetaTrader 5`,
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle: `MetaTrader 4 secara luas dianggap sebagai platform. bentuk CFDs Trading paling populer di dunia \n 's Karena memiliki mudah digunakan antarmuka pengguna, grafik dan indikator Termasuk yang paling penting adalah bahasa MQL, yang memungkinkan pengguna untuk dengan mudah indikator program serta juga termasuk Expert Advisors (EA atau Automated Strategi trading)`,
      boxMetatrader5SubTitle: `MetaTrader 5 secara luas dianggap sebagai platform. bentuk CFDs Trading paling populer di dunia \n 's Karena memiliki mudah digunakan antarmuka pengguna, grafik dan indikator Termasuk yang paling penting adalah bahasa MQL, yang memungkinkan pengguna untuk dengan mudah indikator program serta juga termasuk Expert Advisors (EA atau Automated Strategi trading)`,
      boxWebtrader4SubTitle:
        "Without having to download anything at all, you can use the full practicality of IUX Markets  MT4 WebTrader for instant online trading on both demo and trading accounts. The complete trading functionality of IUX Markets  WebTrader is based on its compatibility with MetaTrader4. This allows one-click operations for opening and closing trades, setting stops and entry limits, placing direct orders, setting and editing limit and stop loss, and charting.",
      boxWebtrader5SubTitle:
        "Without having to download anything at all, you can use the full practicality of IUX Markets  MT5 WebTrader for instant online trading on both demo and trading accounts. The complete trading functionality of IUX Markets  WebTrader is based on its compatibility with MetaTrader4. This allows one-click operations for opening and closing trades, setting stops and entry limits, placing direct orders, setting and editing limit and stop loss, and charting.",
      boxMobileTitle: `MT4 Mobile App`,
      boxMobile5Title: `MT5 Mobile App`,
      boxMobileSubTitle: `The IUX MT4 app untuk iPhone siap rekening trading. Dengan men-download gratis dari Apple App Store`,
      readMore: `Lebih`,
    },
    dashboardVerify: {
      title: `Memeriksa`,
    },
    dashboardSwapReturn: {
      title: `Swap Kredit Kembali`,
      deposit: `Menyetorkan`,
      withdraw: `Menarik`,
      myCredit: `Kredit saya`,
      condition: `Kondisi`,
      conditionSeq1: `- Swap kredit yang dapat dikembalikan oleh penyedia layanan harus selalu berada dalam kontak langsung dengan pasar atau broker.`,
      conditionSeq2: `- Anda harus memiliki perdagangan yang berkelanjutan. biasanya`,
      conditionSeq3: `- Harus memiliki minimal deposit 50.000 baht atau lebih untuk menerima kredit Swap Swap`,
      conditionSeq4: `- Harap membaca dan memahami kondisi benar`,
    },
    dashboardFund: {
      deposit: `Menyetorkan`,
      withdraw: `Menarik`,
      history: `Sejarah`,
      warning: {
        title: `Catatan: Jika penarikan uang dalam hal membuka pending order Anda akan dapat menarik hanya 90% dari Equity yang ada. (Pesanan yang tidak termasuk, termasuk, berhenti, sell, stop, limit, sell)`,
        description: `Merekomendasikan: Jika penarikan dana, semua pesanan yang tertunda harus ditutup pertama`,
      },
      modalVerify: {
        bankAccountTypeLabel: "Jenis rekening bank",
        bankAccountTypePlaceHolder: "Pilih jenis rekening bank",
        typeOfBank: {
          currentaccount: "Akun saat ini",
          savingsaccount: "Rekening tabungan",
          ordinaryaccount: "Akun biasa",
        },
        bankBranch: "Cabang Bank ",
        bankBranchPlaceHolder: "Cabang Bank",
        bankBranchRequired: "Harap Masukkan Cabang Bank Dengan Benar",
        alertVerifyBookBank: `Anda harus mengkonfirmasi rekening bank Anda. Agar dapat penarikan proses Anda dapat mengkonfirmasi rekening bank Anda dengan mengisi informasi yang lengkap di bawah ini`,
        alertVerifyUser: `Anda harus mengkonfirmasi identitas Anda agar dapat menerima perdagangan. Anda dapat memverifikasi identitas Anda dengan mengisi informasi di bawah ini`,
        titleVerifyUser: `Verifikasi Pengguna`,
        titleVerifyBookBank: `Verifikasi Buku Bank`,
        fnameLabel: `Nama depan`,
        fnamePlaceHolder: `Nama depan`,
        fnameLabelPlaceHolderJP:
          "Silakan masukkan nama depan Anda menggunakan karakter bahasa Inggris.",
        lnameLabel: `Nama keluarga`,
        lnamePlaceHolder: `Nama keluarga`,
        lnameLabelPlaceHolderJP:
          "Silakan masukkan nama belakang Anda menggunakan karakter bahasa Inggris.",
        popIdLabel: `nomor kartu identitas`,
        popIdPlaceHolder: `nomor kartu identitas`,
        warning: `* Masukkan informasi bank yang digunakan untuk penyetoran - menarik. Untuk penggunaan di akun Anda`,
        bankLabel: `Bank`,
        bankPlaceHolder: `Pilih Bank`,
        accountNumberLabel: `Nomor rekening bank`,
        accountNumberPlaceHolder: `Nomor rekening bank`,

        accountNameLabel: `Pemegang Rekening Bank`,
        accountNamePlaceholderJP: `Silakan masukkan nama pemegang rekening bank menggunakan karakter Katakana.`,
        email: `Surel`,
        tel: `Phone Number`,
        birthdayLabel: `Tanggal lahir`,
        birthdayPlaceHolder: `Tanggal lahir`,
        addressLabel: `Alamat`,
        addressPlaceHolder: `Alamat`,
        provinceLabel: `Propinsi`,
        provincePlaceHolder: `Pilih Provinsi`,
        stateUnionLabel: "	Wilayah Negara/Union	",
        stateUnionPlaceHolder: "	Pilih Wilayah Negara/Union	",
        stateLabel: "	Negara	",
        statePlaceHolder: "	Pilih negara bagian	",
        municipalityLabel: "	Provinsi/Kota	",
        municipalityPlaceHolder: "	Pilih provinsi/kotamadya	",
        regionStateLabel: "	Wilayah/negara bagian	",
        regionStatePlaceHolder: "	Pilih Wilayah/Negara Bagian	",
        regionLabel: "	Wilayah	",
        regionPlaceHolder: "	Pilih wilayah	",
        postLabel: `Pos`,
        postPlaceHolder: `Pos`,
        jobLabel: `Karier`,
        otherLabel: `Lainnya (sebutkan)`,
        jobPlaceHolder: `Pilih Karir`,
        footerText1: `Harap unggah foto KTP Anda dengan melampirkan hanya bagian depan kartu.`,
        condition: `* (Xxx.png, XXX.jpg, xxx.jpeg)`,
        footerText2: `Silakan gambar akun meng-upload Bank`,
        footerText3: `Sebelum melanjutkan dengan verifikasi Bukti Bank (POB), kami dengan hormat meminta Anda untuk memeriksa petunjuk dengan seksama untuk memastikan pembaruan yang lancar dan sukses.`,
        validateFirstName: `Silahkan Masukan Pertama name.Correctly`,
        validateLastName: `Silahkan Masukan name.Correctly terakhir`,
        validateIdCard: `Silahkan Masukan`,
        validateBank: `Silahkan Masukan Bank name.Correctly`,
        validateBankAccount: `Silahkan Masukan Bank Account.Correctly`,
        validateBankName: `Silahkan Masukan Bank Name.Correctly`,
        validatePhone: `Silahkan Masukan Telepon Number.Correctly`,
        validateBirth: `Silahkan Masukan Lahir Date.Correctly`,
        validateAddress: `Silahkan Masukan Address.Correctly`,
        validateProvince: `Silahkan Masukan Province.Correctly`,
        validat: `Silahkan Masukan Province.Correctly`,
        validatePost: `Silahkan Masukan Pasang Number.Correctly`,
        validateCareer: `Silahkan Masukan Career.Correctly`,
        validateInput: "Mohon masukkan",
        validatePassword: `Silahkan Masukan Field, Benar`,
      },
      tabHistory: {
        title: `tertunda transaksi`,
        title2: `transaksi lengkap`,
        tableLabel: {
          transaction: `Transaksi`,
          account: `Akun`,
          amount: `Jumlah`,
          bank: `Bank`,
          status: `Status`,
          date: `Tanggal`,
        },
      },
    },
    dashboardSpread: {
      thematic: "Indeks Thematic",
    },
  },
  zh: {
    nodata: "沒有數據",
    dashboardBonus: {
      bonus_term1:
        "Make your first deposit 20 $, get free $30, trade and withdraw unconditionally.",
      bonus_term2:
        "You can trade and withdraw immediately without any conditions.",
      ckeck_box_bonus:
        "You have read the details and agree to the terms of the company.",
      bonus_warning:
        "** Please note that the 30 $ bonus can be used only once and cannot be changed.",
      bonus_warning_2:
        "** Note : $30 Bonus for deposit to STANDARD+ and Standard account only",
    },
    tooltip_currency:
      "The value of the currency is only an approximation of the current price.",
    dashboard: {
      footer:
        `本网站由IUX Markets国际集团经营。从新加坡的主要经营证券交易业务许可证”电源` +
        `风险提示：请注意，外汇交易及其他信贷产品涉及高风险。不适合交易的金融工具所有投资者可能会导致损失以及。随着接收的利润和损失可能会比最初投资作出这样的交易前更大，一定要了解所有的风险。而如果不使用需要这些信息应该得到公正的意见。或拟分配或居住在某些国家/地区，包括人使用，但不限于澳大利亚，比利时，法国，伊朗，日本，朝鲜和美国的公司不提供服务。居住在某些国家/地区，包括人，但不限于澳大利亚，比利时，法国，伊朗，日本，朝鲜和美国，IUX Markets环球集团有可能改变国家的名单之上。在我们自己的决定权。`,
      copyright: `版权所有：“2016年©市场IUX全局组。版权所有。`,
    },
    dashboardTransactionHistory: {
      filter: {
        month: "月",
        type: "类型",
        status: "地位",
        all: "全部",
      },
      headers: {
        type: "类型",
        time: "时间",
        account: "帐户",
        method: "方式",
        localAmount: "转移的金额",
        receive: "收到的金额",
        status: "地位",
      },
      type: {
        Deposit: "订金",
        Withdraw: "提取",
        Compensation: "赔偿",
      },
      status: {
        Accepted: "批准",
        Pending: "等待行动",
        Rejected: "拒绝",
      },
      expand: {
        otherDetails: "更多细节",
        bankAccountDetail: "银行账户明细",
        accountType: "会计类型",
        transactionID: "交易",
        currencyRate: "汇率",
        accountNumber: "帐号",
        accountName: "帐户名称",
        bankName: "银行名",
        proofOfTransfer: "转移证据",
        exportHere: "在这里导出文件",
      },
    },
    dashboardWallet: {
      no_archive_account: "	您沒有存檔帳戶。	",
      account_detail: "	帳戶細節	",
      recommended: "	受到推崇的	",
      Professional: "	專業的	",
      fund: "	基金	",
      reactive: "	重新活躍	",
      only_mt5: `Only MT5 trading accounts can be added.`,
      your_account: `Something went wrong`,
      error_10:
        'Sorry for the inconvenience, You cannot open additional accounts. Because the maximum account is limited to 6 accounts only." Please delete some accounts to add new accounts',
      laos_deposit: `Please transfer money in kip currency only, if transfer in USD, you will be deducted from the bank deposit rate higher than normal rate`,
      your_mt4: `您的MT4账户`,
      your_mt5: `您的MT5账户`,
      input_error: `请在此输入`,
      rq_account: "Please choose account",
      rq_amount: "Please enter amount",
      createAccount: `创建帐户`,
      server: "服務器",
      account: `帐户`,
      accountType: `类型`,
      accountBalance: `平衡`,
      accountCredit: `信用`,
      accountBonusRemain: `红利次还`,
      accountPlatform: `平台`,
      accountNumber: `户口号码。`,
      accountLeverage: `杠杆作用`,
      accountDemoMoney: `量`,
      transferNomore: "為了轉移資金，您必須開設1個以上的實時交易帳戶",
      myBonus: `我的奖金`,
      detail: `详情`,
      deposit: `存款`,
      remainBonus: `剩余奖金`,
      notAccount: `你没有一个开放的交易账户。您可以通过点击右侧的图标，申请帐户。`,
      noVerifyUser: `添加帐户之前，您必须接受身份验证。`,
      noVerifyBookBank: `取钱前，必须将身份验证。`,
      bonus: "奖金",
      menu: {
        confirm_dialog: {
          title: `账号`,
          content: `你确定要删除这个帐户吗？`,
        },
        account_edit: `更改密码`,
        investor_edit: `更改密码投资者`,
        account_close: `删除帐户`,
        account_archive: `Archive account`,
        leverage_edit: `更改杠杆`,
      },
      tooltip: {
        password: `密码必须包含（A-Z A-Z）的至少1人物造型`,
        title: `奖励忠诚存款`,
        description: `獎勵條件：您將收到與存入額成正比的獎金金額，並指定最大限制`,
      },
      modal: {
        title: `打开一个新的帐户`,
        subTitle: `请选择您的实际帐户的特点。为了方便使用`,
        metatrader: `MetaTrader的4`,
        accountType: `类型`,
        accountMoney: `货币`,
        accountPassword: `密码`,
        accountPassword_validate:
          "密码长度 — 最少8个字符，最多15个字符。密码必须包含至少1个大写和小写字符，至少1个数字，以及至少1个特殊字符。",

        accountPasswordInvestor: `投资者密码`,
        accountConfirmPassword: `确认密码`,
        accountConfirmPasswordInvestor: `确认投资者密码`,
        code: " Enter the code from your",
        confirm: `确认`,
        cancel: `取消`,
      },
      error: {
        title: "The amount you wish to withdraw is insufficient.",
      },
    },
    dashboardInnerTransfer: {
      title: `内部转移`,
      tab1: `转让`,
      tab2: `历史`,
      warningTitle: "重要的提醒",
      warningSubTitle1:
        "在签订交易订单时，请注意，内部转移最多可以转移您的权益的70％，不包括信贷。",
      warningSubTitle2:
        "对于奖金帐户之间的内部转移到帐户参与奖金，积分奖金将根据转移的余额百分比成比例地转移。",
      warningSubTitle3:
        "对于不参与奖金的帐户之间的内部转让，将从转移的帐户中扣除奖金。",
      input1: `从`,
      input2: `至`,
      input3: `量`,
      input1Placeholder: `选择账户`,
      input2Placeholder: `选择从账户`,
      input3Placeholder: `量`,
      confirm: `确认`,
      confirm_dialog: {
        title: `确认`,
      },
      historyTitle: `历史`,
      accountNumberTransfer: `从账户`,
      accountNumberIncome: `为了帐户`,
      amount: `日期`,
      date: `日期`,
      error: {
        title_PRO: "Internal transfers to PRO accounts for a minimum of ",
        title_Raw: "Internal transfers to Raw accounts for a minimum of ",
        title_min: "Internal transfer minimum",
      },
    },
    dashboardProgram: {
      title: `交易工具`,
      boxMetatrader4Title: `MetaTrader的4`,
      boxMetatrader5Title: `MetaTrader的4`,
      boxwebtrader4Ti5le: "Web Trader",
      boxMetatrader4SubTitle: `MetaTrader 4的被广泛认为是一个平台。世界\n'最流行的外汇交易形式，因为它具有一个易于使用的用户界面，图形和指标，包括最重要的是MQL语言，它允许用户方便地计划指标，也包括智能交易（EA或自动交易策略）`,
      boxMetatrader5SubTitle: `MetaTrader 5的被广泛认为是一个平台。世界\n'最流行的外汇交易形式，因为它具有一个易于使用的用户界面，图形和指标，包括最重要的是MQL语言，它允许用户方便地计划指标，也包括智能交易（EA或自动交易策略）`,
      boxWebtrader4SubTitle:
        "Without having to download anything at all, you can use the full practicality of IUX Markets  MT4 WebTrader for instant online trading on both demo and trading accounts. The complete trading functionality of IUX Markets  WebTrader is based on its compatibility with MetaTrader4. This allows one-click operations for opening and closing trades, setting stops and entry limits, placing direct orders, setting and editing limit and stop loss, and charting.",
      boxWebtrader5SubTitle:
        "Without having to download anything at all, you can use the full practicality of IUX Markets  MT5 WebTrader for instant online trading on both demo and trading accounts. The complete trading functionality of IUX Markets  WebTrader is based on its compatibility with MetaTrader4. This allows one-click operations for opening and closing trades, setting stops and entry limits, placing direct orders, setting and editing limit and stop loss, and charting.",
      boxMobileTitle: `MT4 移动应用`,
      boxMobile5Title: `MT5 移动应用`,
      boxMobileSubTitle: `该IUX MT4应用程序的iPhone®为准备真实交易帐户。通过下载它从苹果App Store免费`,
      readMore: `更多`,
    },
    dashboardVerify: {
      title: `校验`,
    },
    dashboardSwapReturn: {
      title: `交换信用退回`,
      deposit: `存款`,
      withdraw: `退出`,
      myCredit: `我的信用`,
      condition: `健康）状况`,
      conditionSeq1: ` - 可以由服务供应商退还互换学分必须始终与市场或经纪人直接接触。`,
      conditionSeq2: ` - 你必须有持续交易。平时`,
      conditionSeq3: ` - 必须在100000泰铢以上的最低存款接收串换调剂信贷`,
      conditionSeq4: ` - 请阅读并正确理解的条件`,
    },
    dashboardFund: {
      deposit: `存款`,
      withdraw: `退出`,
      history: `历史`,
      warning: {
        title: `注：如果在打开挂单的情况下取钱，您将能够收回现有的余额只有70％。 （未包括订单，包括止损，卖出，止损，限制，卖出）`,
        description: `推荐：如果抽逃资金，所有挂单，应首先关闭`,
      },
      modalVerify: {
        bankAccountTypeLabel: "银行账户类型",
        bankAccountTypePlaceHolder: "选择银行账户类型",
        typeOfBank: {
          currentaccount: "经常账户",
          savingsaccount: "储蓄账户",
          ordinaryaccount: "普通账户",
        },
        bankBranch: "银行分行",
        bankBranchPlaceHolder: "银行分行",
        bankBranchRequired: "请输入正确的银行分行",
        alertVerifyBookBank: `你必须要确认您的银行帐户。为了能够处理取款您可以通过下面的完整信息填写确认您的银行帐户`,
        alertVerifyUser: `您必须确认，以便您的身份是能够接受的交易。您可以通过填写以下信息验证您的身份`,
        titleVerifyUser: `验证用户`,
        titleVerifyBookBank: `验证图书银行`,
        fnameLabel: `名字`,
        fnamePlaceHolder: `名字`,
        fnameLabelPlaceHolderJP: "请使用英文字符输入您的名字。",
        lnameLabel: `姓`,
        lnamePlaceHolder: `姓`,
        lnameLabelPlaceHolderJP: "请使用英文字符输入您的姓氏。",
        popIdLabel: `身份证号码`,
        popIdPlaceHolder: `身份证号码`,
        warning: `*请输入用于存放银行信息 - 退出。对于帐户中的使用`,
        bankLabel: `银行`,
        bankPlaceHolder: `选择银行`,
        accountNumberLabel: `银行账户`,
        accountNumberPlaceHolder: `银行账户`,

        accountNameLabel: `银行帐户名`,
        accountNamePlaceholderJP: `请使用片假名字符输入银行帐户持有人的姓名。`,
        email: `电子邮件`,
        tel: `联系电话`,
        birthdayLabel: `出生日期`,
        birthdayPlaceHolder: `出生日期`,
        addressLabel: `地址`,
        addressPlaceHolder: `地址`,
        provinceLabel: `省`,
        provincePlaceHolder: `選擇省`,
        stateUnionLabel: "	州/聯盟領土	",
        stateUnionPlaceHolder: "	選擇州/工會領土	",
        stateLabel: "	狀態	",
        statePlaceHolder: "	選擇狀態	",
        municipalityLabel: "	省/市政當局	",
        municipalityPlaceHolder: "	選擇省/市	",
        regionStateLabel: "	地區/州	",
        regionStatePlaceHolder: "	選擇區域/狀態	",
        regionLabel: "	地區	",
        regionPlaceHolder: "	選擇區域	",
        postLabel: `岗位`,
        postPlaceHolder: `岗位`,
        jobLabel: `事业`,
        otherLabel: `其他说明）`,
        jobPlaceHolder: `选择职业`,
        footerText1: `请仅附上身份证正面，上传身份证照片。`,
        condition: `*（xxx.png，XXX.JPG，xxx.jpeg）`,
        footerText2: `请上传银行帐户中的图片`,
        footerText3: `在进行银行证明（POB）验证之前，请您仔细阅读说明，确保更新顺利成功。`,
        validateFirstName: `请输入首先name.Correctly`,
        validateLastName: `请输入最后name.Correctly`,
        validateIdCard: `请输入人口`,
        validateBank: `请输入银行name.Correctly`,
        validateBankAccount: `请输入银行Account.Correctly`,
        validateBankName: `请输入银行Name.Correctly`,
        validatePhone: `请输入电话Number.Correctly`,
        validateBirth: `请输入出生Date.Correctly`,
        validateAddress: `请输入Address.Correctly`,
        validateProvince: `请输入Province.Correctly`,
        validat: `请输入Province.Correctly`,
        validatePost: `请输入帖子Number.Correctly`,
        validateCareer: `请输入Career.Correctly`,
        validateInput: "請輸入",
        validatePassword: `请输入字段，正确`,
      },
      tabHistory: {
        title: `交易待定`,
        title2: `交易完成`,
        tableLabel: {
          transaction: `交易`,
          account: `帐户`,
          amount: `量`,
          bank: `银行`,
          status: `状态`,
          date: `日期`,
        },
      },
    },
    dashboardSpread: {
      thematic: "Thematic 指数",
    },
  },
  vi: {
    nodata: "không có dữ liệu",
    dashboardBonus: {
      bonus_term1:
        "Nạp tiền lần đầu tiên 20$ nhận miễn phí 30$ giao dịch và rút tiền không có bất kỳ điều kiện",
      bonus_term2:
        "Bạn có thể giao dịch và rút tiền ngay lập tức mà không có bất kỳ điều kiện nào",
      ckeck_box_bonus: "Bạn đã đọc và chấp nhận các điều khoản của công ty",
      bonus_warning:
        "**Xin lưu ý rằng nhận tiền thưởng 30$ chỉ có thể được sử dụng một lần, không thể thay đổi",
      bonus_warning_2:
        "**Lưu ý: Yêu cầu tiền thưởng 30$  sẽ sử dụng được khi nạp tiền vào tài khoản STANDARD+ và Standard ",
    },
    tooltip_currency: "Giá trị của đồng tiền chỉ là xấp xỉ với giá hiện tại. ",
    dashboard: {
      footer:
        "Trang web được điều hành bởi IUX Markets Global Group được quản lý từ Singapore có quyền chủ yếu hoạt động kinh doanh mua bán chứng khoán có giấy phép" +
        "Cảnh báo Rủi ro: Xin lưu ý rằng giao dịch CFDs và kinh doanh các sản phẩm tín dụng khác có mức độ rủi ro cao và không phù hợp với tất cả các nhà đầu tư, việc giao dịch công cụ tài chính cũng có thể dẫn đến thua lỗ cũng như với việc thu được lợi nhuận. Và khoản lỗ có thể lớn hơn số tiền đầu tư ban đầu. Trước khi thực hiện các giao dịch như vậy, hãy chắc chắn hiểu tất cả các rủi ro. và những lời khuyên không thiên vị nên được thực hiện nếu cần thiết. Thông tin này không được sử dụng. hoặc được dành để phân phối hoặc sử dụng bởi cư dân của các quốc gia / khu vực pháp lý nhất định. bao gồm nhưng không giới hạn trong: Úc, Bỉ, Pháp, Iran, Nhật Bản, Triều Tiên và Hoa Kỳ. Công ty không cung cấp dịch vụ Đối với cư dân của một số quốc gia / khu vực pháp lý Bao gồm nhưng không giới hạn ở Úc, Bỉ, Pháp, Iran, Nhật Bản, Triều Tiên và Hoa Kỳ, IUX Markets Global Group có quyền thay đổi danh sách các quốc gia trên. theo quyết định của riêng chúng tôi." +
        "©2016 IUX Markets Global Group mọi quyền được bảo lưu",
      copyright: "©2016 IUX Markets Global Group mọi quyền được bảo lưu",
    },
    dashboardTransactionHistory: {
      filter: {
        month: "tháng",
        type: "kiểu",
        status: "trạng thái",
        all: "tất cả",
      },
      headers: {
        type: "kiểu",
        time: "thời gian",
        account: "tài khoản",
        method: "đường",
        localAmount: "Số tiền được chuyển nhượng",
        receive: "Số tiền nhận được",
        status: "trạng thái",
      },
      type: {
        Deposit: "Tiền gửi",
        Withdraw: "Rút",
        Compensation: "Tiền bồi thường",
      },
      status: {
        Accepted: "chấp thuận",
        Pending: "Chờ đợi hành động",
        Rejected: "từ chối ",
      },
      expand: {
        otherDetails: "Thêm chi tiết",
        bankAccountDetail: "Chi tiết tài khoản ngân hàng",
        accountType: "Loại kế toán",
        transactionID: "Giao dịch",
        currencyRate: "Tỷ giá",
        accountNumber: "Số tài khoản",
        accountName: "Tên tài khoản",
        bankName: "tên ngân hàng",
        proofOfTransfer: "Chuyển bằng chứng",
        exportHere: "Xuất tập tin ở đây",
      },
    },
    dashboardWallet: {
      no_archive_account: "	Bạn không có tài khoản lưu trữ.	",
      account_detail: "	Thông tin tài khoản	",
      recommended: "	Khuyến khích	",
      Professional: "	Chuyên nghiệp	",
      fund: "	Quỹ	",
      reactive: "	Hồi đáp nhanh	",
      only_mt5: `Thêm tài khoản giao dịch MT5`,
      your_account: "một lỗi xảy ra",
      error_10:
        'Rất tiếc, bạn không thể mở tài khoản bổ sung. Chúng tôi giới hạn các tài khoản bổ sung tối đa chỉ 6 tài khoản "Vui lòng xóa các tài khoản không hoạt động để thêm tài khoản mới',
      laos_deposit: `Vui lòng chỉ chuyển tiền bằng VND nếu chuyển khoản USD , bạn sẽ bị tính phí tỷ giá tiền gửi từ ngân hàng cao hơn tỷ giá bình thường.`,
      your_mt4: " số tài khoản MT4",
      your_mt5: " số tài khoản MT5",
      input_error: "Vui lòng thêm thông tin",
      rq_account: "Vui lòng chọn tài khoản",
      rq_amount: "Vui lòng nhập số tiền",
      createAccount: "Thêm tài khoản giao dịch",
      server: "Máy chủ",
      account: "Tài khoản",
      accountType: "Loại tài khoản",
      accountBalance: "Số tiền còn lại",
      accountCredit: "Tín dụng",
      accountBonusRemain: "Tín dụng cón lại",
      accountPlatform: "Nền tảng",
      accountNumber: "Số tài khoản giao dịch",
      accountLeverage: "Leverage",
      accountDemoMoney: "Số tiền dùng thử",
      transferNomore:
        "Để chuyển tiền, bạn phải mở hơn 1 tài khoản giao dịch trực tiếp",
      myBonus: "Tiền thưởng của tôi",
      detail: "Chi tiết",
      deposit: "Nạp tiền",
      remainBonus: "Tiền thưởng còn lại có thể được nhận",
      notAccount:
        "Bạn không có tài khoản giao dịch đang hoạt động. Bạn có thể yêu cầu một tài khoản bằng cách nhấp vào biểu tượng ở bên phải.",
      noVerifyUser: "Bạn phải xác minh danh tính trước rút tiền",
      noVerifyBookBank: "",
      bonus: "Tiền thưởng",
      menu: {
        confirm_dialog: {
          title: "Bạn muốn xóa tài khoản",
          content: "Bạn xác nhận xóa tài khoản phải không",
        },
        account_edit: "Thay đổi mật khẩu giao dịch",
        investor_edit: "Thay đổi mã nhà đầu tư",
        account_close: "Đóng tài khoản",
        account_archive: "Lưu trữ tài khoản",
        leverage_edit: "Thay đổi đòn bẩy",
      },
      tooltip: {
        password: "Mật khẩu phải chứa ít nhất1 ký tự (AZ az)",
        title: "Tiền Deposit",
        description:
          "Điều kiện thưởng: Bạn sẽ nhận được số tiền thưởng tỷ lệ thuận với số tiền gửi, với giới hạn tối đa theo quy định",
      },
      modal: {
        title: "Mở tài khoản mới",
        subTitle:
          "Vui lòng chọn các đặc điểm của tài khoản thực của bạn để dễ sử dụng",
        metatrader: "Metatrader 4",
        accountType: "Mở tài khoản mới",
        accountMoney: "Tiền tệ",
        accountPassword: "Mật khẩu giao dịch",
        accountPassword_validate:
          "Độ dài mật khẩu — Tối thiểu 8 ký tự, tối đa 15 ký tự. Mật khẩu phải chứa ít nhất 1 ký tự in hoa và thường, ít nhất 1 chữ số, và ít nhất 1 ký tự đặc biệt.",

        accountConfirmPassword: "Xác nhận mật khẩu giao dịch",
        accountPasswordInvestor: "Đặt mật khẩu nhà đầu tư",
        accountConfirmPasswordInvestor: "ยืนยันรหัสอินเวสเตอร์",
        code: "Điền mã nhận được qua",
        confirm: "Xác nhận",
        cancel: "Hủy bỏ",
        validate: {
          inputFirstName: "",
          inputLastName: "",
          inputPopId: "",
          inputBankAccount: "",
          inputBankAccountName: "",
          inputTel: "",
          inputDate: "",
          inpu: "",
          inputPost: "",
          inputUpload: "",
        },
      },
      error: {
        title: "Không đủ số tiền để rút",
      },
    },
    dashboardInnerTransfer: {
      title: "Chuyển tiền nội bộ",
      tab1: "chuyển tiền",
      tab2: "Lịch sử chuyển tiền",
      warningTitle: "Thông báo quan trọng",
      warningSubTitle1:
        "Khi đặt một đơn đặt hàng giao dịch, hãy lưu ý rằng chuyển khoản nội bộ có thể chuyển tới 90% vốn chủ sở hữu của bạn, không bao gồm tín dụng.",
      warningSubTitle2:
        "Để chuyển nội bộ giữa các tài khoản tiền thưởng vào các tài khoản tham gia tiền thưởng, tiền thưởng được ghi có sẽ chuyển theo tỷ lệ dựa trên tỷ lệ phần trăm số dư được chuyển.",
      warningSubTitle3:
        "Để chuyển nội bộ giữa các tài khoản tiền thưởng vào các tài khoản không tham gia tiền thưởng, tiền thưởng sẽ được khấu trừ từ tài khoản được chuyển.",
      input1: "Từ tài khoản",
      input2: "Đến tài khoản",
      input3: "Số tiền cần chuyển",
      input1Placeholder: "Chọn tài khoản để chuyển",
      input2Placeholder: "chọn tài khoản nhận tiền",
      input3Placeholder: "Số tiền cần chuyển",
      confirm: "Xác nhận",
      confirm_dialog: {
        title: "Xác nhận chuyển khoản của bạn",
      },
      historyTitle: "Lịch sử chuyển tiền",
      accountNumberTransfer: "Số tài khoản chuyển",
      accountNumberIncome: "Số tài khoản nhận",
      amount: "Số tiền chuyển khoản",
      date: "Ngày",
      error: {
        title_PRO: "Chuyển khoản nội bộ sang tài khoản PRO tối thiểu ",
        title_Raw: "Chuyển khoản nội bộ sang tài khoản Raw tối thiểu ",
        title_min: "Internal transfer minimum",
      },
    },
    dashboardProgram: {
      title: "Chương trình giao dịch",
      boxMetatrader4Title: "MetaTrader 4",
      boxMetatrader5Title: "MetaTrader 5",
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle:
        "MetaTrader 4 được nhiều người coi là một nền tảng hình thức giao dịch CFDs phổ biến trên thế giới. Vì có phần liên lạc   người dễ sử dụng biểu đồ, quan trọng nhất là ngôn ngữ MQLcho phép người dùng lập trình các chỉ báo dễ dàng và cũng cóCố vấn chuyên môn (EA hoặc hiến lược giao dịch tự động)",
      boxMetatrader5SubTitle:
        "MetaTrader 5 được nhiều người coi là một nền tảng. Hình thức giao dịch CFDs phổ biến trên thế giới Nó có giao diện người dùng, đồ thị và chỉ số dễ sử dụng. Trong đó quan trọng nhất là ngôn ngữ MQL cho phép người dùng lập trình các chỉ báo dễ dàng và cũng cóCố vấn chuyên môn (EA hoặc Chiến lược giao dịch tự động)",
      boxWebtrader4SubTitle:
        "Bạn có thể sử dụng IUX Markets MT4 WebTrader để giao dịch trực tuyến ngay lập tức trên tài khoản demo và tài khoản giao dịch,  không cần tải xuống bất kỳ chức năng giao dịch nào của IUX Markets WebTrader hoàn toàn tương thích với MetaTrader 4 cho phép bạn mở và đóng giao dịch, điểm đặt dừng và giới hạn nhập, đã đặt lệnh , đã đặt và điều chỉnh điểm giới hạn và 0 dừng lỗm 1 điều chỉnh biểu đồ chỉ với một cú nhấp, Chức năng giao dịch của IUX Markets WebTrader hoàn toàn tương thích với MetaTrader 4 cho bạn mở-đóng giao dịch, đặt điểm stop และจุดเข้าแบบ limit,đặt các mục lệnh dừng, đặt và điều chỉnh limit và stop loss, và điều chỉnh biểu đồ chỉ với một cú nhấp",
      boxWebtrader5SubTitle:
        " Không có bất kỳ tải xuống nào, chức năng giao dịch của IUX Markets WebTrader hoàn toàn tương thích với cho phép bạn mở và đóng giao dịch, đặt các mục dừng và giới hạn, đặt lệnh, đặt và điều chỉnh các điểm giới hạn và cắt lỗ cũng như điều chỉnh biểu đồ. chỉ với một cú nhấp.",
      boxMobileTitle: "Ứng dụng di động MT4",
      boxMobile5Title: "Ứng dụng di động MT5",
      boxMobileSubTitle:
        "Ứng dụng MT4 của IUX dành cho iPhone® có sẵn cho tài khoản giao dịch thực. Nó có thể được tải xuống miễn phí từ Apple App Store.",
      readMore: "Thêm",
    },
    dashboardVerify: {
      title: "Xác minh danh tính",
    },
    dashboardSwapReturn: {
      title: "Tín dụng swap hoàn tiền",
      deposit: "Nạp tiền",
      withdraw: "Rút tiền",
      myCredit: "Tín dụng hôm nay",
      condition: "Điều kiện",
      conditionSeq1:
        "- Tín dụng Swap hoàn tiền từ nhà cung cấp phải phù hợp với thị trường hoặc Broker trực tiếp. ",
      conditionSeq2: "- ạn phải giao dịch liên tục.  ",
      conditionSeq3:
        "- Phải có số nạp tiền tối thiểu 50,000 THB trở lên để bạn nhận được tín dụng Swap hoàn tiền.",
      conditionSeq4: "- Vui lòng đọc và tìm hiểu điều kiện một cách chính xác",
    },
    dashboardFund: {
      deposit: "Nạp tiền",
      withdraw: "Rút tiền",
      warning: {
        title:
          "Lưu ý: Quý khách lưu ý khi có đặt hàng giao dịch. Rút tiền có thể được rút 90% trong số ký quỹ mà không gồm tín dụng.",
        description:
          "Giới thiệu: Nếu bạn muốn rút tiền, trước hết nên đóng tất cả các lệnh đang chờ xử lý",
      },
      history: "Lịch sử",
      modalVerify: {
        bankAccountTypeLabel: "Loại tài khoản ngân hàng",
        bankAccountTypePlaceHolder: "Chọn loại tài khoản ngân hàng",
        typeOfBank: {
          currentaccount: "Tài khoản hiện tại",
          savingsaccount: "Tài khoản tiết kiệm",
          ordinaryaccount: "Tài khoản bình thường",
        },
        bankBranch: "Chi nhánh Ngân hàng ",
        bankBranchPlaceHolder: "Chi nhánh Ngân hàng",
        bankBranchRequired: "Vui lòng nhập chi nhánh Ngân hàng đúng cách",
        alertVerifyBookBank:
          "Bạn phải xác minh tài khoản ngân hàng nên có thể giao dịch rút tiền. Bạn có thể xác minh tài khoản ngân hàng  bằng cách điền  thông tin bên dưới để đầy đủ",
        alertVerifyUser:
          "Bạn phải xác minh danh tính để có thể mở một tài khoản giao dịch. Bạn có thể xác minh danh tính bằng cách điền đầy đủ thông tin bên dưới.",
        titleVerifyUser: "Xác minh danh tính",
        titleVerifyBookBank: "Xác nhận số tài khoản",
        fnameLabel: "Tên",
        fnamePlaceHolder: "Tên (tiếng Việt hoặc tiếng Anh)",
        fnameLabelPlaceHolderJP:
          "Vui lòng nhập tên của bạn bằng ký tự tiếng Anh.",
        lnameLabel: "Hộ",
        lnamePlaceHolder: "Hộ (tiếng Việt hoặc tiếng Anh)",
        lnameLabelPlaceHolderJP:
          "Vui lòng nhập họ của bạn bằng ký tự tiếng Anh.",
        popIdLabel: "Số CMND",
        popIdPlaceHolder: "Số CMND",
        warning:
          "* Vui lòng điền thông tin Ngân hàng mà được sử dụng để nạp/ rút tiền. Để sử dụng trong tài khoản của bạn",
        bankLabel: "Ngân hàng",
        bankPlaceHolder: "Vui lòng chọn ngân hàng",
        accountNumberLabel: "Số tài khoản ngân hàng",
        accountNumberPlaceHolder: "Số tài khoản ngân hàng",

        accountNameLabel: "Tên chủ tài khoản ngân hàng",
        accountNamePlaceholderJP:
          "Vui lòng nhập tên chủ tài khoản ngân hàng bằng ký tự Katakana.",
        email: "E-mail",
        tel: "Số điện thoại",
        birthdayLabel: "Ngày sinh",
        birthdayPlaceHolder: "Điền ngày sinh",
        addressLabel: "Tỉnh",
        addressPlaceHolder: "Tỉnh",
        provinceLabel: "Tỉnh",
        provincePlaceHolder: "Chọn tỉnh",
        stateUnionLabel: "	Lãnh thổ tiểu bang/Liên minh	",
        stateUnionPlaceHolder: "	Chọn Lãnh thổ Nhà nước/Liên minh	",
        stateLabel: "	Tình trạng	",
        statePlaceHolder: "	Chọn trạng thái	",
        municipalityLabel: "	Tỉnh/đô thị	",
        municipalityPlaceHolder: "	Chọn Tỉnh/Thành phố	",
        regionStateLabel: "	Khu vực/tiểu bang	",
        regionStatePlaceHolder: "	Chọn vùng/tiểu bang	",
        regionLabel: "	Vùng đất	",
        regionPlaceHolder: "	Chọn địa bàn	",
        postLabel: "Số bưu điện",
        postPlaceHolder: "Số bưu điện",
        jobLabel: "Nghề nghiệp",
        otherLabel: "Khác (chỉ định)",
        jobPlaceHolder: "Vui lòng chọn nghề nghiệp",
        footerText1:
          "Vui lòng tải lên ảnh chụp Chứng minh nhân dân của bạn bằng cách chỉ đính kèm mặt trước của thẻ.",
        footerText2: "Vui lòng tải lên ảnh tài khoản ngân hàng",
        footerText3:
          "Trước khi tiến hành xác minh Chứng từ Ngân hàng (POB), chúng tôi kính đề nghị bạn kiểm tra kỹ hướng dẫn để đảm bảo quá trình cập nhật diễn ra mạch lạc và thành công.",
        validateFirstName: "Vui lòng điền chính xác tên của bạn",
        validateLastName: "Vui lòng điền chính xác họ của bạn",
        validateIdCard: "Vui lòng điền ",
        validateBank: "Vui lòng điền chính xác tài khoản ngân hàng ",
        validateBankAccount: "Vui lòng điền số chính xác tài khoản ngân hàng ",
        validateBankName: "Vui lòng điền chính xác tên tài khoản ngân hàng ",
        validatePhone: "Vui lòng điền số điện thoại chính xác",
        validateBirth: "ui lòng điền ngày sinh chính xác",
        validateAddress: "Vui lòng điền địa chỉ chính xác ",
        validateProvince: `Vui lòng điền Tỉnh`,
        validat: "Vui lòng điền chính xác tỉnh",
        validatePost: "Vui lòng điền chính xác mã bưu điện ",
        validateCareer: "Vui lòng điền chính xác nghề nghiệp.",
        validateInput: "Xin vui lòng nhập",
        validatePassword: "Vui lòng điền chính xác thông tin ",
      },
      tabHistory: {
        title: "Giao dịch đang chờ xử lý",
        title2: "Hoàn tất giao dịch",
        tableLabel: {
          transaction: "Giao dịch",
          account: "Tài khoản",
          amount: "Số tiền",
          bank: "Ngân hàng",
          status: "Trạng thái",
          date: "Ngày",
        },
      },
    },
    dashboardSpread: {
      thematic: "Chỉ số Thematic",
    },
  },
  ko: {
    nodata: "데이터가 없습니다",
    dashboardBonus: {
      bonus_term1:
        "Make your first deposit 20 $, get free $30, trade and withdraw unconditionally.",
      bonus_term2:
        "You can trade and withdraw immediately without any conditions.",
      ckeck_box_bonus:
        "You have read the details and agree to the terms of the company.",
      bonus_warning:
        "** Please note that the 30 $ bonus can be used only once and cannot be changed.",
      bonus_warning_2:
        "** Note : $30 Bonus for deposit to STANDARD+ and Standard account only",
    },
    tooltip_currency:
      "The value of the currency is only an approximation of the current price.",
    dashboard: {
      footer:
        `이 웹 사이트는 IUX 시장 글로벌 그룹에 의해 운영되고 있습니다. 싱가포르에서 + 주로 라이센스 '와 함께 사업을 거래 증권을 관리 할 수있는 능력을 가지고` +
        `위험 경고 : 무역 외환 및 기타 신용 상품은 높은 위험을 수반한다는하시기 바랍니다 참고. 그리고 금융 상품을 무역 모든 투자자는 손실뿐만 아니라이 발생할 수 있습니다 적합하지 않습니다에 대한. 이익을 수신 그리고 손실은 거래를하기 전에 초기 투자 비용보다 클 수 있습니다으로, 모든 위험을 이해해야합니다. 필요한이 정보를 사용하지 않는 경우 그리고 공정한 조언을 받아야합니다. 또는 분산 또는 특정 국가 / 관할 구역 포함하여에 거주하는 사람들이 사용하지만, 호주, 벨기에, 프랑스,이란, 일본, 북한과 미국에 서비스를 제공하지 않는 회사를 제한하지하기위한 것. 호주, 벨기에, 프랑스,이란, 일본, 북한과 미국, IUX 시장 글로벌 그룹으로 제한 특정 국가 / 관할 구역 포함하여에 거주하는 사람들이 아니라 우리 자신의 재량에 따라 위의 국가 목록을 변경할 수있는 권리가 있습니다.`,
      copyright: `저작권 : '© 2016 IUX 시장 글로벌 그룹. 판권 소유.`,
    },
    dashboardTransactionHistory: {
      filter: {
        month: "월",
        type: "유형",
        status: "상태",
        all: "모두",
      },
      headers: {
        type: "유형",
        time: "시간",
        account: "계정",
        method: "방법",
        localAmount: "양도 된 금액",
        receive: "받은 금액",
        status: "상태",
      },
      type: {
        Deposit: "보증금",
        Withdraw: "철회하다",
        Compensation: "Compensation",
      },
      status: {
        Accepted: "승인하다",
        Pending: "행동을 기다리고 있습니다",
        Rejected: "거절하다",
      },
      expand: {
        otherDetails: "자세한 내용은",
        bankAccountDetail: "은행 계좌 정보",
        accountType: "회계 유형",
        transactionID: "거래",
        currencyRate: "환율",
        accountNumber: "계좌 번호",
        accountName: "계정 이름",
        bankName: "은행 이름",
        proofOfTransfer: "이전 증거",
        exportHere: "여기에서 파일을 내보내십시오",
      },
    },
    dashboardWallet: {
      no_archive_account: "	아카이브 계정이 없습니다.	",
      account_detail: "	계정 세부 사항	",
      recommended: "	추천	",
      Professional: "	전문적인	",
      fund: "	축적	",
      reactive: "	다시 활성화	",
      only_mt5: `Only MT5 trading accounts can be added.`,
      your_account: `Something went wrong`,
      error_10:
        'Sorry for the inconvenience, You cannot open additional accounts. Because the maximum account is limited to 6 accounts only." Please delete some accounts to add new accounts',
      laos_deposit: `Please transfer money in kip currency only, if transfer in USD, you will be deducted from the bank deposit rate higher than normal rate`,
      your_mt4: `귀하의 MT4 계정`,
      your_mt5: `귀하의 MT5 계정`,
      input_error: `여기에 입력하세요`,
      rq_account: "Please choose account",
      rq_amount: "Please enter amount",
      createAccount: `계정 MT4 만들기`,
      server: "섬기는 사람",
      account: `계정`,
      accountType: `유형`,
      accountBalance: `밸런스`,
      accountCredit: `신용`,
      accountBonusRemain: `보너스는 남아`,
      accountPlatform: `플랫폼`,
      accountNumber: `계정 없음.`,
      accountLeverage: `이점`,
      accountDemoMoney: `양`,
      transferNomore:
        "자금을 이체하려면 1 개 이상의 라이브 거래 계좌를 개설해야합니다.",
      myBonus: `내 보너스`,
      detail: `세부 묘사`,
      deposit: `예금`,
      remainBonus: `남은 보너스`,
      notAccount: `당신은 개방 된 무역 계정이 없습니다. 당신은 오른쪽에있는 아이콘을 클릭하여 계정을 요청할 수 있습니다.`,
      noVerifyUser: `당신은 계정을 추가하기 전에 신원 확인을 받아야합니다.`,
      noVerifyBookBank: `당신은 돈을 인출하기 전에 신원 확인이 있어야합니다.`,
      bonus: "보너스",
      menu: {
        confirm_dialog: {
          title: `계좌 번호`,
          content: `이 계정을 삭제 확인합니까?`,
        },
        account_edit: `암호 변경`,
        investor_edit: `암호 변경 투자자`,
        account_close: `계정 삭제`,
        account_archive: `Archive account`,
        leverage_edit: `변경 활용`,
      },
      tooltip: {
        password: `암호 (A-Z의 A-z) 적어도 하나를 포함해야 charactor`,
        title: `보너스 로열티 예금`,
        description: `보너스 조건 : 예금 금액에 비례하는 보너스 금액이 지정된대로 최대 한도입니다.`,
      },
      modal: {
        title: `새로운 계정을 열고`,
        subTitle: `실제 계정의 특성을 선택하십시오. 사용의 용이성을 위해`,
        metatrader: `메타 트레이더 4`,
        accountType: `유형`,
        accountMoney: `통화`,
        accountPassword: `암호`,
        accountPassword_validate:
          "비밀번호 길이 — 최소 8자, 최대 15자. 비밀번호는 최소 1개의 대문자와 소문자, 최소 1개의 숫자, 그리고 최소 1개의 특수 문자를 포함해야 합니다.",

        accountPasswordInvestor: `투자자 비밀번호`,
        accountConfirmPassword: `비밀번호 확인`,
        accountConfirmPasswordInvestor: `확인 투자자 비밀번호`,
        code: " Enter the code from your",
        confirm: `확인`,
        cancel: `취소`,
      },
      error: {
        title: "The amount you wish to withdraw is insufficient.",
      },
    },
    dashboardInnerTransfer: {
      title: `내부 거래`,
      tab1: `이전`,
      tab2: `역사`,
      warningTitle: "중요한 통지",
      warningSubTitle1:
        "거래 명령을 내릴 때는 신용을 제외하고 내부 양도가 주식의 최대 90%를 이전 할 수 있습니다.",
      warningSubTitle2:
        "보너스 계정 간의 내부 양도에 대한 계정에 참여하는 보너스에 대한 보너스는 이체 된 잔액 백분율에 따라 비례 적으로 이체됩니다.",
      warningSubTitle3:
        "보너스 계정간에 보너스를 참여하지 않는 계정으로의 내부 양도의 경우 보너스는 양도 계정에서 공제됩니다.",
      input1: `에서`,
      input2: `에`,
      input3: `양`,
      input1Placeholder: `에 계정을 선택`,
      input2Placeholder: `에서 계정을 선택`,
      input3Placeholder: `양`,
      confirm: `확인`,
      confirm_dialog: {
        title: `확인`,
      },
      historyTitle: `역사`,
      accountNumberTransfer: `계좌로부터`,
      accountNumberIncome: `계정에`,
      amount: `양`,
      date: `양`,
      error: {
        title_PRO: "Internal transfers to PRO accounts for a minimum of ",
        title_Raw: "Internal transfers to Raw accounts for a minimum of ",
        title_min: "Internal transfer minimum ",
      },
    },
    dashboardProgram: {
      title: `데이트`,
      boxMetatrader4Title: `무역 도구`,
      boxMetatrader5Title: `무역 도5`,
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle: `메타 트레이더 4`,
      boxMetatrader5SubTitle: `메타 5레이더 4`,
      boxWebtrader4SubTitle:
        "Without having to download anything at all, you can use the full practicality of IUX Markets  MT4 WebTrader for instant online trading on both demo and trading accounts. The complete trading functionality of IUX Markets  WebTrader is based on its compatibility with MetaTrader4. This allows one-click operations for opening and closing trades, setting stops and entry limits, placing direct orders, setting and editing limit and stop loss, and charting.",
      boxWebtrader5SubTitle:
        "Without having to download anything at all, you can use the full practicality of IUX Markets  MT5 WebTrader for instant online trading on both demo and trading accounts. The complete trading functionality of IUX Markets  WebTrader is based on its compatibility with MetaTrader4. This allows one-click operations for opening and closing trades, setting stops and entry limits, placing direct orders, setting and editing limit and stop loss, and charting.",
      boxMobileTitle: `MT4 메타 트레이더 4는 널리 플랫폼으로 간주됩니다. 세계 \n '의 가장 인기있는 외환 거래 형태로 쉽게 프로그램 지표에 사용자를 허용하고 또한 전문가 자문 (EA 또는 자동을 포함하는 MQL 언어, 가장 중요한입니다 포함 사용하기 쉬운 사용자 인터페이스, 그래프 및 지표를 가지고 있기 때문에 무역 전략)`,
      boxMobile5Title: `MT5 메타 트레이더 4는 널리 플랫폼으로 간주됩니다. 세계 \n '의 가장 인기있는 외환 거래 형태로 쉽게 프로그램 지표에 사용자를 허용하고 또한 전문가 자문 (EA 또는 자동을 포함하는 MQL 언어, 가장 중요한입니다 포함 사용하기 쉬운 사용자 인터페이스, 그래프 및 지표를 가지고 있기 때문에 무역 전략)`,
      boxMobileSubTitle: `모바일 앱`,
      readMore: `더`,
    },
    dashboardVerify: {
      title: `확인`,
    },
    dashboardSwapReturn: {
      title: `스왑 신용 반환`,
      deposit: `예금`,
      withdraw: `빼다`,
      myCredit: `나의 신용`,
      condition: `질환`,
      conditionSeq1: `- 서비스 제공 업체에 의해 환불 할 수 있습니다 교환 학점은 항상 시장 또는 브로커와 직접 접촉해야합니다.`,
      conditionSeq2: `- 당신은 지속적으로 거래를해야합니다. 보통`,
      conditionSeq3: `- 스왑 스왑 크레딧을받을 수있는 5 만 바트 이상의 최소 보증금이 있어야`,
      conditionSeq4: `- 읽고 올바르게 조건을 양해 해 주시기 바랍니다`,
    },
    dashboardFund: {
      deposit: `예금`,
      withdraw: `빼다`,
      history: `역사`,
      warning: {
        title: `참고 : 보류중인 주문을 여는 이벤트에 돈을 철회하는 경우 당신은 당신의 기존 잔액의 70 %를 철회 할 수 있습니다. (포함되지 않은 주문은 포함, 정지, 판매, 정지, 제한, 판매)`,
        description: `추천 : 자금을 철수하면 모든 보류중인 주문을 먼저 닫아야합니다`,
      },
      modalVerify: {
        bankAccountTypeLabel: "은행 계좌 유형",
        bankAccountTypePlaceHolder: "은행 계좌 유형 선택",
        typeOfBank: {
          currentaccount: "당좌 계정",
          savingsaccount: "예금 계좌",
          ordinaryaccount: "일반계좌",
        },
        bankBranch: "은행 지점 ",
        bankBranchPlaceHolder: "은행 지점",
        bankBranchRequired: "은행 지점을 올바르게 입력하세요",
        alertVerifyBookBank: `당신은 당신의 은행 계좌를 확인해야합니다. 위해서하는 것은 아래의 완전한 정보를 작성하여 은행 계좌를 확인할 수 있습니다 프로세스 인출 할 수 있도록`,
        alertVerifyUser: `당신은 거래를 받아 들일 수 있도록하기 위해 사용자의 신원을 확인해야합니다. 당신은 아래의 정보를 작성하여 사용자의 신원을 확인할 수 있습니다`,
        titleVerifyUser: `사용자 확인`,
        titleVerifyBookBank: `예약 은행 확인`,
        fnameLabel: `이름`,
        fnamePlaceHolder: `이름`,
        fnameLabelPlaceHolderJP: "이름은 영문으로 입력해주세요.",
        lnameLabel: `성`,
        lnamePlaceHolder: `성`,
        lnameLabelPlaceHolderJP: "성을 영문으로 입력해주세요.",
        popIdLabel: `ID 카드 번호`,
        popIdPlaceHolder: `ID 카드 번호`,
        warning: `* 증착에 사용되는 은행 정보를 입력하십시오 - 철수를. 계정에서 사용하기 위해`,
        bankLabel: `은행`,
        bankPlaceHolder: `은행을 선택`,
        accountNumberLabel: `은행 계좌`,
        accountNumberPlaceHolder: `은행 계좌`,

        accountNameLabel: `은행 이름`,
        accountNamePlaceholderJP: `가타카나 문자를 사용하여 은행 계좌 소유자의 이름을 입력하십시오.`,
        email: `이메일`,
        tel: `전화`,
        birthdayLabel: `생년월일`,
        birthdayPlaceHolder: `생년월일`,
        addressLabel: `주소`,
        addressPlaceHolder: `주소`,
        provinceLabel: `주`,
        provincePlaceHolder: `지방을 선택하십시오`,
        stateUnionLabel: "	주/연합 영토	",
        stateUnionPlaceHolder: "	주/연합 영토를 선택하십시오	",
        stateLabel: "	상태	",
        statePlaceHolder: "	상태를 선택하십시오	",
        municipalityLabel: "	지방/지방 자치 단체	",
        municipalityPlaceHolder: "	지방/지방 자치 단체를 선택하십시오	",
        regionStateLabel: "	지역/상태	",
        regionStatePlaceHolder: "	지역/상태를 선택하십시오	",
        regionLabel: "	지역	",
        regionPlaceHolder: "	지역을 선택하십시오	",
        postLabel: `게시하다`,
        postPlaceHolder: `게시하다`,
        jobLabel: `직업`,
        otherLabel: `기타 (구체적으로)`,
        jobPlaceHolder: `경력 선택`,
        footerText1: `신분증 사진을 업로드하여 카드 앞면만 부착하고.`,
        condition: `* (xxx.png, xxx.jpg, xxx.jpeg)`,
        footerText2: `제발 업로드 은행 계좌 이미지`,
        footerText3: `은행 증명서 (POB) 확인을 진행하기 전에, 원활하고 성공적인 업데이트를 위해 지침을 주의 깊게 검토하시기 바랍니다.`,
        validateFirstName: `제발 입력 우선 name.Correctly`,
        validateLastName: `입력 해주세요 마지막 name.Correctly`,
        validateIdCard: `입력 해주세요 인구 `,
        validateBank: `입력 해주세요 은행 name.Correctly`,
        validateBankAccount: `입력 해주세요 은행 Account.Correctly`,
        validateBankName: `입력 해주세요 은행 Name.Correctly`,
        validatePhone: `제발 입력 전화 Number.Correctly`,
        validateBirth: `제발 입력 출생 Date.Correctly`,
        validateAddress: `제발 입력 Address.Correctly`,
        validateProvince: `제발 입력 Province.Correctly`,
        validat: `제발 입력 Province.Correctly`,
        validatePost: `제발 입력 후 Number.Correctly`,
        validateCareer: `제발 입력 Career.Correctly`,
        validateInput: "입력하십시오",
        validatePassword: `제발 입력 필드, 올바르게`,
      },
      tabHistory: {
        title: `거래 출원`,
        title2: `전체 거래`,
        tableLabel: {
          transaction: `트랜잭션`,
          account: `계정`,
          amount: `양`,
          bank: `은행`,
          status: `상태`,
          date: `데이트`,
        },
      },
    },
    dashboardSpread: {
      thematic: "Thematic Indices",
    },
  },
  fil: {
    nodata: "Walang data",
    dashboardBonus: {
      bonus_term1:
        "Make your first deposit 20 $, get free $30, trade and withdraw unconditionally.",
      bonus_term2:
        "You can trade and withdraw immediately without any conditions.",
      ckeck_box_bonus:
        "You have read the details and agree to the terms of the company.",
      bonus_warning:
        "** Please note that the 30 $ bonus can be used only once and cannot be changed.",
      bonus_warning_2:
        "** Note : $30 Bonus for deposit to STANDARD+ and Standard account only",
    },
    tooltip_currency:
      "Ang halaga ng pera ay isang pagtatantya lamang ng kasalukuyang presyo. ",
    dashboard: {
      footer:
        `Ang website na ito ay pinapatakbo ng IUX Markets Global Group. Mula sa Singapore Nagtataglay ng kapangyarihang higit sa lahat pamahalaan ang mga mahalagang papel kalakalan negosyo Sa pamamagitan ng isang lisensiya` +
        `Panganib Babala: Mangyaring tandaan na ang CFDs Trading at iba pang mga produkto ng credit ay nagsasangkot ng mataas na panganib. At hindi angkop para sa lahat ng mga namumuhunan Trading sa pananalapi instrumento ay maaaring magresulta sa pagkawala pati na rin. Sa pagtanggap ng mga kita At ang pagkawala ay maaaring maging mas malaki kaysa sa paunang puhunan Bago gumawa ng tulad ng isang transaksyon, siguraduhin na maunawaan ang lahat ng mga panganib. At dapat makatanggap ng walang pinapanigan payo kung kinakailangan Ang impormasyon na ito ay hindi na ginagamit. O inilaan upang ipamahagi o gamitin ng mga taong naninirahan sa ilang mga bansa / mga saklaw kabilang ang ngunit hindi limitado sa Australia, Belgium, France, Iran, Japan, North Korea at ang Estados Unidos ng kumpanya ay hindi nagbibigay ng mga serbisyo. Sa mga tao na namamalagi sa ilang mga bansa / mga saklaw kabilang ang ngunit hindi limitado sa Australia, Belgium, France, Iran, Japan, North Korea at Estados Unidos, IUX Markets Global Group ay may karapatan na baguhin ang listahan ng mga bansa sa itaas Sa aming sariling paghuhusga.`,
      copyright: `copyright: '© 2016 IUX Markets Global Group. Lahat ng karapatan ay nakareserba.`,
    },
    dashboardTransactionHistory: {
      filter: {
        month: "Buwan",
        type: "i -type",
        status: "katayuan",
        all: "lahat",
      },
      headers: {
        type: "i -type",
        time: "oras",
        account: "account",
        method: "paraan",
        localAmount: "Ang halaga ng pera na inilipat",
        receive: "Ang halagang natanggap",
        status: "katayuan",
      },
      type: {
        Deposit: "Deposito",
        Withdraw: "Umatras",
        Compensation: "kabayaran",
      },
      status: {
        Accepted: "aprubahan",
        Pending: "Naghihintay para sa pagkilos",
        Rejected: "tumanggi",
      },
      expand: {
        otherDetails: "Higit pang mga detalye",
        bankAccountDetail: "mga detalye ng bank account",
        accountType: "Uri ng Accounting",
        transactionID: "Transaksyon",
        currencyRate: "Palitan ng rate",
        accountNumber: "Numero ng account",
        accountName: "Pangalan ng Account",
        bankName: "Pangalan ng bangko",
        proofOfTransfer: "Ilipat ang katibayan",
        exportHere: "I -export ang mga file dito",
      },
    },
    dashboardWallet: {
      no_archive_account: "	Wala kang isang archive account.	",
      account_detail: "	Detalye ng Account	",
      recommended: "	Inirerekumenda	",
      Professional: "	Propesyonal	",
      fund: "	Pondo	",
      reactive: "	Aktibo	",
      only_mt5: `Only MT5 trading accounts can be added.`,
      your_account: `Something went wrong`,
      error_10:
        'Sorry for the inconvenience, You cannot open additional accounts. Because the maximum account is limited to 6 accounts only." Please delete some accounts to add new accounts',
      laos_deposit: `Please transfer money in kip currency only, if transfer in USD, you will be deducted from the bank deposit rate higher than normal rate`,
      your_mt4: `Ang iyong MT4 Account`,
      your_mt5: `Ang iyong MT5 Account`,
      input_error: `Mangyaring input dito`,
      rq_account: "Please choose account",
      rq_amount: "Please enter amount",
      createAccount: `Gumawa ng Account MT5`,
      server: "Server",
      account: `account`,
      accountType: `uri`,
      accountBalance: `Balanse`,
      accountCredit: `kredito`,
      accountBonusRemain: `bonus mananatiling`,
      accountPlatform: `Platform`,
      accountNumber: `Account No.`,
      accountLeverage: `pagkilos`,
      accountDemoMoney: `dami`,
      transferNomore:
        "Upang maglipat ng mga pondo, kailangan mong magbukas ng higit sa 1 live na account sa pangangalakal",
      myBonus: `Aking Bonus`,
      detail: `detalye`,
      deposit: `deposito`,
      remainBonus: `natitirang bonus`,
      notAccount: `Wala kang anumang mga account`,
      noVerifyUser: `Dapat kang makatanggap ng pagpapatunay ng pagkikilanlan bago ang pagdaragdag ng isang account.`,
      noVerifyBookBank: `Dapat ay mayroon kang pag-verify pagkakakilanlan bago ma-withdraw ang pera.`,
      bonus: "bonus",
      menu: {
        confirm_dialog: {
          title: `account number`,
          content: `Huwag mong kumpirmahin na tanggalin ang account na ito?`,
        },
        account_edit: `Baguhin Password`,
        investor_edit: `Baguhin Investor Password`,
        account_close: `Delete Account`,
        account_archive: `Archive Account`,
        leverage_edit: `Baguhin ang Leverage`,
      },
      tooltip: {
        password: `password ay dapat maglaman ng (A-Z a-z) ng hindi bababa sa 1 charactor`,
        title: `Bonus Deposit`,
        description: `Kondisyon ng Bonus: Makakatanggap ka ng isang halaga ng bonus na proporsyonal sa na -deposito, na may isang maximum na limitasyon tulad ng tinukoy`,
      },
      modal: {
        title: `Buksan ang isang bagong account`,
        subTitle: `Mangyaring piliin ang mga katangian ng iyong aktwal na account. Para sa kadalian ng paggamit`,
        metatrader: `Metatrader 4`,
        accountType: `uri`,
        accountMoney: `pera`,
        accountPassword: `password`,
        accountPassword_validate:
          "Haba ng password — Hindi bababa sa 8 karakter, hindi lalampas sa 15 karakter. Ang password ay dapat maglaman ng hindi bababa sa 1 na uppercase at lowercase na karakter, hindi bababa sa 1 na digit, at hindi bababa sa 1 na espesyal na karakter.",

        accountPasswordInvestor: `Investor Password`,
        accountConfirmPassword: `Kumpirmahin ang Password`,
        accountConfirmPasswordInvestor: `Kumpirmahin Investor Password`,
        code: " Enter the code from your",
        confirm: `Kumpirmahin`,
        cancel: `kanselahin`,
      },
      error: {
        title: "The amount you wish to withdraw is insufficient.",
      },
    },
    dashboardInnerTransfer: {
      title: `Internal transfer`,
      tab1: `paglilipat`,
      tab2: `kasaysayan`,
      warningTitle: "Mahalagang paunawa",
      warningSubTitle1:
        "Kapag naglalagay ng isang order ng kalakalan, magkaroon ng kamalayan na ang mga panloob na paglilipat ay maaaring maglipat ng hanggang sa 90% ng iyong equity, hindi kasama ang kredito.",
      warningSubTitle2:
        "Para sa mga panloob na paglilipat sa pagitan ng mga account ng bonus sa mga account na nakikilahok ng mga bonus, ang kredito na bonus ay lilipat nang proporsyonal batay sa inilipat na porsyento ng balanse.",
      warningSubTitle3:
        "Para sa mga panloob na paglilipat sa pagitan ng mga account sa bonus sa mga account na hindi nakikilahok ng mga bonus, ang bonus ay ibabawas mula sa inilipat na account.",
      input1: `mula sa`,
      input2: `sa`,
      input3: `dami`,
      input1Placeholder: `Pumili ng account upang`,
      input2Placeholder: `Pumili ng account mula sa`,
      input3Placeholder: `dami`,
      confirm: `Kumpirmahin`,
      confirm_dialog: {
        title: `pagpapatibay`,
      },
      historyTitle: `kasaysayan`,
      accountNumberTransfer: `Galing sa account`,
      accountNumberIncome: `upang account`,
      amount: `dami`,
      date: `petsa`,
      error: {
        title_PRO: "Internal transfers to PRO accounts for a minimum of ",
        title_Raw: "Internal transfers to Raw accounts for a minimum of ",
        title_min: "Internal transfer minimum ",
      },
    },
    dashboardProgram: {
      title: `Platform`,
      boxMetatrader4Title: `MetaTrader 4`,
      boxMetatrader5Title: `MetaTrader 5`,
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle: `MetaTrader 4 ay malawak na itinuturing bilang platform. Ang mundo \n 's pinaka-popular na anyo ng CFDs kalakalan Dahil ito ay isang madaling-gamitin na user interface, mga graph at mga tagapagpahiwatig Kabilang sa mga pinakamahalagang ay ang MQL wika, na nagpapahintulot sa mga user upang madaling tagapagpabatid programa at kabilang din Expert Advisors (EA o Automated Trading Istratehiya)`,
      boxMetatrader5SubTitle: `MetaTrader 5 ay malawak na itinuturing bilang platform. Ang mundo \n 's pinaka-popular na anyo ng CFDs kalakalan Dahil ito ay isang madaling-gamitin na user interface, mga graph at mga tagapagpahiwatig Kabilang sa mga pinakamahalagang ay ang MQL wika, na nagpapahintulot sa mga user upang madaling tagapagpabatid programa at kabilang din Expert Advisors (EA o Automated Trading Istratehiya)`,
      boxWebtrader4SubTitle:
        "Without having to download anything at all, you can use the full practicality of IUX Markets  MT4 WebTrader for instant online trading on both demo and trading accounts. The complete trading functionality of IUX Markets  WebTrader is based on its compatibility with MetaTrader4. This allows one-click operations for opening and closing trades, setting stops and entry limits, placing direct orders, setting and editing limit and stop loss, and charting.",
      boxWebtrader5SubTitle:
        "Without having to download anything at all, you can use the full practicality of IUX Markets  MT5 WebTrader for instant online trading on both demo and trading accounts. The complete trading functionality of IUX Markets  WebTrader is based on its compatibility with MetaTrader4. This allows one-click operations for opening and closing trades, setting stops and entry limits, placing direct orders, setting and editing limit and stop loss, and charting.",
      boxMobileTitle: `MT4 mobile App`,
      boxMobile5Title: `MT5 mobile App`,
      boxMobileSubTitle: `Ang IUX MT4 app para sa iPhone ® ay handa na para sa isang live na kalakalan account. Sa pamamagitan ng pag-download nito magbakante mula sa Apple App Store`,
      readMore: `pa`,
    },
    dashboardVerify: {
      title: `mapatunayan`,
    },
    dashboardSwapReturn: {
      title: `Swap Credit Return`,
      deposit: `deposito`,
      withdraw: `bawiin`,
      myCredit: `Aking Credit`,
      condition: `kalagayan`,
      conditionSeq1: `- Pagpalitin ang mga kredito na maaaring ma-refund sa pamamagitan ng mga service provider ay dapat palaging magiging sa direct contact sa merkado o broker.`,
      conditionSeq2: `- Dapat ay mayroon kang patuloy na kalakalan. karaniwan`,
      conditionSeq3: `- Kailangan ay mayroong isang minimum na deposito ng 50,000 baht o higit pa upang makatanggap ng isang Swap Swap credit`,
      conditionSeq4: `- Mangyari lamang na basahin at intindihin ang mga kondisyon ng tama`,
    },
    dashboardFund: {
      deposit: `deposito`,
      withdraw: `bawiin`,
      history: `kasaysayan`,
      warning: {
        title: `Tandaan: Kung ma-withdraw ang pera sa kaganapan ng pagbubukas nakabinbing mga order Makaka upang bawiin lamang ang 90% ng iyong mga umiiral na Balanse. (Mga order na hindi kasama, isama, stop, sell, stop, limit, sell)`,
        description: `Magrekomenda: Kung ma-withdraw ang mga pondo, ang lahat ng mga nakabinbing mga order ay dapat na unang sarado`,
      },
      modalVerify: {
        bankAccountTypeLabel: "Uri ng bank account",
        bankAccountTypePlaceHolder: "Pumili ng uri ng bank account",
        typeOfBank: {
          currentaccount: "Kasalukuyang account",
          savingsaccount: "Savings account",
          ordinaryaccount: "Normal na account",
        },
        bankBranch: "Sangay ng Bangko ",
        bankBranchPlaceHolder: "Sangay ng Bangko",
        bankBranchRequired: "Mangyaring Ilagay ng Tama ang Sangay ng Bangko",
        alertVerifyBookBank: `Mayroon kang upang kumpirmahin ang iyong account sa bangko. Upang ma-proseso withdrawals Maaari mong kumpirmahin ang iyong account sa bangko sa pamamagitan ng pagpuno sa mga kumpletong impormasyon sa ibaba`,
        alertVerifyUser: `Kailangan mong kumpirmahin ang iyong pagkakakilanlan upang magagawang tanggapin trades. Maaari mong i-verify ang iyong pagkakakilanlan sa pamamagitan ng pagpuno ang impormasyon sa ibaba`,
        titleVerifyUser: `I-verify ang User`,
        titleVerifyBookBank: `I-verify Book Bank`,
        fnameLabel: `Pangalan`,
        fnamePlaceHolder: `Pangalan`,
        fnameLabelPlaceHolderJP:
          "Pakilagay ang iyong pangalan gamit ang mga English na character.",
        lnameLabel: `Huling pangalan`,
        lnamePlaceHolder: `Huling pangalan`,
        lnameLabelPlaceHolderJP:
          "Pakilagay ang iyong apelyido gamit ang mga English na character.",
        popIdLabel: `numero ng ID card`,
        popIdPlaceHolder: `numero ng ID card`,
        warning: `* Mangyaring ipasok ang impormasyon ng iyong bank ginagamit para sa pagdedeposito - withdraw. Para sa paggamit sa iyong account`,
        bankLabel: `bangko`,
        bankPlaceHolder: `piliin ang Bank`,
        accountNumberLabel: `Numero ng account sa bangko`,
        accountNumberPlaceHolder: `Numero ng account sa bangko`,

        accountNameLabel: `May-ari ng bank account`,
        accountNamePlaceholderJP: `Pakilagay ang pangalan ng may-ari ng bank account gamit ang mga character na Katakana.`,
        email: `email`,
        tel: `Phone Number`,
        birthdayLabel: `Araw ng kapanganakan`,
        birthdayPlaceHolder: `Araw ng kapanganakan`,
        addressLabel: `address`,
        addressPlaceHolder: `address`,
        provinceLabel: `Lalawigan`,
        provincePlaceHolder: `Piliin ang Lalawigan`,
        stateUnionLabel: "	Teritoryo ng Estado/Union	",
        stateUnionPlaceHolder: "	Piliin ang Teritoryo ng Estado/Union	",
        stateLabel: "	Estado	",
        statePlaceHolder: "	Piliin ang Estado	",
        municipalityLabel: "	Lalawigan/Munisipalidad	",
        municipalityPlaceHolder: "	Piliin ang Lalawigan/Munisipalidad	",
        regionStateLabel: "	Rehiyon/Estado	",
        regionStatePlaceHolder: "	Piliin ang Rehiyon/Estado	",
        regionLabel: "	Rehiyon	",
        regionPlaceHolder: "	Piliin ang Rehiyon	",
        postLabel: `koreo`,
        postPlaceHolder: `koreo`,
        jobLabel: `karera`,
        otherLabel: `Iba pa (tukuyin)`,
        jobPlaceHolder: `Pumili ng karera`,
        footerText1: `Mag-upload ng larawan ng iyong ID Card at ilakip lamang ang harap ng card.`,
        condition: `* (Xxx.png, xxx.jpg, xxx.jpeg)`,
        footerText2: `Mangyaring mag-upload ng bank imahe ng account`,
        footerText3: `Bago magpatuloy sa pagsusuri ng Proof of Bank (POB) verification, kami ay may kagalang-galang na hinihiling sa iyo na suriin nang mabuti ang mga tagubilin upang matiyak ang isang magaan at matagumpay na pag-update.`,
        validateFirstName: `Mangyaring Input First name.Correctly`,
        validateLastName: `Mangyaring Input Huling name.Correctly`,
        validateIdCard: `Mangyaring Input`,
        validateBank: `Mangyaring Input Bank name.Correctly`,
        validateBankAccount: `Mangyaring Input Bank Account.Correctly`,
        validateBankName: `Mangyaring Input Bank Name.Correctly`,
        validatePhone: `Mangyaring Input Telepono Number.Correctly`,
        validateBirth: `Mangyaring Input Birth Date.Correctly`,
        validateAddress: `Mangyaring Input Address.Correctly`,
        validateProvince: `Mangyaring Input Province.Correctly`,
        validat: `Mangyaring Input Province.Correctly`,
        validatePost: `Mangyaring Input ZIP / Post Code Number.Correctly`,
        validateCareer: `Mangyaring Input Career.Correctly`,
        validateInput: "Mangyaring mag -input",
        validatePassword: `Mangyaring Input Field, Tamang`,
      },
      tabHistory: {
        title: `transaksyon pending`,
        title2: `Kumpletuhin ang transaksyon`,
        tableLabel: {
          transaction: `transaksiyon`,
          account: `account`,
          amount: `dami`,
          bank: `bangko`,
          status: `katayuan`,
          date: `petsa`,
        },
      },
    },
    dashboardSpread: {
      thematic: "Thematic Indices",
    },
  },
  ja: {
    nodata: "データなし",
    dashboardBonus: {
      bonus_term1:
        "最初のデポジットを20ドルにし、30ドルを無料で入手し、取引して無条件に撤回します。",
      bonus_term2: "条件なしですぐに取引して撤回することができます。",
      ckeck_box_bonus: "あなたは詳細を読み、会社の条件に同意しました。",
      bonus_warning:
        "** 30ドルののボーナス一度だけでき変更、変更できないに注意",
      bonus_warning_2:
        "**注：標準+および標準アカウントのみへのデポジットの30ドルのボーナス",
    },
    tooltip_currency: "通貨の値は、現在の価格の近似にすぎません。",
    dashboard: {
      footer:
        "このウェブサイトは、IUX Markets Global Groupが運営しています。 シンガポールから、主に有価証券取引事業をライセンスで管理する権限があります" +
        "リスク警告：CFDやその他のクレジット製品の取引には高いリスクが含まれることに注意してください。 また、金融商品を取引するすべての投資家にも適していない場合も、損失をもたらす可能性があります。 利益を受け取ると、そのような取引を行う前に、損失が初期投資よりも大きい場合は、すべてのリスクを必ず理解してください。 必要に応じて、この情報が使用されない場合は、公平なアドバイスを受ける必要があります。 または、オーストラリア、ベルギー、フランス、イラン、日本、北朝鮮、米国など、特定の国 /管轄区域に居住する人々によって配布または使用されることを目的としています。 オーストラリア、ベルギー、フランス、イラン、日本、北朝鮮、米国を含むがこれらに限定されない特定の国 /管轄区域に居住する人々に、IUX Markets Global Groupは、当社の裁量で上記の国のリストを変更する権利を持っています。",
      copyright: "©2016 IUX Markets Global Group。 無断転載を禁じます。",
    },
    dashboardTransactionHistory: {
      filter: {
        month: "月",
        type: "タイプ",
        status: "状態",
        all: "全て",
      },
      headers: {
        type: "タイプ",
        time: "時間",
        account: "アカウント",
        method: "方法",
        localAmount: "譲渡された金額",
        receive: "受け取った金額",
        status: "状態",
      },
      type: {
        Deposit: "デポジット",
        Withdraw: "撤回する",
        Compensation: "補償",
      },
      status: {
        Accepted: "承認する",
        Pending: "アクションを待っています",
        Rejected: "拒否する",
      },
      expand: {
        otherDetails: "詳細",
        bankAccountDetail: "銀行口座の詳細",
        accountType: "会計タイプ",
        transactionID: "取引",
        currencyRate: "為替レート",
        accountNumber: "口座番号",
        accountName: "アカウント名",
        bankName: "銀行名",
        proofOfTransfer: "証拠を転送します",
        exportHere: "ここにファイルをエクスポートします",
      },
    },
    dashboardWallet: {
      no_archive_account: "アーカイブアカウントはありません。",
      account_detail: "アカウントの詳細",
      recommended: "推奨",
      Professional: "プロ",
      fund: "基金",
      reactive: "反応性",
      only_mt5: "MT5トレーディングアカウントのみを追加できます。",
      your_account: "何かがうまくいかなかった",
      error_10:
        "ご不便をおかけして申し訳ありませんが、追加のアカウントを開くことはできません。 最大アカウントは6つのアカウントのみに制限されているためです。一部のアカウントを削除して新しいアカウントを追加してください",
      laos_deposit:
        "KIP通貨のみで送金してください。USDで移転すると、通常の料金よりも高い銀行預金料金から差し引かれます",
      your_mt4: "MT4アカウント",
      your_mt5: "MT5アカウント",
      input_error: "値を入力してください",
      rq_account: "アカウントを選択してください",
      rq_amount: "金額を入力してください",
      createAccount: "取引口座を作成します",
      server: "サーバ",
      account: "私のアカウント",
      accountType: "タイプ",
      accountBalance: "バランス",
      accountCredit: "クレジット",
      accountBonusRemain: "ボーナスは残ります",
      accountPlatform: "プラットホーム",
      accountNumber: "アカウントなし。",
      accountLeverage: "てこの作用",
      accountDemoMoney: "額",
      transferNomore:
        "資金を譲渡するには、複数のライブトレーディングアカウントを開設する必要があります",
      myBonus: "私のボーナス",
      detail: "詳細",
      deposit: "デポジット",
      remainBonus: "残りのボーナス",
      notAccount: "アカウントはありません",
      noVerifyUser:
        "アカウントを追加する前に、身元確認を受信する必要があります。",
      noVerifyBookBank: "お金を撤回する前に身元確認が必要です。",
      bonus: "ボーナス",
      menu: {
        confirm_dialog: {
          title: "口座番号",
          content: "このアカウントを削除することを確認しますか？",
        },
        account_edit: "パスワードを変更する",
        investor_edit: "パスワード投資家を作成します",
        account_close: "アカウントを削除する",
        account_archive: "アーカイブアカウント",
        leverage_edit: "レバレッジを変更します",
      },
      tooltip: {
        password:
          "パスワードには（a-z a-z）少なくとも1文字を含める必要があります",
        title: "ボーナスデポジット",
        description:
          "ボーナス条件：指定された最大制限で、堆積額に比例するボーナス額を受け取ります",
      },
      modal: {
        title: "新しいアカウントを開きます",
        subTitle: "実際のアカウントの特性を選択してください。 使いやすさ",
        metatrader: "Metatrader 4",
        accountType: "タイプ",
        accountMoney: "通貨",
        accountPassword: "パスワードの取引",
        accountPassword_validate:
          "パスワードの長さ — 最小8文字、最大15文字。パスワードには少なくとも1つの大文字と小文字、少なくとも1つの数字、そして少なくとも1つの特殊文字が含まれている必要があります。",
        accountPasswordInvestor: "投資家のパスワード",
        accountConfirmPassword: "取引パスワードを確認します",
        accountConfirmPasswordInvestor: "投資家のパスワードを確認します",
        code: "あなたからコードを入力します",
        confirm: "確認する",
        cancel: "キャンセル",
      },
      error: {
        title: "撤回したい金額は不十分です。",
      },
    },
    dashboardInnerTransfer: {
      title: "内部転送",
      tab1: "移行",
      tab2: "歴史",
      warningTitle: "重要なお知らせ",
      warningSubTitle1:
        "取引命令を出すときは、内部転送がクレジットを除いて、あなたの株式の最大70％を株式の70％を転送できることに注意してください。",
      warningSubTitle2:
        "ボーナスアカウント間の参加ボーナスへの内部転送の場合、クレジットボーナスは、転送された残高の割合に基づいて比例して転送されます。",
      warningSubTitle3:
        "ボーナスアカウント間のボーナスに参加しないアカウント間の内部転送の場合、ボーナスは転送されたアカウントから差し引かれます。",
      input1: "から",
      input2: "に",
      input3: "額",
      input1Placeholder: "アカウントを選択します",
      input2Placeholder: "アカウントを選択します",
      input3Placeholder: "額",
      confirm: "確認する",
      confirm_dialog: {
        title: "確認転送！",
      },
      historyTitle: "歴史",
      accountNumberTransfer: "アカウントから",
      accountNumberIncome: "アカウントへ",
      amount: "額",
      date: "日付",
      error: {
        title_PRO: "Proアカウントへの内部転送は最小限です",
        title_Raw: "最小限のRAWアカウントへの内部転送",
        title_min: "内部転送最小",
      },
    },
    dashboardProgram: {
      title: "プラットホーム",
      boxMetatrader4Title: "Metatrader 4",
      boxMetatrader5Title: "Metatrader 5",
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle:
        "Metatrader 4は、プラットフォームと広く見なされています。 最も重要なユーザーインターフェイス、グラフ、インジケーターが最も重要なものを含むインジケータがMQL言語であるため、世界で最も人気のあるCFDSトレーディングフォームは、ユーザーが簡単にプログラムすることができ、エキスパートアドバイザー（EAまたは自動取引戦略）を含むことができます。 。",
      boxMetatrader5SubTitle:
        "Metatrader 5は、プラットフォームと広く見なされています。 最も重要なユーザーインターフェイス、グラフ、インジケーターが最も重要なものを含むインジケータがMQL言語であるため、世界で最も人気のあるCFDSトレーディングフォームは、ユーザーが簡単にプログラムすることができ、エキスパートアドバイザー（EAまたは自動取引戦略）を含むことができます。 。",
      boxWebtrader4SubTitle:
        "何もダウンロードすることなく、DEMOアカウントと取引アカウントの両方でインスタントオンライン取引にIUX Markets MT4 WebTraderの完全な実用性を使用できます。 IUX Markets WebTraderの完全な取引機能は、Metatrader4との互換性に基づいています。 これにより、トレードを開設および閉鎖するためのワンクリック操作、停止とエントリの制限、直接注文の配置、制限の設定と編集の損失、および停止の損失の設定、チャートが可能になります。",
      boxWebtrader5SubTitle:
        "何もダウンロードすることなく、DEMOアカウントと取引アカウントの両方でインスタントオンライン取引にIUX Markets MT5 WebTraderの完全な実用性を使用できます。 IUX Markets WebTraderの完全な取引機能は、Metatrader4との互換性に基づいています。 これにより、トレードを開設および閉鎖するためのワンクリック操作、停止とエントリの制限、直接注文の配置、制限の設定と編集の損失、および停止の損失の設定、チャートが可能になります。",
      boxMobileTitle: "MT4モバイルアプリ",
      boxMobile5Title: "MT5モバイルアプリ",
      boxMobileSubTitle:
        "iPhone®のIUX MT4アプリは、ライブトレーディングアカウントの準備ができています。 Apple App Storeから無料でダウンロードします",
      readMore: "もっと",
    },
    dashboardVerify: {
      title: "確認する",
    },
    dashboardSwapReturn: {
      title: "クレジットリターンを交換します",
      deposit: "デポジット",
      withdraw: "撤回する",
      myCredit: "私の信用",
      condition: "状態",
      conditionSeq1:
        " - サービスプロバイダーが返金できるクレジットを交換することは、常に市場またはブローカーと直接連絡する必要があります。",
      conditionSeq2: " - 継続的な取引が必要です。 いつもの",
      conditionSeq3:
        " - スワップスワップクレジットを受け取るには、50,000バーツ以上の最低預金が必要です",
      conditionSeq4: " - 条件を正しく読んで理解してください",
    },
    dashboardFund: {
      deposit: "デポジット",
      withdraw: "撤回する",
      history: "歴史",
      warning: {
        title:
          "取引注文をしながら注意してください。 引き出しは、信用を得ることなく、マージンの70％を引き出すことができます。",
        description:
          "推奨：資金を撤回する場合、保留中のすべての注文は最初に閉鎖する必要があります。",
      },
      modalVerify: {
        bankAccountTypeLabel: "銀行口座の種類",
        bankAccountTypePlaceHolder: "銀行口座の種類を選択してください",
        typeOfBank: {
          currentaccount: "当座預金口座",
          savingsaccount: "貯蓄預金口座",
          ordinaryaccount: "普通預金口座",
        },
        bankBranch: "銀行の店番",
        bankBranchPlaceHolder: "銀行の店番",
        bankBranchRequired: "正確に銀行の店番を入力してください",
        alertVerifyBookBank:
          "銀行口座を確認する必要があります。 引き出しを処理できるようにするには、以下の完全な情報を記入して、銀行口座を確認できます。",
        alertVerifyUser:
          "取引を受け入れることができるようにするには、自分の身元を確認する必要があります。 以下の情報を入力して、身元を確認できます。",
        titleVerifyUser: "ユーザーを確認します",
        titleVerifyBookBank: "ブックバンクを確認します",
        fnameLabel: "ファーストネーム",
        fnamePlaceHolder: "ファーストネーム",
        fnameLabelPlaceHolderJP: "名前をローマ字で入力してください。",
        lnameLabel: "苗字",
        lnamePlaceHolder: "苗字",
        lnameLabelPlaceHolderJP: "姓をローマ字で入力してください。",
        popIdLabel: "IDカード番号",
        popIdPlaceHolder: "IDカード番号",
        warning:
          "*堆積に使用される銀行情報を入力してください - 撤回。 アカウントで使用するため",
        bankLabel: "銀行",
        bankPlaceHolder: "銀行を選択します",
        accountNumberLabel: "銀行の口座番号",
        accountNumberPlaceHolder: "銀行の口座番号",
        accountNameLabel: "銀行口座名義人名",
        accountNamePlaceholderJP:
          "銀行口座名義人名をカタカナで入力してください",
        email: "Eメール",
        tel: "電話番号",
        birthdayLabel: "生年月日",
        birthdayPlaceHolder: "生年月日",
        addressLabel: "住所",
        addressPlaceHolder: "住所",
        provinceLabel: "州",
        provincePlaceHolder: "州を選択します",
        stateUnionLabel: "州/組合の領土",
        stateUnionPlaceHolder: "州/ユニオンの領土を選択します",
        stateLabel: "州",
        statePlaceHolder: "状態を選択します",
        municipalityLabel: "州/自治体",
        municipalityPlaceHolder: "州/自治体を選択します",
        regionStateLabel: "地域/州",
        regionStatePlaceHolder: "領域/状態を選択します",
        regionLabel: "地域",
        regionPlaceHolder: "領域を選択します",
        postLabel: "郵便番号",
        postPlaceHolder: "郵便番号",
        jobLabel: "キャリア",
        otherLabel: "その他（指定）",
        jobPlaceHolder: "キャリアを選択します",
        footerText1:
          "カードの前面のみを添付して、IDカードの写真をアップロードしてください。",
        condition: "*（xxx.png、xxx.jpg、xxx.jpeg）",
        footerText2: "銀行口座の画像をアップロードしてください",
        footerText3:
          "銀行証明（POB）の検証を進める前に、スムーズで成功する更新を確実にするために、指示を注意深く確認してください。",
        validateFirstName: "直名を入力してください",
        validateLastName: "姓を正解的に入力してください",
        validateIdCard: "入力してください",
        validateBank: "銀行名を正しく入力してください",
        validateBankAccount: "銀行account.correctlyを入力してください",
        validateBankName: "銀行名を正しく入力してください",
        validatePhone: "電話番号を入力してください",
        validateBirth: "出生日を正しく入力してください",
        validateAddress: "address.correctlyを入力してください",
        validateProvince: "unvince.cerectlyを入力してください",
        validat: "入力してください",
        validatePost: "zip /郵便番号番号を入力してください",
        validateCareer: "Career.carey.carectlyを入力してください",
        validateInput: "入力してください",
        validatePassword: "フィールドを正しく入力してください",
      },
      tabHistory: {
        title: "保留中のトランザクション",
        title2: "完全なトランザクション",
        tableLabel: {
          transaction: "取引",
          account: "アカウント",
          amount: "額",
          bank: "銀行",
          status: "状態",
          date: "日付",
        },
      },
    },
    dashboardSpread: {
      thematic: "Thematic Indices",
    },
  },
  es: {
    nodata: "Sin datos",
    dashboardBonus: {
      bonus_term1:
        "Haz tu primer depósito de 20 $, recibe $30 gratis, comercia y retira sin condiciones.",
      bonus_term2:
        "Puedes comerciar y retirar de inmediato sin ninguna condición.",
      ckeck_box_bonus:
        "Has leído los detalles y aceptas los términos de la compañía.",
      bonus_warning:
        "** Tenga en cuenta que el bono de $30 solo se puede usar una vez y no se puede cambiar.",
      bonus_warning_2:
        "** Nota: Bono de $30 para depósito en cuenta STANDARD+ y Standard únicamente",
    },
    tooltip_currency:
      "El valor de la moneda es solo una aproximación del precio actual.",
    dashboard: {
      footer:
        "Este sitio web es operado por IUX Markets Global Group. Desde Singapur, tiene el poder de gestionar principalmente el negocio de comercio de valores con una licencia." +
        " Advertencia de riesgo: Tenga en cuenta que el comercio de CFDs y otros productos crediticios implica altos riesgos. Y no es adecuado para todos los inversores. El comercio de instrumentos financieros puede resultar en pérdidas así como en ganancias. Y las pérdidas pueden ser mayores que la inversión inicial. Antes de realizar dicha transacción, asegúrese de comprender todos los riesgos. Y debe recibir asesoramiento imparcial si es necesario. Esta información no se utiliza ni está destinada a ser distribuida o utilizada por personas que residan en ciertos países/jurisdicciones, incluidos pero no limitados a Australia, Bélgica, Francia, Irán, Japón, Corea del Norte y Estados Unidos. La compañía no presta servicios a personas que residan en ciertos países/jurisdicciones, incluidos pero no limitados a Australia, Bélgica, Francia, Irán, Japón, Corea del Norte y Estados Unidos. IUX Markets Global Group tiene derecho a cambiar la lista de países anteriores a su propia discreción.",
      copyright:
        "© 2016 IUX Markets Global Group. Todos los derechos reservados.",
    },
    dashboardTransactionHistory: {
      filter: {
        month: "Mes",
        type: "Tipo",
        status: "Estado",
        all: "Todos",
      },
      headers: {
        type: "Tipo",
        time: "Hora",
        account: "Cuenta",
        method: "Método",
        localAmount: "Monto local",
        receive: "Recibir",
        status: "Estado",
      },
      type: {
        Deposit: "Depósito",
        Withdraw: "Retiro",
        Compensation: "compensación",
      },
      status: {
        Accepted: "Aceptado",
        Pending: "Pendiente",
        Rejected: "Rechazado",
      },
      expand: {
        otherDetails: "Otros detalles",
        bankAccountDetail: "Detalle de la cuenta bancaria",
        accountType: "Tipo de cuenta",
        transactionID: "ID de transacción",
        currencyRate: "Tasa de cambio",
        accountNumber: "Número de cuenta",
        accountName: "Nombre de la cuenta",
        bankName: "Nombre del banco",
        proofOfTransfer: "Prueba de transferencia",
        exportHere: "Exportar aquí",
      },
    },
    dashboardWallet: {
      no_archive_account: "No tienes una cuenta archivada.",
      account_detail: "Detalle de la cuenta",
      recommended: "Recomendado",
      Professional: "Profesional",
      fund: "Fondo",
      reactive: "Reactivar",
      only_mt5: "Solo se pueden agregar cuentas comerciales MT5.",
      your_account: "Algo salió mal",
      error_10:
        "Lo siento por la inconveniencia, no puedes abrir cuentas adicionales. Porque el máximo de cuentas está limitado a 6 cuentas solamente. Por favor, elimina algunas cuentas para agregar nuevas cuentas",
      laos_deposit:
        "Por favor, transfiere dinero solo en moneda kip, si transfieres en USD, serás deducido de la tasa de depósito del banco más alta que la tasa normal",
      your_mt4: "Tu cuenta MT4",
      your_mt5: "Tu cuenta MT5",
      input_error: "Por favor, ingresa el valor",
      rq_account: "Por favor, elige la cuenta",
      rq_amount: "Por favor, ingresa el monto",
      createAccount: "Crear cuenta comercial",
      server: "Servidor",
      account: "Mi cuenta",
      accountType: "Tipo",
      accountBalance: "Balance",
      accountCredit: "Crédito",
      accountBonusRemain: "Bono restante",
      accountPlatform: "Plataforma",
      accountNumber: "Número de cuenta",
      accountLeverage: "Apalancamiento",
      accountDemoMoney: "Monto",
      transferNomore:
        "Para transferir fondos, debes abrir más de 1 cuenta comercial activa",
      myBonus: "Mi bono",
      detail: "Detalle",
      deposit: "Depósito",
      remainBonus: "Bono restante",
      notAccount: "No tienes ninguna cuenta",
      noVerifyUser:
        "Debes recibir la verificación de identidad antes de agregar una cuenta.",
      noVerifyBookBank:
        "Debes tener verificación de identidad antes de retirar dinero.",
      bonus: "Bono",
      menu: {
        confirm_dialog: {
          title: "Número de cuenta",
          content: "¿Confirmas eliminar esta cuenta?",
        },
        account_edit: "Cambiar contraseña",
        investor_edit: "Crear contraseña de inversor",
        account_close: "Eliminar cuenta",
        account_archive: "Archivar cuenta",
        leverage_edit: "Cambiar apalancamiento",
      },
      tooltip: {
        password: "la contraseña debe contener (A-Z a-z) al menos 1 carácter",
        title: "Bono de depósito",
        description:
          "Condición del bono: recibirás una cantidad de bono que es proporcional a la suma depositada, con un límite máximo según lo especificado",
      },
      modal: {
        title: "Abrir una nueva cuenta",
        subTitle:
          "Por favor, elige las características de tu cuenta real. Para facilidad de uso",
        metatrader: "Metatrader 4",
        accountType: "Tipo",
        accountMoney: "Moneda",
        accountPassword: "Contraseña de comercio",
        accountPassword_validate:
          "Longitud de la contraseña — Mínimo 8 caracteres, máximo 15 caracteres. La contraseña debe contener al menos 1 carácter en mayúsculas y minúsculas, al menos 1 dígito y al menos 1 carácter especial.",
        accountPasswordInvestor: "Contraseña de inversor",
        accountConfirmPassword: "Confirmar contraseña de comercio",
        accountConfirmPasswordInvestor: "Confirmar contraseña de inversor",
        code: " Introduce el código de tu",
        confirm: "Confirmar",
        cancel: "Cancelar",
      },
      error: {
        title: "El monto que deseas retirar es insuficiente.",
      },
    },
    dashboardInnerTransfer: {
      title: "Transferencia interna",
      tab1: "Transferencia",
      tab2: "Historial",
      warningTitle: "Aviso importante",
      warningSubTitle1:
        "Al realizar una orden de comercio, ten en cuenta que las transferencias internas pueden transferir hasta el 90% de tu capital, excluyendo el crédito.",
      warningSubTitle2:
        "Para transferencias internas entre cuentas de bono a cuentas que participan en bonos, el bono acreditado se transferirá proporcionalmente según el porcentaje del balance transferido.",
      warningSubTitle3:
        "Para transferencias internas entre cuentas de bono a cuentas que no participan en bonos, el bono se deducirá de la cuenta transferida.",
      input1: "De",
      input2: "A",
      input3: "Monto",
      input1Placeholder: "Selecciona cuenta",
      input2Placeholder: "Selecciona cuenta",
      input3Placeholder: "Monto",
      confirm: "Confirmar",
      confirm_dialog: {
        title: "¡Confirmación de transferencia!",
      },
      historyTitle: "Historial",
      accountNumberTransfer: "De la cuenta",
      accountNumberIncome: "A la cuenta",
      amount: "Monto",
      date: "Fecha",
      error: {
        title_PRO: "Transferencias internas a cuentas PRO por un mínimo de ",
        title_Raw: "Transferencias internas a cuentas Raw por un mínimo de ",
        title_min: "Transferencia interna mínima",
      },
    },
    dashboardProgram: {
      title: "Plataforma",
      boxMetatrader4Title: "MetaTrader 4",
      boxMetatrader5Title: "MetaTrader 5",
      boxwebtrader4Title: "WebTrader 4",
      boxwebtrader5Title: "WebTrader 5",
      boxMetatrader4SubTitle:
        "MetaTrader 4 es ampliamente considerada como una plataforma. La forma de comercio de CFDs más popular del mundo porque tiene una interfaz de usuario fácil de usar, gráficos e indicadores. Lo más importante es el lenguaje MQL, que permite a los usuarios programar fácilmente indicadores e incluir Asesores Expertos (EA o Estrategias de Comercio Automatizado).",
      boxMetatrader5SubTitle:
        "MetaTrader 5 es ampliamente considerada como una plataforma. La forma de comercio de CFDs más popular del mundo porque tiene una interfaz de usuario fácil de usar, gráficos e indicadores. Lo más importante es el lenguaje MQL, que permite a los usuarios programar fácilmente indicadores e incluir Asesores Expertos (EA o Estrategias de Comercio Automatizado).",
      boxWebtrader4SubTitle:
        "Sin necesidad de descargar nada, puedes usar la completa funcionalidad práctica de IUX Markets MT4 WebTrader para comercio instantáneo en línea tanto en cuentas demo como en cuentas comerciales. La completa funcionalidad de comercio de IUX Markets WebTrader se basa en su compatibilidad con MetaTrader4. Esto permite operaciones de un clic para abrir y cerrar operaciones, establecer stops y límites de entrada, colocar órdenes directas, establecer y editar límites y stop loss, y gráficos.",
      boxWebtrader5SubTitle:
        "Sin necesidad de descargar nada, puedes usar la completa funcionalidad práctica de IUX Markets MT5 WebTrader para comercio instantáneo en línea tanto en cuentas demo como en cuentas comerciales. La completa funcionalidad de comercio de IUX Markets WebTrader se basa en su compatibilidad con MetaTrader4. Esto permite operaciones de un clic para abrir y cerrar operaciones, establecer stops y límites de entrada, colocar órdenes directas, establecer y editar límites y stop loss, y gráficos.",
      boxMobileTitle: "Aplicación móvil MT4",
      boxMobile5Title: "Aplicación móvil MT5",
      boxMobileSubTitle:
        "La aplicación IUX MT4 para iPhone® está lista para una cuenta comercial activa. Descargándola gratis desde la App Store de Apple",
      readMore: "Más",
    },
    dashboardVerify: {
      title: "Verificar",
    },
    dashboardSwapReturn: {
      title: "Devolución de crédito Swap",
      deposit: "Depósito",
      withdraw: "Retiro",
      myCredit: "Mi crédito",
      condition: "Condición",
      conditionSeq1:
        "- Los créditos de Swap que pueden ser reembolsados por proveedores de servicios deben estar siempre en contacto directo con el mercado o el corredor.",
      conditionSeq2: "- Debes tener comercio continuo. usualmente",
      conditionSeq3:
        "- Debes tener un depósito mínimo de 50,000 baht o más para recibir un crédito Swap",
      conditionSeq4:
        "- Por favor, lee y comprende correctamente las condiciones",
    },
    dashboardFund: {
      deposit: "Depósito",
      withdraw: "Retiro",
      history: "Historial",
      warning: {
        title:
          " Por favor, ten en cuenta al realizar una orden de comercio. Las retiradas pueden retirar el 90% del margen sin incluir el crédito.",
        description:
          "Recomendación: Si retiras fondos, todas las órdenes pendientes deben ser cerradas primero.",
      },
      modalVerify: {
        bankAccountTypeLabel: "Tipo de cuenta bancaria",
        bankAccountTypePlaceHolder: "Elige tipo de cuenta bancaria",
        typeOfBank: {
          currentaccount: "Cuenta corriente",
          savingsaccount: "Cuenta de ahorros",
          ordinaryaccount: "Cuenta ordinaria",
        },
        bankBranch: "Sucursal bancaria ",
        bankBranchPlaceHolder: "Sucursal bancaria",
        bankBranchRequired:
          "Por favor, ingresa la sucursal bancaria correctamente",
        alertVerifyBookBank:
          "Debes confirmar tu cuenta bancaria. Para poder procesar retiros. Puedes confirmar tu cuenta bancaria llenando la información completa a continuación.",
        alertVerifyUser:
          "Debes confirmar tu identidad para poder aceptar operaciones. Puedes verificar tu identidad llenando la información a continuación.",
        titleVerifyUser: "Verificar usuario",
        titleVerifyBookBank: "Verificar cuenta bancaria",
        fnameLabel: "Nombre",
        fnamePlaceHolder: "Nombre",
        fnameLabelPlaceHolderJP:
          "Por favor, ingresa tu nombre utilizando caracteres en inglés.",
        lnameLabel: "Apellido",
        lnamePlaceHolder: "Apellido",
        lnameLabelPlaceHolderJP:
          "Por favor, ingresa tu apellido utilizando caracteres en inglés.",
        popIdLabel: "Número de tarjeta de identificación",
        popIdPlaceHolder: "Número de tarjeta de identificación",
        warning:
          "* Por favor, ingresa la información bancaria utilizada para depositar - retirar. Para usar en tu cuenta",
        bankLabel: "Banco",
        bankPlaceHolder: "Elige banco",
        accountNumberLabel: "Número de cuenta bancaria",
        accountNumberPlaceHolder: "Número de cuenta bancaria",
        accountNameLabel: "Titular de la cuenta bancaria",
        accountNamePlaceholderJP:
          "Por favor, ingresa el nombre del titular de la cuenta bancaria utilizando caracteres Katakana.",
        email: "Correo electrónico",
        tel: "Número de teléfono",
        birthdayLabel: "Fecha de nacimiento",
        birthdayPlaceHolder: "Fecha de nacimiento",
        addressLabel: "Dirección",
        addressPlaceHolder: "Dirección",
        provinceLabel: "Provincia",
        provincePlaceHolder: "Seleccionar provincia",
        stateUnionLabel: "Estado/Territorio de la Unión",
        stateUnionPlaceHolder: "Seleccionar Estado/Territorio de la Unión",
        stateLabel: "Estado",
        statePlaceHolder: "Seleccionar Estado",
        municipalityLabel: "Provincia/Municipio",
        municipalityPlaceHolder: "Seleccionar Provincia/Municipio",
        regionStateLabel: "Región/Estado",
        regionStatePlaceHolder: "Seleccionar Región/Estado",
        regionLabel: "Región",
        regionPlaceHolder: "Seleccionar Región",
        postLabel: "Código postal",
        postPlaceHolder: "Código postal",
        jobLabel: "Carrera",
        otherLabel: "Otro (especificar)",
        jobPlaceHolder: "Seleccionar carrera",
        footerText1:
          "Por favor, sube una foto de tu tarjeta de identificación adjuntando solo la parte frontal de la tarjeta.",
        condition: "* (xxx.png, xxx.jpg, xxx.jpeg)",
        footerText2: "Por favor, sube imágenes de la cuenta bancaria",
        footerText3:
          " Antes de proceder con la verificación del Comprobante de Banco (POB), solicitamos amablemente que revises minuciosamente las instrucciones para garantizar una actualización sin problemas y exitosa.",
        validateFirstName: "Por favor, ingresa el nombre correctamente.",
        validateLastName: "Por favor, ingresa el apellido correctamente.",
        validateIdCard: "Por favor, ingresa",
        validateBank: "Por favor, ingresa el nombre del banco correctamente.",
        validateBankAccount:
          "Por favor, ingresa la cuenta bancaria correctamente.",
        validateBankName:
          "Por favor, ingresa el nombre del banco correctamente.",
        validatePhone:
          "Por favor, ingresa el número de teléfono correctamente.",
        validateBirth:
          "Por favor, ingresa la fecha de nacimiento correctamente.",
        validateAddress: "Por favor, ingresa la dirección correctamente.",
        validateProvince: "Por favor, ingresa la provincia correctamente.",
        validat: "Por favor, ingresa correctamente.",
        validatePost: "Por favor, ingresa el código postal correctamente.",
        validateCareer: "Por favor, ingresa la carrera correctamente.",
        validateInput: "Por favor, ingresa",
        validatePassword: "Por favor, ingresa el campo correctamente.",
      },
      tabHistory: {
        title: "Transacción pendiente",
        title2: "Transacción completada",
        tableLabel: {
          transaction: "Transacción",
          account: "Cuenta",
          amount: "Monto",
          bank: "Banco",
          status: "Estado",
          date: "Fecha",
        },
      },
    },
    dashboardSpread: {
      thematic: "Índices Thematic",
    },
  },
};
